import { ContentState, clearEditorContent, emptyContentState, convertFromRaw, convertToRaw, EditorState, Editor } from "draft-js";
import PropTypes from "prop-types";
import React, { useEffect, useRef } from "react";
//import { ENTITY_TYPE } from 'draft-js-utils';
//import { EditorState, Modifier } from 'draft-js';
import "react-confirm-alert/src/react-confirm-alert.css";
import MathJax from "../component/react-mathjax-preview";
import { Card, CardContent, IconButton, Tooltip, Typography } from '@mui/material';
import { FormControlLabel, Radio, RadioGroup } from '@mui/material'
import {
  Button,
  Cell,
  Grid,
  SelectField,
  SelectionControlGroup,
  TextField,
  Tooltipped,
  ExpansionList,
  ExpansionPanel,
  Checkbox,
  Chip
} from "react-md";
import { FaMinus } from "react-icons/fa6";
import { HiOutlineZoomIn, HiOutlineZoomOut } from "react-icons/hi";
import { NotificationManager } from "react-notifications";
import "react-notifications/lib/notifications.css";
import Toggle from "react-toggle";
import shortid from "shortid";
import Answer from "../component/Answer";
import ApiRequestService from "../component/ApiRequestService";
import ImageResizeWarning from "../component/ImageResizeWarning";
import Loader from "../component/Loader";
import LoadingSpinner from "../component/LoadingSpinner";
import MQTDisplayOption1 from "../component/mqt/MQTDisplayOption1.js";
import MQTDisplayOption2 from "../component/mqt/MQTDisplayOption2.js";
import RPPreview from "../component/randomized-parameters/RPTextBoxPreview";
import VariablesTable, {
  createEmptyDisplayOption,
  QuestionHelp,
  StandardQuestionHelp,
  TextAnswerFormula,
} from "../component/randomized-parameters/VariablesTable";
import { GetNewComponentGuid } from '../component/randomized-parameters/CommonHelpers';
import SelectBox from "../component/SelectBox";
import TextEditor from "../component/TextEditor";
import "../css/createQuestions.css"; ///bug-tracker#156
import "../css/custom.css";
import "../css/index.css";
import "../css/mediaCss.css";
import styles from "../css/styles.css.js";
import HelpText from "../lib/help-text";
import MathParserUtil from "../lib/math-parser";
import { VariableTypes } from "../lib/types.js";
import "../css/VectorStyles.scss";
import editIcon from '../images/png/edit.png';
import crossIcon from '../images/png/crossIcon.png';

//Vectors
import VectorVariablesTable, {
  createEmptyVectorAnswerFormula,
  VectorQuestionHelp
} from "../component/vectors/VariablesTable";
import VectorCanvasSettings from "../component/vectors/grid-settings";
import VectorParserUtil from "../lib/vector-math-parser";
import Canvas from "../component/vectors/canvas";
//import VectorAnswerFormula from "../component/vectors/VectorAnswerFormula";
import VectorAnswers from "../component/vectors/VectorAnswers";
import DrawVectorAnswers from "../component/vectors/DrawVectorAnswer";
import VectorFreeFormAnswerLivePreview from "../component/vectors/VectorFreeFormAnswerLivePreview";
import LivePreview from "../component/LivePreview";
import { AppSetting,AppProperties } from '../common/function';
import ReactTooltip from 'react-tooltip';
import DataTable from "react-data-table-component";
import { VectorVariable } from "../lib/vector-math-parser";


const customStyles = {
  headCells: {
    style: {
      fontSize: '14px', 
      fontWeight: 'bold',
    },
  }, 
};

//let RichTextEditor = null;
const testString = String.raw`When $a \ne 0$, there are two solutions to \(ax^2 + bx + c = 0\) and they are
$$x = {-b \pm \sqrt{b^2-4ac} \over 2a}.$$`;
//let answerIndex = 0;

const cloneMQTQuestionObject = (src, html) => {
  return {
    id:src.id,
    displayOrder: src.displayOrder,
    value:html?TextEditor.getHTMLStringFromEditorState( src.value):src.value
  }
}

//Generates new Key index, based on the last question's key index
const generateNewKeyIndex = (displayOrder) => {
  try {
    if(displayOrder === 0) {
      return 1;
    } else {
      return parseInt(displayOrder) + 1;
    }
  } catch(e) {
    return 1;
  }
};

const createMQTObjectFromString = (src, index) => {

  return {
    id: src.id,
    displayOrder: src.displayOrder != undefined  && src.displayOrder != null && src.displayOrder != 0 ? src.displayOrder : index,
    value:TextEditor.createValueFromString(src.value)
  }
}

const objectsToArray = (objectArray) => {
  return objectArray.sort((a, b) => {
      if(a.displayOrder !== undefined && a.displayOrder !== null 
          && b.displayOrder !== undefined && b.displayOrder !== null) {
              return parseInt(a.displayOrder) - parseInt(b.displayOrder)
      } else {
          return -1;
      }
  });
}

//Creates MQT Answer Choice array for correct answer dropdown.

const getMQTCorrectAnswerArray = (options) => {
  const { mqt_answer_count, mqt_answer_header, mqt_answers } = options;
  if (mqt_answer_header) {
    if (mqt_answers) {
      const mqt_answer_keys = Object.keys(mqt_answers);
      return mqt_answer_keys.map((value, i) => {
        return { label: i + 1, value: value.toString() };
      });
    }
  } else {
    let answerArray = [];
    for (let index = 0; index < mqt_answer_count; index++) {
      answerArray.push({ label: index + 1, value: (index + 1).toString() });
    }
    return answerArray;
  }

  return [];
};

const getMQTMasteryConditionCount = (options) => {
  const { mqt_questions } = options;
  if (mqt_questions) {
    const mqt_questions_keys = Object.keys(mqt_questions);
    return mqt_questions_keys.map((value, i) => {
      return { label: i + 1, vallue: i + 1 };
    });
  }

  return [];
};

const getAnswerDisplayOption = (answerType, questionType, answerJson, index) => {
  if (!answerJson) {
    answerJson = answerArrListJsonFunction(index);
  }
  if ((questionType === 1 || [50, 60].includes(answerType)) || (questionType === 0 || [70, 80,90].includes(answerType)) ) {
    if (!answerJson.answer_display_options) {
      answerJson.answer_display_options = createEmptyDisplayOption();
    }
    return answerJson.answer_display_options;
  }

  return undefined;
};

const getVectorAnswerFormula = (questionType, answerJson, index) => {
  if (!answerJson) {
    answerJson = answerArrListJsonFunction(index);
  }
  if (questionType === 3 || (questionType === 0)) {
    if (!answerJson.vectorAnswerFormula) {
      answerJson.vectorAnswerFormula = createEmptyVectorAnswerFormula(index);
    }
    return answerJson.vectorAnswerFormula;
  }
  
  return answerJson.vectorAnswerFormula;
};

const answerArrListJsonFunction = (index) => {
  const answerArrListJson = {
    answer_type: 0,
    answer_text: "",
    feedback_text: "",
    question_id: 0,
    color:'',
    is_answer: 0,
    answer_id: 0,
    alt_answer_text: "",
    enable_alt_ans_text: 0,
    alt_feedback_text: "",
    answer_display_options: createEmptyDisplayOption(),
    vectorAnswerFormula: createEmptyVectorAnswerFormula(index),
    vectorAnswerVariable:[]
  };

  return answerArrListJson;
};

const answerArrListJson = {
  answer_type: 0,
  answer_text: "",
  feedback_text: "",
  question_id: 0,
  color:'',
  is_answer: 0,
  answer_id: 0,
  alt_answer_text: "",
  enable_alt_ans_text: 0,
  alt_feedback_text: "",
  answer_display_options: createEmptyDisplayOption(),
  vectorAnswerFormula: createEmptyVectorAnswerFormula(0),
  vectorAnswerVariable:[]
};

//Question Type Drop Down Array
const questionTypes = [
  { value: 0, label: "Standard" },
  { value: 1, label: "Randomized Parameters" },
  { value: 2, label: "Multiple Question Grid" },
  { value: 3, label: "Vector Arrow-Rand. Par" },
  { value: 4, label: "Reasoning Chain" },
];

const questionOwnership = [
  { value: 0, label: "Owned by ES" },
  {
    value: 1,
    label: "From outside source, Attribution needed, can share (commercially)",
  },
  { value: 2, label: "From outside source, Cannot be shared or distributed" },
];

const VectorSettingsData =  {
  height: 240,
  width: 240,
  stepSize: 24,
  enableGrid: true,
  enableBorder: true,
  enableIdenticalVector: false,
  enableDarkGridLine: true,
  enableRuler: false,
  heightUnit: "10",
  widthUnit: "10",
  imageWidthUnit: 10,
  imageHeightUnit: 10,
  imageX: 0,
  imageY: 0,
  gridColor:'dark',
  rulerXPoint: "5",
  rulerYPoint: "5",
  rulerXLabel: "x",
  rulerYLabel: "y",
  altImageText:''
}
export default class CreateQuestions extends React.Component {
  helpTextModel = new HelpText();
  AppSetting = AppSetting()
  appProperties = AppProperties();

  static propTypes = {
    onChange: PropTypes.func,
  };

  constructor(props) {
    super(props);

    this.reasoningElementTextEditorRef = React.createRef();
    this.conclusionTextEditorRef = React.createRef();
    this.questionCardRef = React.createRef();
    this.state = {
      questionText: "",
      altQuestionText: "",
      pageLoading: true,
      ///bug-tracker#156
      questionCanvasComponentGuid: GetNewComponentGuid(),
      answerCanvasComponentGuid: GetNewComponentGuid(),
      freeFormCanvasComponentGuid: GetNewComponentGuid(),
      showSubCategorySelectBox: true,
      showTopicsSelectBox: true,
      showCategorySelectBox: true,
      style: this.props.style,
      styleans1: this.props.style,
      math: testString,
      answerIndex: 0,
      isQuestionWithPreview: false,
      answerArrList: [
        answerArrListJsonFunction(0),
        answerArrListJsonFunction(1),
        answerArrListJsonFunction(2),
        answerArrListJsonFunction(3),
      ],
      selectBoxTopicValue: "",
      selectBoxCategoryValue: "",
      selectBoxSubCategoryValue: "",
      addOneMoreAnswer: "",
      answerList: [],
      subjects: [],
      topics: [],
      categories: [],
      subCategories: [],
      subjectId: this.props.selectedSubjectId,
      topicId: this.props.selectedTopicId,
      categoryId: this.props.selectedCategoryId,
      subcategoryId: this.props.selectedSubCategoryId,
      copyModeQID: 0,
      isCaseSensitive: false,
      caseSensitiveChange: false,
      shouldAnswerAllorAnyChange: false,
      /*
      subjectId: 0,
      topicId: 0,
      categoryId: 0,
      subcategoryId: 0,*/
      questionName: "",
      loading: true,
      multipleChoice: 0,
      randomizeOrder: 0,
      questions: [],
      questionNameDefaultVaule: "",
      subjectDefaultId: 0,
      topicDefaultId: 0,
      categoryDefaultId: 0,
      subCategoryDefaultId: 0,
      defaultQuestionText: "",
      defaultQuestionTextBelowOrAbove: 0,
      defaultRandamizeOrder: 1, //Enable Randomize Order by Default
      defaultSwitchAnswer: false,
      defaultAnswerType: 0,
      forCheckBoxQuestion: 1,
      saveButtonShow: true,
      loadingSave: false,
      answerDisplayStyle: 1,
      questionNonGraded: 0,
      enableAnalytics: false,
      enableFeedback: false,
      // enableAltText:false,
      feedbackVisibility: false,
      altQueTextVisible: false,
      imgTagCount: 0,
      questionType: 0,
      
      reasoningElements: [], // arr of {element: code: category: altText:}
      reasoningElementEditorState: EditorState.createEmpty(),
      showReasoningElementCategoryInfo: true,
      reasoningElementCategoryText: "",
      selectedReasoningElementIndex: -1,
      altReasoningElementText: "",
      altReasoningElementVisible: false,
      altReasoningElementImgTagCount: 0,
      altConclusionSentenceText: "",
      altConclusionSentenceVisible: false,
      altConclusionSentenceImgTagCount: 0,

      connectingWords: [],
      conclusionEditorState: EditorState.createEmpty(),
      connectingWordText: "",
      selectedConclusionIndex: -1,

      conclusionSentences: [],
      isConclusionSentenceRequired: false,
      conclusionWordText: "",

      selectedConclusionWordIndex: -1,
      variablesMap: undefined,
      shouldAnswerAllorAny: "1",
      questionImageWidth: 500,
      localValue:"",
      localValueArr:"",
      answerDisplayOptions: { type: "RANGE" },
      answer_formula: {},
      mqt_questions: {},
      mqt_answers: {},
      mqt_question_answer_map: {},
      mqt_hide_question: false,
      mqt_answer_header: false,
      mqt_answer_count: 1,
      mqt_question_random_order: false,
      mqt_answers_random_order:false,
      generateRandomOrigin: true,
      mqt_mastery_condition: 0,
      mqt_answer_type: "radio",
      questionOrder: 0,
      questionOwnership: 0,
      showOwnershipAttribute: false,
      ownershipAttributeObj: "",
      rpBlackList: "",
      instSubjectsId: JSON.parse(
        window.localStorage.getItem(
          `${this.AppSetting.REACT_APP_UNIVERSITY_SUFFIX}_userAccessDetails`
        )
      ),
      instAllSubjects: [],
      vectorState:[],
      vectorVariablesMap: undefined,
      vectorAnswerVariablesMap: undefined,
      vectorAnswerVariable: [],
      vectorSettingsData: {...VectorSettingsData},
      vectorAnswerFormula:{},
      vectorAnswerFormulas:[],
      showComponents: true,
      showMagnitudeAngle: true,
      showVectorPrompt: false,
    };
    this.answerListVarMap = [];
    if (this.props.copyMode === 1) {
      this.state.copyMode = 1;
    }
    if (this.props.moveMode === 1) {
      this.state.moveMode = 1;
    }

    this.onQuestionTextChange = this.onQuestionTextChange.bind(this);
    this.onAltQuestionTextChange = this.onAltQuestionTextChange.bind(this);
    this.AddAnswerHandler = this.AddAnswerHandler.bind(this);
    this.onAnswerTextChange = this.onAnswerTextChange.bind(this);
    this.stringToValueRPAnswer = this.stringToValueRPAnswer.bind(this);
    this.onAltAnswerTextChange = this.onAltAnswerTextChange.bind(this);
    this.onAltFeedbackTextChange = this.onAltFeedbackTextChange.bind(this);
    this.previewQuestion = this.previewQuestion.bind(this);
    this.previewExit = this.previewExit.bind(this);
    this.generateRandomisedAnswer = this.generateRandomisedAnswer.bind(this);
    this.answerRefreshCallback = this.answerRefreshCallback.bind(this);
    this.selectBoxSubjectHandleChange = this.selectBoxSubjectHandleChange.bind(
      this
    );
    this.selectBoxTopicHandleChange = this.selectBoxTopicHandleChange.bind(
      this
    );
    this.selectBoxCategoryHandleChange = this.selectBoxCategoryHandleChange.bind(
      this
    );
    this.selectBoxSubcategoryHandleChange = this.selectBoxSubcategoryHandleChange.bind(
      this
    );
    this.changeQuestionName = this.changeQuestionName.bind(this);
    this.randamizeOrderChanges = this.randamizeOrderChanges.bind(this);
    this.selectBoxMultipleChoiceHandleChange = this.selectBoxMultipleChoiceHandleChange.bind(
      this
    );
    this.addQuestion = this.addQuestion.bind(this);
    this.copyQuestion = this.copyQuestion.bind(this);
    this.loadTopicData = this.loadTopicData.bind(this);
    this.onLoadResponse = this.onLoadResponse.bind(this);
    this.questionTextBelowORAboveImageOnChange = this.questionTextBelowORAboveImageOnChange.bind(
      this
    );
    this.correctAnswerOnChange = this.correctAnswerOnChange.bind(this);
    this.randomizeOrderOnChange = this.randomizeOrderOnChange.bind(this);
    this.AnswerTypeOnChange = this.AnswerTypeOnChange.bind(this);
    this.forCheckBoxQuestionOnChange = this.forCheckBoxQuestionOnChange.bind(this);
    this.onDisplayStyleChange = this.onDisplayStyleChange.bind(this);
    this.onChangeAnswerAllorAny = this.onChangeAnswerAllorAny.bind(this);
    this.questionNonGradeOnChange = this.questionNonGradeOnChange.bind(this);
    this.onAnswerDisplayOptionsChange = this.onAnswerDisplayOptionsChange.bind(
      this
    );
    this.changeCaseSensitive = this.changeCaseSensitive.bind(this);

    this.canvasRef = React.createRef();
    this.OnComponentShowChange = this.OnComponentShowChange.bind(true);
    this.onGenerateAnswerVector= this.onGenerateAnswerVector.bind(this);
    this.RandomizeQuestionVector = this.RandomizeQuestionVector.bind(this);
  }

  optimizeVectorVariableValues = (vectorState, generateValueWithState, vectorSettingsData) => {

    const formatValue = (value) => value.toString();
    vectorSettingsData = this.state.vectorSettingsData;
    if(generateValueWithState) {
      //console.log("P VectorVariable =", this.state.vectorVariablesMap)
      if(this.state.vectorVariablesMap) {
        const _vecArray = this.state.vectorVariablesMap.getVectorsArray(vectorSettingsData.widthUnit, vectorSettingsData.heightUnit, vectorSettingsData.enableIdenticalVector);
        console.log("newVectorValues0.2",_vecArray)
        const formattedOBJ = [];
  
        for (let index = 0; index < _vecArray.length; index++) {
          const _vecArrayElement = _vecArray[index];
          const _vecStateElement = vectorState[index];

          if(vectorSettingsData && vectorSettingsData != undefined) {

            if(generateValueWithState !== "randomize") {

              if( _vecArrayElement.autoOrigin){
                _vecArrayElement.posX = formatValue(Math.trunc((vectorSettingsData.widthUnit / 2) - (_vecStateElement.x/2)));
                _vecArrayElement.posY = formatValue(Math.trunc((vectorSettingsData.heightUnit / 2) - (_vecStateElement.y/2)));
                console.log(_vecArrayElement.name," => ","Auto X-Orgin", _vecArrayElement.posX, "Auto Y-Orgin", _vecArrayElement.posY) 
              }else{
                _vecArrayElement.posX = formatValue(_vecArrayElement.posX ? _vecArrayElement.posX:Math.trunc(vectorSettingsData.widthUnit / 2));
                _vecArrayElement.posY = formatValue(_vecArrayElement.posY ? _vecArrayElement.posY:Math.trunc(vectorSettingsData.heightUnit / 2));
              } 
            }
            _vecArrayElement.gridHeightUnit = formatValue(vectorSettingsData.heightUnit);
            _vecArrayElement.gridWidthUnit = formatValue(vectorSettingsData.widthUnit);
          }

          if(generateValueWithState !== "default") {
            if( _vecArrayElement.autoOrigin){
              _vecArrayElement.posX = formatValue(Math.trunc((vectorSettingsData.widthUnit / 2) - (_vecStateElement.x/2)));
              _vecArrayElement.posY = formatValue(Math.trunc((vectorSettingsData.heightUnit / 2) - (_vecStateElement.y/2)));
              console.log(_vecArrayElement.name," => ","Auto X-Orgin", _vecArrayElement.posX, "Auto Y-Orgin", _vecArrayElement.posY) 
            }else{
              _vecArrayElement.posX = formatValue(_vecArrayElement.posX ? _vecArrayElement.posX:Math.trunc(vectorSettingsData.widthUnit / 2));
              _vecArrayElement.posY = formatValue(_vecArrayElement.posY ? _vecArrayElement.posY:Math.trunc(vectorSettingsData.heightUnit / 2));
            }
            // console.log("default", _vecArrayElement)
            formattedOBJ.push({
              ..._vecArrayElement
            })
          } else {
            formattedOBJ.push({
              ..._vecArrayElement
            })
          }
        }

        return formattedOBJ;
      }
    } else {
      if(this.state.vectorVariablesMap) {
        const _vecArray = this.state.vectorVariablesMap.getVectorsArray(vectorSettingsData.widthUnit, vectorSettingsData.heightUnit, vectorSettingsData.enableIdenticalVector);
        console.log("newVectorValues0.1",_vecArray, this.state.vectorVariablesMap)
        const formattedOBJ = [];
  
        for (let index = 0; index < _vecArray.length; index++) {
          const _vecArrayElement = _vecArray[index];
          formattedOBJ.push({
            x: _vecArrayElement.x,
            y: _vecArrayElement.y
          })
        }

        return formattedOBJ;
      }
    }

    return [];
  };
  componentDidUpdate(prevProps) {
    if (prevProps && this.props) {
        if (prevProps?.count !== this.props?.count) {
            this.setState({
                questionImageWidth: 500
            })
        }
    }
}
  onVectorGridSettingsChanged = (settings) => {
    const { heightUnit, widthUnit,image, stepSize,imageWidthUnit, imageHeightUnit } = settings;
    console.log('onVectorGridSettingsChanged', settings)
    
    let generateRandomOrigin = true;
    let preventChangesForArray = ['rulerYPoint','rulerXPoint','rulerYLabel','rulerXPoint','rulerYLabel','rulerXLabel','rulerNYLabel','rulerNXLabel','gridColor','image','enableGrid', 'enableBorder', 'enableDarkGridLine','enableRuler','imageHeight','imageWidth', 'imageHeightUnit', 'imageWidthUnit', 'imageX', 'imageY', 'altImageText'];
    //if(image && image != "") {
      Object.values(Object.keys(settings)).forEach((key, object) => {
        if(preventChangesForArray.includes(key) && settings[key] != " " && settings[key] != '') {
          generateRandomOrigin = false;
        }
      });

      if(!generateRandomOrigin) {
        Object.values(Object.keys(settings)).forEach((key, object) => {
          if( !preventChangesForArray.includes(key) && settings[key] != this.state.vectorSettingsData[key]) {
            generateRandomOrigin = true;
          }
        });
      }
    //}

    console.log('generateRandomOrigin', generateRandomOrigin)
    this.setState(
      {
        vectorSettingsData: {
          ...settings,
          height: stepSize * heightUnit,
          width: stepSize * widthUnit,
          imageWidth: stepSize *imageWidthUnit,
          imageHeight: stepSize *imageHeightUnit,
        },
      },
      () => {
        if(this.canvasRef.current) {

          let _vecArray = this.optimizeVectorVariableValues(this.state.vectorState, "default", this.state.vectorSettingsData);
          for (let index = 0; index < _vecArray.length; index++) {
            const variableObj = _vecArray[index];
            let varMap = this.state.variablesMap;
            if(varMap !== undefined && varMap !== null) {
              varMap.set(variableObj.name, variableObj);
              this.setState({
                variablesMap: varMap,
              });
            }
          }

          this.setState({
            vectorState: this.optimizeVectorVariableValues(),
          }, () => {
              
            if(generateRandomOrigin) {
              this.canvasRef.current.drawVectors({
                vectors: this.optimizeVectorVariableValues(this.state.vectorState, true, this.state.vectorSettingsData),
                updatedGridStepSize: this.state.vectorSettingsData.stepSize
              });

              //console.log('onVectorGridSettingsChanged', this.optimizeVectorVariableValues(this.state.vectorState, true))
            }

            setTimeout(() => {
              this.setState({ 
                  generateRandomOrigin,
                  questionCanvasComponentGuid: GetNewComponentGuid(),
                  answerCanvasComponentGuid: GetNewComponentGuid(),
                });
            }, 500);

          });

        }
      }
    );
  };

  //Randomized Parameters Black List on Change
  onRpBlackListChange = (value) => {
    this.setState({
      rpBlackList: value,
    });
  };


  //bug-tracker#261
  onDisplayStyleChange(value) {
    
    this.setState({ 
      answerDisplayStyle: parseInt(value, 10)
     });
  }

 

  setAnswerFormatChange(value) {
    for (const formulaItem of Array.from(this.state.answer_formula.formulaMap.values())){
      formulaItem["answerFormat"] = value;
    }
    this.setState({
      answer_formula: this.state.answer_formula,
    });
  }

  

  onChangeAnswerAllorAny(value) {
    this.setState({ shouldAnswerAllorAny: parseInt(value, 10) });
    this.setShouldAnswerAllorAny(value);
    this.setState({
      shouldAnswerAllorAnyChange: true,
    });
  }

  changeCaseSensitive() {
    if (this.state.isCaseSensitive) {
      this.setState({ isCaseSensitive: false });
      for (const formulaItem of Array.from(
        this.state.answer_formula.formulaMap.values()
      )) {
        formulaItem["isCaseSensitive"] = false;
      }
    } else {
      this.setState({ isCaseSensitive: true });
      for (const formulaItem of Array.from(
        this.state.answer_formula.formulaMap.values()
      )) {
        formulaItem["isCaseSensitive"] = true;
      }
    }
    // this.setAnswerCaseSensitiveorNot();
    this.setState({
      answer_formula: this.state.answer_formula,
    });
    this.setState({
      caseSensitiveChange: true,
    });
    console.log("answer_formula", this.state.answer_formula);
  }

  setAnswerCaseSensitiveorNot() {
    for (const formulaItem of Array.from(
      this.state.answer_formula.formulaMap.values()
    )) {
      formulaItem["isCaseSensitive"] = false;
    }
    this.setState({
      answer_formula: this.state.answer_formula,
    });
  }

  setShouldAnswerAllorAny(value) {
    if (value === "1") {
      for (const formulaItem of Array.from(
        this.state.answer_formula.formulaMap.values()
      )) {
        formulaItem["shouldAnswerAll"] = true;
      }
    } else {
      for (const formulaItem of Array.from(
        this.state.answer_formula.formulaMap.values()
      )) {
        formulaItem["shouldAnswerAll"] = false;
      }
    }
    this.setState({
      answer_formula: this.state.answer_formula,
    });
  }

  removeOldAnswerData(answer) {
    //tempAnswerList
    var tempValue = {};
    tempValue.answer_text = answer.answer_text;
    tempValue.feedback_text = answer.feedback_text;
    tempValue.is_answer = answer.is_answer;
    tempValue.enable_alt_ans_text = answer.enable_alt_ans_text;
    tempValue.answer_display_options = answer.answer_display_options;
    tempValue.vectorAnswerFormula = answer.vectorAnswerFormula;
    tempValue.alt_answer_text = answer.alt_answer_text ? answer.alt_answer_text : "";
    tempValue.vectorAnswerVariable = answer.vectorAnswerVariable;

    return tempValue;
  }

  onLoadResponse(res) {
    console.log('Onload responce from server', res.data.data);
    let tempResAnswerArray = [];
    tempResAnswerArray = this.state.textEditorObjAns.slice();
    let tempResFeedbackArray = [];
    tempResFeedbackArray = this.state.textEditorObjFeed.slice();
    let tempResAltAnswerArray = [];
    tempResAltAnswerArray = this.state.textEditorObjAltAns.slice();
    let tempResAltFeedbackArray = [];
    tempResAltFeedbackArray = this.state.textEditorObjAltFeedback.slice();
    //

    if (res.data.data !== undefined && res.data.data !== null) {
      //
      var tempQuestionNameDefaultVaule = res.data.data.question_name;
      var tempSubjectDefaultId = parseInt(res.data.data.subject_id, 10);
      var tempTopicDefaultId = parseInt(res.data.data.topic_id, 10);
      var tempCategoryDefaultId = parseInt(res.data.data.category_id, 10);
      var tempSubCategoryDefaultId = parseInt(res.data.data.subcategory_id, 10);
      var tempQuestionTextDefaultId = res.data.data.question_text;
      var tempAltQuestionTextDefaultId = res.data.data.alt_question_text;
      var tempAnswerList = [];
      var tempQuestionTextBelowOrAbove = res.data.data.is_text_above_image;

      if (res.data.data.answers !== null) {
        tempAnswerList = res.data.data.answers;
        //
        if (this.state.copyMode === 1) {
          //Purge Excess Data
          var purgedArray = [];

          purgedArray.push(tempAnswerList.map(this.removeOldAnswerData));
          tempAnswerList = null;
          tempAnswerList = purgedArray[0];
        }
      }
      var tempAnswerType = parseInt(res.data.data.answer_type, 10);
      var tempForCheckBoxQuestion = parseInt(res.data.data.for_checkbox_question, 10);
      var tempRandomizeOrder = parseInt(res.data.data.randomize_answer, 10);
      var tempQuestionNonGraded = parseInt(
        res.data.data.question_nongraded,
        10
      );
      let answerDisplayStyleLocal = 0;
      if (
        res.data.data.answerDisplayStyle !== undefined &&
        res.data.data.answerDisplayStyle !== null
      ) {
        answerDisplayStyleLocal = res.data.data.answerDisplayStyle;
      }
      let tempShowOwnershipAttribute = false;
      if (res.data.data.question_ownership === 1) {
        tempShowOwnershipAttribute = true;
      }

      const vectorVariableMap = MathParserUtil.buildQuestionVariablesMap(
        res.data.data.question_variables
      );
      console.log(
        'API response',
        res.data.data.vector_settings_data?{...res.data.data.vector_settings_data,imageWidth:res.data.data.vector_settings_data.stepSize *res.data.data.vector_settings_data.imageWidthUnit, imageHeight:res.data.data.vector_settings_data.stepSize *res.data.data.vector_settings_data.imageHeightUnit}:{...VectorSettingsData}
      )
      let tempShowComponent =  true;
      let tempShowMagnitudeAngle = true;
      let tempShowVectorPrompt = false;
      if(res.data.data.question_type === 3 && res.data.data.answer_type === 2){
         tempShowComponent = res.data.data.freeform_vector_options.show_components;
         tempShowMagnitudeAngle = res.data.data.freeform_vector_options.show_magnitude_angle;
         tempShowVectorPrompt = res.data.data.freeform_vector_options?.show_vector_prompt !== undefined && res.data.data.     freeform_vector_options?.show_vector_prompt !== null ? res.data.data.freeform_vector_options.show_vector_prompt : false
      } 
      this.setState({
        questions: res.data.data,
        questionNameDefaultVaule: tempQuestionNameDefaultVaule,
        subjectDefaultId: tempSubjectDefaultId,
        topicDefaultId: tempTopicDefaultId,
        categoryDefaultId: tempCategoryDefaultId,
        subCategoryDefaultId: tempSubCategoryDefaultId,
        questionTextEditorObj: TextEditor.createValueFromString(
          tempQuestionTextDefaultId,
          "html"
        ),
        altQuestionTextEditorObj: tempAltQuestionTextDefaultId,
        answerArrList: tempAnswerList,
        defaultQuestionTextBelowOrAbove: tempQuestionTextBelowOrAbove,
        defaultAnswerType: tempAnswerType,
        forCheckBoxQuestion: tempForCheckBoxQuestion,
        defaultRandamizeOrder: tempRandomizeOrder,
        answerDisplayStyle: answerDisplayStyleLocal,
        questionNonGraded: tempQuestionNonGraded,
        enableAnalytics: res.data.data.enable_analytics,
        enableFeedback: res.data.data.enable_feedback,
        //enableAltText:res.data.data.enable_alt_text ,
        feedbackVisibility: res.data.data.enable_feedback,
        //answerIndex:tempAnswerIndex
        questionType: res.data.data.question_type,
        variablesMap: vectorVariableMap,
        answer_formula:
          res.data && res.data.data && res.data.data.answer_formula
            ? {
                ...res.data.data.answer_formula,
                formulaMap: MathParserUtil.buildAnswerFormulasMap(
                  res.data.data.answer_formula.formulaArray
                ),
              }
            : null,
        questionOrder: res.data.data.question_order,
        questionOwnership: res.data.data.question_ownership,
        ownershipAttributeObj: res.data.data.question_ownership_attribute,
        showOwnershipAttribute: tempShowOwnershipAttribute,
        rpBlackList: res.data.data.rpBlackList,
        vectorVariablesMap: VectorParserUtil.buildQuestionVariablesMap(
          res.data.data.vector_question_variables
        ),
        vectorSettingsData:res.data.data.vector_settings_data?{...res.data.data.vector_settings_data,imageWidth:res.data.data.vector_settings_data.stepSize *res.data.data.vector_settings_data.imageWidthUnit, imageHeight:res.data.data.vector_settings_data.stepSize *res.data.data.vector_settings_data.imageHeightUnit}:{...VectorSettingsData},
        vectorAnswerFormulas:res.data.data.vector_answer_formulas?res.data.data.vector_answer_formulas:[createEmptyVectorAnswerFormula(0)],
        vectorBelowGridTextEditorObj:TextEditor.createValueFromString(
          res.data.data.vector_below_question_text,
          "html"
        ),
        vectorBelowQuestionText: res.data.data.vector_below_question_text,
        showComponents: tempShowComponent,
        showMagnitudeAngle: tempShowMagnitudeAngle,
        showVectorPrompt: tempShowVectorPrompt,
        reasoningElements: res.data.data?.reasoning_elements ? res.data.data?.reasoning_elements : [],
        connectingWords: res.data.data?.connecting_words ? res.data.data?.connecting_words : [],
        conclusionSentences: res.data.data?.conclusion_sentences ? res.data.data?.conclusion_sentences  : [],
        isConclusionSentenceRequired: res.data.data?.is_conclusion_sentence_required,
        showReasoningElementCategoryInfo: res.data.data?.show_reasoning_element_category_info
      });

      // initialize case Sensitive and shouldAnswerAllorAny
      if (res?.data?.data?.answer_formula?.formulaArray) {
      const formulaArray = this.state?.answer_formula?.formulaArray || [];
      for (const formulaItem of formulaArray) {
        if (formulaItem.isCaseSensitive !== undefined && formulaItem.shouldAnswerAll !== undefined) {
            this.setState({
                isCaseSensitive: formulaItem.isCaseSensitive,
                caseSensitiveChange : true                
            });
            if (formulaItem.shouldAnswerAll) {
              this.setState({
                shouldAnswerAllorAny: 1,
                shouldAnswerAllorAnyChange: true
              });
            }
            else if (formulaItem.shouldAnswerAll === false) {
              this.setState({
                shouldAnswerAllorAny: 2,
                shouldAnswerAllorAnyChange: true
              });
            }
        }
      }
    }
      //Initizalize MultipleQuestionType
      if (res?.data?.data.question_type && res.data.data.question_type === 2) {
        this.initializeMQT(res.data.data.mqt_options);
      }
      //
      //
      //
      console.debug("tempAnswerList>?>>>", tempAnswerList)
      for (var i = 0; i < tempAnswerList.length; i++) {
        if (tempAnswerList[i]?.value !== undefined) {
          tempResAnswerArray[i].value = TextEditor.createValueFromString(
            tempAnswerList[i].answer_text,
            "html"
          );
        } else {
          tempResAnswerArray.push({ value: TextEditor.createEmptyValue() });
          tempResAnswerArray[i].value = TextEditor.createValueFromString(
            tempAnswerList[i].answer_text,
            "html"
          );
        }
      }
      for (let i = 0; i < tempAnswerList.length; i++) {
        if (tempAnswerList[i]?.value !== undefined) {
          tempResAltAnswerArray[i].value = tempAnswerList[i].alt_answer_text;
        } else {
          tempResAltAnswerArray.push({ value: "" });
          tempResAltAnswerArray[i].value = tempAnswerList[i].alt_answer_text;
        }
      }
      for (let i = 0; i < tempAnswerList.length; i++) {
        if (tempAnswerList[i]?.value !== undefined) {
          tempResAltFeedbackArray[i].value =
            tempAnswerList[i].alt_feedback_text;
        } else {
          tempResAltFeedbackArray.push({ value: "" });
          tempResAltFeedbackArray[i].value =
            tempAnswerList[i].alt_feedback_text;
        }
      }
      for (let i = 0; i < tempAnswerList.length; i++) {
        if (
          tempAnswerList[i]?.feedback_text !== undefined &&
          tempAnswerList[i]?.feedback_text !== null &&
          tempAnswerList[i]?.feedback_text !== "" &&  tempAnswerList[i].feedback_text !== "<p><br></p>"
        ) {
          const contentState = convertFromRaw(
            JSON.parse(tempAnswerList[i].feedback_text)
          );
          const serlializedState = EditorState.createWithContent(contentState);
          //
          let tempfeedbackText = TextEditor.getHTMLStringFromEditorState(
            serlializedState
          );
          if(tempResFeedbackArray[i] !== undefined &&
            tempResFeedbackArray[i] !== null){
              tempResFeedbackArray[i].value = TextEditor.createValueFromString(
                tempfeedbackText,
                "html"
              );
          }else{
            tempResFeedbackArray.push({ value: TextEditor.createEmptyValue() });
            tempResFeedbackArray[i].value = TextEditor.createValueFromString(
            tempAnswerList[i].feedback_text,
            "html"
          );
          }   
        } else if (tempAnswerList[i].feedback_text !== undefined &&
          tempAnswerList[i].feedback_text !== null &&
          tempAnswerList[i].feedback_text == "<p><br></p>"){
            tempResFeedbackArray.push({ value: TextEditor.createEmptyValue() });
            tempResFeedbackArray[i].value = TextEditor.createValueFromString(
              tempAnswerList[i].feedback_text,
              "html"
            );
        } else {
          tempResFeedbackArray.push({ value: TextEditor.createEmptyValue() });
          tempResFeedbackArray[i].value = TextEditor.createValueFromString(
            tempAnswerList[i].feedback_text,
            "html"
          );
        }

        // tempAnswerList[i].answer_text;
        //
      }
      this.setState({
        textEditorObjAns: tempResAnswerArray,
        textEditorObjFeed: tempResFeedbackArray,
        textEditorObjAltAns: tempResAltAnswerArray,
        textEditorObjAltFeedback: tempResAltFeedbackArray,
      });
      if (res.data.data.question_type !== 4) {
        this.answerTextDisplay();
      }
    }

    if(this.props.IsQuestionList !== true){
      if (this.refs.randomizeOrderToggle) {
      if (this.state.defaultRandamizeOrder === 1) {
        this.refs.randomizeOrderToggle.setState({ checked: true }); //TODO : Change be later-default value set for Randomize Order
      } else {
        this.refs.randomizeOrderToggle.setState({ checked: false });
      }
    }

    // bug id 361
    if (tempQuestionNonGraded === 1) {
      this.refs.QuestionNongraded.setState({ checked: false });
    } else {
      this.refs.QuestionNongraded.setState({ checked: true });
    }
  }

    /* After Updating the API values to UI ~ need to update the componentGUID to refresh the child */
     this.generateRandomisedAnswer();

    this.setState({
      loading: false,
      saveButtonShow: true,
    });
  }

  loadSubjectData() {
    //let answerIndex = 0;
    ApiRequestService({
      method: "post",
      url: "/getAllSubjects",
    }).then((res) => {
      //
      this.setState({
        subjects: res.data.data.subject_names,
      });
      Object.keys(this.state.instSubjectsId.subjectsbyInstructor).forEach(
        (subId) => {
          res.data.data.subject_names.forEach((subject) => {
            if (subject.subject_id === parseInt(subId)) {
              this.state.instAllSubjects.push(subject);
            }
          });
        }
      );
    });
  }

  answerDelete(thisObj, index) {
    this.setState({ loading: true });

    var tempArray = this.state.answerArrList.slice();
    //console.log("tempArray.length ===", tempArray.length)

    if (tempArray.length === 1) {
      NotificationManager.error("The question should have at least one answer", "Warning!", 5000);
      this.setState({ loading: false, loadingSave: false });
      return;
    } 

    if (tempArray.length === 0) {
      alert("Please choose vaild answer");
      this.setState({ loading: false, loadingSave: false });
      return;
    }
    //bug id 166 fixes
    if (window.confirm("Do you really want to delete this answer?")) {
      var sub_id = parseInt(this.props.selectedSubjectId, 10);
      var top_id = parseInt(this.props.selectedTopicId, 10);
      var catg_id = parseInt(this.props.selectedCategoryId, 10);
      var subcatg_id = parseInt(this.props.selectedSubCategoryId, 10);

      if (
        tempArray[thisObj] !== undefined &&
        tempArray[thisObj] !== null &&
        tempArray[thisObj].answer_id !== 0
      ) {
        // tempArray is undefined new add answer remove from array
        //
        var answerId = parseInt(tempArray[thisObj].answer_id, 10);

        const payload = {
          answer_id: answerId,
          subject_id: sub_id,
          topic_id: top_id,
          category_id: catg_id,
          subcategory_id: subcatg_id,
        };
        //

        ApiRequestService({
          method: "post",
          url: "/deleteAnswers",
          data: payload,
        })
          .then((res) => {
            //
            this.state.textEditorObjAns.splice(thisObj, 1);
            this.state.textEditorObjAltAns.splice(thisObj, 1);
            this.state.textEditorObjAltFeedback.splice(thisObj, 1);
            this.state.textEditorObjFeed.splice(thisObj, 1);
            this.state.answerArrList.splice(thisObj, 1);
            this.state.answerList.splice(thisObj, 1);

            this.setState({
              textEditorObjAns: this.state.textEditorObjAns,
              textEditorObjAltAns: this.state.textEditorObjAltAns,
              textEditorObjAltFeedback: this.state.textEditorObjAltFeedback,
              textEditorObjFeed: this.state.textEditorObjFeed,
              answerArrList: this.state.answerArrList,
              answerList: this.state.answerList,
              answerIndex: 0,
              loading: false,
            });

            this.answerTextDisplay();
          })
          .catch((error) => {
            //bug-tracker#148

            if (error.status !== undefined && error.status === 403) {
              //User Doesnt Have Access
              NotificationManager.error(
                "Unauthorized",
                "You are not authorized to delete answers",
                5000
              );
            }
            this.setState({
              loading: false,
            });
          });
      } else {
        this.state.textEditorObjAns.splice(thisObj, 1);
        this.state.textEditorObjAltAns.splice(thisObj, 1);
        this.state.textEditorObjAltFeedback.splice(thisObj, 1);
        this.state.textEditorObjFeed.splice(thisObj, 1);
        this.state.answerArrList.splice(thisObj, 1);
        this.state.answerList.splice(thisObj, 1);

        if (this.state.questionType === 3) {
          for (let ansIndex = 0; ansIndex < this.state.answerArrList.length; ansIndex++) {
            const element = this.state.answerArrList[ansIndex];
            if(element === undefined || element == null) {
              this.state.answerArrList[ansIndex] = answerArrListJsonFunction(ansIndex);
            }
          };
        }
        
        this.setState({
          answerIndex: 0,
          textEditorObjAns: this.state.textEditorObjAns,
          textEditorObjAltAns: this.state.textEditorObjAltAns,
          textEditorObjAltFeedback: this.state.textEditorObjAltFeedback,
          textEditorObjFeed: this.state.textEditorObjFeed,
          answerArrList: this.state.answerArrList,
          answerList: this.state.answerList,
          loading: false,
        });
        this.answerTextDisplay();
      }
    } else {
      this.setState({ loading: false });
    }
  }

  answerTextDisplay() {
    var answerList = [];
    var maxLength = 4;

    if (this.state.answerArrList.length !== 0) {
      maxLength = this.state.answerArrList.length;
    }

    const randomString = () => Math.random().toString(36).replace(/[^a-z]+/g, '').substr(0, 5);

    for (var index = 0; index < maxLength; index++) {
      answerList.push(
        <Answer
          key={randomString()}
          index={index}
          answerText={"Answer " + (index + 1)}
          answerButton={styles.answerButton}
          correctAnswerSwitch={styles.correctAnswerSwitch}
          correctAnswer={styles.correctAnswer}
          deleteAnswerButton={styles.deleteAnswerButton}
          onAnswerTextChange={this.onAnswerTextChange.bind(this, index)}
          AnswerValue={this.state.textEditorObjAns[index]}
          answerSwitchValue={
            this.state.answerArrList[index] !== undefined &&
            this.state.answerArrList[index] !== null &&
            this.state.answerArrList[index].is_answer !== undefined &&
            this.state.answerArrList[index].is_answer !== null
              ? this.state.answerArrList[index].is_answer
              : 0
          }
          correctAnswerOnChange={this.correctAnswerOnChange.bind(this, index)}
          answerDelete={this.answerDelete.bind(this, index)}
          feedbackVisible={this.state.feedbackVisibility}
          feedbackText={"Feedback for Answer " + (index + 1)}
          onFeedbackTextChange={this.onFeedbackTextChange.bind(this, index)}
          FeedbackValue={this.state.textEditorObjFeed[index]}
          AltAnswerValue={this.state.textEditorObjAltAns[index]}
          onAltAnswerTextChange={this.onAltAnswerTextChange.bind(this, index)}
          AltFeedbackValue={this.state.textEditorObjAltFeedback[index]}
          onAltFeedbackTextChange={this.onAltFeedbackTextChange.bind(
            this,
            index
          )}
          isRandomized={this.state.questionType === 1 || [50, 60].includes(this.state.defaultAnswerType)}
          answer_display_options={getAnswerDisplayOption(this.state.defaultAnswerType,
            this.state.questionType,
            this.state.answerArrList[index],
            index
          )}
          vectorAnswerFormula={getVectorAnswerFormula(
            this.state.questionType,
            this.state.answerArrList[index],
            index
          )}
          onAnswerDisplayOptionsChange={this.onAnswerDisplayOptionsChange}
          onVectorAnswerChange={this.onVectorAnswerChange}
          questionNonGraded={this.state.questionNonGraded}
          questionType={this.state.questionType}
          defaultAnswerType={this.state.defaultAnswerType}
          questionVectorTableMap={this.state.variablesMap}
          vectorAnswerVariablesMap={this.state.answerArrList[index]?.vectorAnswerVariable ? this.state.answerArrList[index]?.vectorAnswerVariable 
            : VectorParserUtil.createDefaultVectorVariableMap(this.state.vectorAnswerVariablesMap,this.state.vectorSettingsData,"")}
          onAddVectorAnswer={this.onAddVectorAnswer}
          onRemoveVectorAnswer={this.onRemoveVectorAnswer}
          vectorAnswerVariable={ this.state.answerArrList[index]?.vectorAnswerVariable ? this.state.answerArrList[index]?.vectorAnswerVariable :
             [VectorParserUtil.createDefaultVectorVariable(VectorSettingsData,"")]}
             onVectorAnswerVariableChange={this.onVectorVariableChange}
          /*altAnsTextVisible={ this.state.answerArrList[index] !== undefined &&
              this.state.answerArrList[index] !== undefined
                ? this.state.answerArrList[index].enable_alt_ans_text
                : 0}*/
          //altAnsTextVisibleOnChange={this.altAnsTextVisibleOnChange.bind(this, index)}
        />
      );
    }
    //
    this.setState({ answerIndex: index - 1 });
    this.setState({ answerList: answerList });
    this.answerRefreshCallback();
    // }
  }

  /* componentDidUpdate() {
    if (this.state.answer_formula.formulaArray !== null) {
    for (const formulaItem of this.state.answer_formula.formulaArray) {
      if (formulaItem.isCaseSensitive !== undefined && formulaItem.shouldAnswerAll !== undefined) {
          this.setState({
              isCaseSensitive: formulaItem.isCaseSensitive
          });
          if (formulaItem.shouldAnswerAll) {
            this.setState({
              shouldAnswerAllorAny: 1
            });
          }
          else if (formulaItem.shouldAnswerAll === false) {
            this.setState({
              shouldAnswerAllorAny: 2
            });
          }
      }
    }
  }
}*/

  // componentDidMount() {

  //   var sub_id = parseInt(this.props.selectedSubjectId, 10);
  //   var top_id = parseInt(this.props.selectedTopicId, 10);
  //   var catg_id = parseInt(this.props.selectedCategoryId, 10);
  //   var subcatg_id = parseInt(this.props.selectedSubCategoryId, 10);
  //   var question_id = this.props.selectedQuestionId;

  //   const payload = {
  //     // subject_id: this.state.subject_id
  //     subject_id: sub_id,
  //     topic_id: top_id,
  //     category_id: catg_id,
  //     subcategory_id: subcatg_id,
  //     question_id: question_id,
  //   };
  //   //

  //   ApiRequestService({
  //     method: "post",
  //     url: "/getQuestionsById",
  //     data: payload,
  //   }).then(this.onLoadResponse);
    


  //   this.setState({
  //     loading: true,
  //     questionTextEditorObj: TextEditor.createEmptyValue(),
  //     vectorBelowGridTextEditorObj : TextEditor.createEmptyValue(),
  //     altQuestionTextEditorObj: "",
  //     textEditorObjAns: [
  //       { value: TextEditor.createEmptyValue() },
  //       { value: TextEditor.createEmptyValue() },
  //       { value: TextEditor.createEmptyValue() },
  //       { value: TextEditor.createEmptyValue() },
  //     ],
  //     textEditorObjAltAns: [
  //       { value: "" },
  //       { value: "" },
  //       { value: "" },
  //       { value: "" },
  //     ],
  //     textEditorObjAltFeedback: [
  //       { value: "" },
  //       { value: "" },
  //       { value: "" },
  //       { value: "" },
  //     ],
  //     textEditorObjFeed: [
  //       { value: TextEditor.createEmptyValue() },
  //       { value: TextEditor.createEmptyValue() },
  //       { value: TextEditor.createEmptyValue() },
  //       { value: TextEditor.createEmptyValue() },
  //     ],
  //     pageLoading: false,
  //   });


  //   /*this.setState({
  //         subjectId: this.props.selectedSubjectId,
  //         topicId: this.props.selectedTopicId,
  //         categoryId: this.props.selectedCategoryId,
  //         subcategoryId: this.props.selectedSubCategoryId
  //       });*/

  //   if (this.state.copyMode) {
  //     this.loadSubjectData();
  //     this.loadTopicData(sub_id);
  //     this.loadCategory(sub_id, top_id);
  //     this.loadSubcategory(sub_id, top_id, catg_id);
  //   }
  // }

  componentWillMount() {
    this.onLoadQuestionByid()
  }
  componentDidMount() {
    this.onLoadQuestionByid().then(() => {
      if (this.props.IsQuestionList) {
        this.previewQuestion(); 
      }
    });
  }



   componentWillReceiveProps(nextProps) {
     if( nextProps.selectedQuestionId != this.props.selectedQuestionId){
        this.onLoadQuestionByid(nextProps).then(() => {
          if (this.props.IsQuestionList && this.canvasRef?.current) {
            this.previewQuestion();
          }
        });
      }
      
  }
 
  async onLoadQuestionByid(props = this.props) {

    // asyncComponent(() => import("react-mathjax-preview"));
    //Promise.all([import('react-rte'), import('react-mathjax-preview')]).then(
    //([reactRte, mathjax]) => {
    //Loading React RTE Module On Demand
    var sub_id = parseInt(props.selectedSubjectId, 10);
    var top_id = parseInt(props.selectedTopicId, 10);
    var catg_id = parseInt(props.selectedCategoryId, 10);
    var subcatg_id = parseInt(props.selectedSubCategoryId, 10);
    var question_id = props.selectedQuestionId;

    /* Capture the current question id and reduce the unwanted rendering */
    await this.setState({selectedQuestionId: question_id })
     
  
    // var sub_id = parseInt(this.props.selectedSubjectId, 10);
    // var top_id = parseInt(this.props.selectedTopicId, 10);
    // var catg_id = parseInt(this.props.selectedCategoryId, 10);
    // var subcatg_id = parseInt(this.props.selectedSubCategoryId, 10);
    // var question_id = this.props.selectedQuestionId;

    const payload = {
      // subject_id: this.state.subject_id
      subject_id: sub_id,
      topic_id: top_id,
      category_id: catg_id,
      subcategory_id: subcatg_id,
      question_id: question_id
    };
    //

    ApiRequestService({
      method: "post",
      url: "/getQuestionsById",
      data: payload
    }).then( res => 
      {
      if(this.state.selectedQuestionId ===  res.data.data.question_id ) {
        this.onLoadResponse(res)
      }
     })
    


    this.setState({
      loading: true,
      questionTextEditorObj: TextEditor.createEmptyValue(),
      altQuestionTextEditorObj: "",
      textEditorObjAns: [
        { value: TextEditor.createEmptyValue() },
        { value: TextEditor.createEmptyValue() },
        { value: TextEditor.createEmptyValue() },
        { value: TextEditor.createEmptyValue() }
      ],
      textEditorObjAltAns: [
        { value: "" },
        { value: "" },
        { value: "" },
        { value: "" }
      ],
      textEditorObjAltFeedback: [
        { value: "" },
        { value: "" },
        { value: "" },
        { value: "" }
      ],
      textEditorObjFeed: [
        { value: TextEditor.createEmptyValue() },
        { value: TextEditor.createEmptyValue() },
        { value: TextEditor.createEmptyValue() },
        { value: TextEditor.createEmptyValue() }
      ],
      pageLoading: false
    });


    /*this.setState({
          subjectId: this.props.selectedSubjectId,
          topicId: this.props.selectedTopicId,
          categoryId: this.props.selectedCategoryId,
          subcategoryId: this.props.selectedSubCategoryId
        });*/

    if (this.state.copyMode) {
      this.loadSubjectData();
      this.loadTopicData(sub_id);
      this.loadCategory(sub_id, top_id);
      this.loadSubcategory(sub_id, top_id, catg_id);
    }
  }


  onQuestionTextChange = (value) => {
    this.setState({ questionTextEditorObj: value });
    //
    let enteredString = TextEditor.getHTMLStringFromEditorState(
      value
      );
      
      //Randomized Questions - Parsing Question Text for Variables
    if (this.state.questionType === 1 || this.state.questionType === 3) {
      let variablesMap = MathParserUtil.getVariablesFromText(
        enteredString,
        this.state.variablesMap
        );
        
        this.setState({
          variablesMap: variablesMap,
      });
    }
    
    //Vector Questions - Parsing Question Text for Vector Variables
    if(this.props.IsQuestionList !== true){
      let questionTextEditorObj = TextEditor.getHTMLStringFromEditorState(this.state.questionTextEditorObj)
      if(questionTextEditorObj !== enteredString || !this.state.isQuestionWithPreview) {
        if (this.state.questionType === 3 || (this.state.questionType === 0 && [70,80,90].includes(this.state.defaultAnswerType))) {
          VectorParserUtil.getVariablesFromText(
            enteredString,
            this.state.vectorVariablesMap,
            this.state.vectorSettingsData
          )
          .then((vectorVariablesMap)=> {
            this.setState({
              vectorVariablesMap: vectorVariablesMap,
            },() => {
              this.previewQuestion(enteredString)
            });
          });
        }
      }
    }
    

    //
    if (enteredString !== null) {
      this.setState({ questionText: enteredString });
    }
    var imgTagCount = enteredString.split("<img ").length - 1;
    if (imgTagCount >= 1) {
      this.setState({
        altQueTextVisible: true,
        imgTagCount: imgTagCount,
      });
    }
    if (imgTagCount < 1) {
      this.setState({
        altQueTextVisible: false,
        //altQuestionTextEditorObj :'',
        imgTagCount: imgTagCount,
      });
    }
    //
    if (this.props.onChange) {
      this.props.onChange(TextEditor.getHTMLStringFromEditorState(value));
    }
  };

  onBelowVectorQuestion = (value) => {
    let vectorBelowGridTextEditorObj = TextEditor.getHTMLStringFromEditorState(this.state.vectorBelowGridTextEditorObj)
    this.setState({ vectorBelowGridTextEditorObj: value });
    
    let enteredString = TextEditor.getHTMLStringFromEditorState(
      value
      );
    this.setState({vectorBelowQuestionText: enteredString})
  }


  onAltQuestionTextChange = (value) => {
    this.setState({ altQuestionTextEditorObj: value });
    //
    let enteredString = this.state.altQuestionTextEditorObj;
    //
    if (enteredString !== null) {
      this.setState({ altQuestionText: enteredString });
    }
  };
  selectBoxSubjectHandleChange(event) {
    //
    //this.setState({selectBoxTopicValue: event.target.value});

    var sub_id = parseInt(event.target.value, 10);
    this.setState({
      subjectId: sub_id,
      showTopicsSelectBox: false,
      showCategorySelectBox: false,
      showSubCategorySelectBox: false,
      topicId: null,
      categoryId: null,
      subcategoryId: null,
      topicDefaultId: 0,
    });

    this.loadTopicData(sub_id);
  }

  loadTopicData(sub_id) {
    //
    this.setState({ subjectId: sub_id });
    var tempTopic = [];
    const payload = {
      // subject_id: this.state.subject_id
      subject_id: sub_id,
    };
    //
    ApiRequestService({
      method: "post",
      url: "/getAllTopics",
      data: payload,
    }).then((res) => {
      //

      if (res.data.data.topic_names !== null) {
        tempTopic = res.data.data.topic_names;
        this.setState({
          topics: tempTopic,
          showTopicsSelectBox: true,
        });
        //this.selectBoxTopicHandleChange(this.createFakeEvent(tempTopic[0].topic_id));
      } else {
        this.setState({
          topics: [],
        });
        // this.selectBoxTopicHandleChange(this.createFakeEvent(-1));
      }
    });
  }
  selectBoxTopicHandleChange(event) {
    //
    this.setState({
      showCategorySelectBox: false,
      showSubCategorySelectBox: false,
      categoryId: null,
      subcategoryId: null,
      categoryDefaultId: 0,
    });
    var sub_id = parseInt(this.state.subjectId, 10);
    var top_id = parseInt(event.target.value, 10);
    this.loadCategory(sub_id, top_id);
  }
  createFakeEvent(id) {
    var fakeEvent = {};
    fakeEvent["target"] = {};
    fakeEvent.target.value = id;
    return fakeEvent;
  }

  loadCategory(sub_id, top_id) {
    this.setState({ topicId: top_id });
    const payload = {
      topic_id: top_id,
      subject_id: sub_id,
    };
    ////
    ApiRequestService({
      method: "post",
      url: "/getAllCategories",
      data: payload,
    }).then((res) => {
      //
      if (res.data.data.category_names !== null) {
        this.setState({
          categories: res.data.data.category_names,
          showCategorySelectBox: true,
        });

        //this.selectBoxCategoryHandleChange(this.createFakeEvent(res.data.data.category_names[0].category_id));
      } else {
        this.setState({
          categories: [],
        });
        // this.selectBoxCategoryHandleChange(this.createFakeEvent(-1));
      }
    });
  }
  selectBoxCategoryHandleChange(event) {
    ////

    var sub_id = parseInt(this.state.subjectId, 10);
    var top_id = parseInt(this.state.topicId, 10);
    var cat_id = parseInt(event.target.value, 10);
    this.setState({
      showSubCategorySelectBox: false,
      subcategoryId: null,
      subCategoryDefaultId: 0,
    });
    this.loadSubcategory(sub_id, top_id, cat_id);
  }

  loadSubcategory(sub_id, top_id, cat_id) {
    this.setState({ categoryId: cat_id });
    const payload = {
      topic_id: top_id,
      subject_id: sub_id,
      category_id: cat_id,
    };

    ApiRequestService({
      method: "post",
      url: "/getAllSubCategories",
      data: payload,
    }).then((res) => {
      ////
      if (res.data.data.subCategory_names !== null) {
        this.setState({
          subCategories: res.data.data.subCategory_names,
          showSubCategorySelectBox: true,
        });
      } else {
        this.setState({
          subCategories: [],
        });
      }
    });
  }
  selectBoxSubcategoryHandleChange(event) {
    this.setState({ subcategoryId: parseInt(event.target.value, 10) });
  }
  selectBoxMultipleChoiceHandleChange(event) {
    ////
    var tempMultipleChoice = parseInt(event.target.value, 10);
    tempMultipleChoice = event.target.value;

    this.setState({ multipleChoice: tempMultipleChoice });
    //
  }

  generateRandomValuesForPreview() {
    //Generate Dynamic Variable Values
    if (this.state.questionType === 1 || (this.state.questionType === 3 && [50, 60, 3].includes(this.state.defaultAnswerType))) {
      if (this.state.variablesMap && this.state.variablesMap.isValid()) {
        this.state.variablesMap.generateValues();
      }
    }
    this.setState({ isQuestionWithPreview: true });
  }

  generateRPAnswer() {
      if (this.state.variablesMap && this.state.variablesMap.isValid()) {
        this.state.variablesMap.generateValues();
      }
      if(this.state.defaultAnswerType !== 2 && this.state.answerArrList.length > 0){
        let RPAnswerArr = this.stringToValueRPAnswer(JSON.parse(
          JSON.stringify(this.state.answerArrList)
        ))
          let shouldRandomize = false;
          let firstAttempt = true;
          let i = 0;
          do{
            if(firstAttempt){
              shouldRandomize = MathParserUtil.shouldRandomize(RPAnswerArr);
            }
            if(shouldRandomize){
              this.generateRandomValuesForPreview();
            }
            RPAnswerArr = this.stringToValueRPAnswer(JSON.parse(
              JSON.stringify(this.state.answerArrList)
            ));
            shouldRandomize = MathParserUtil.shouldRandomize(RPAnswerArr);
            firstAttempt=false;
            i++;
            //For Avoid Crashing
            if(i>=10){
              console.log("Randomized Continously.. Crash State..")
              break;
            }
          }while(shouldRandomize);
      }
      this.setState({ isQuestionWithPreview: true });
  }

  previewQuestion(canReload) {
    var isQuestionWithPreview = true;
    this.generateRandomValuesForPreview();
    this.setState({ isQuestionWithPreview: isQuestionWithPreview });
    
    if(canReload === '' || canReload === undefined ) {
      this.generateRandomisedAnswer();
    } else {
      this.loadVectors();
    }
  }

  loadVectors = () => {
    console.log('loadVectors')
    if(this.canvasRef.current) {
      this.setState({
        vectorState: this.optimizeVectorVariableValues(),
      }, () => {
        this.canvasRef.current.drawVectors({
          vectors: this.optimizeVectorVariableValues(this.state.vectorState, true),
          updatedGridStepSize: this.state.vectorSettingsData.stepSize
        });
      });

      setTimeout(() => {
        this.setState({ generateRandomOrigin: true, questionCanvasComponentGuid: GetNewComponentGuid(), answerCanvasComponentGuid: GetNewComponentGuid() });
      }, 500);
    }

  };

  previewExit() {
    var isQuestionWithPreview = false;
    this.setState({ isQuestionWithPreview: isQuestionWithPreview });
  }

  generateRandomisedAnswer() {
    if(this.state.questionType === 3){
      //Vector Type Questions
      if(this.canvasRef.current) {
        this.setState({
          vectorState: this.optimizeVectorVariableValues()
        }, () => {
          this.canvasRef.current.drawVectors({
            vectors: this.optimizeVectorVariableValues(this.state.vectorState, "randomize"),
            updatedGridStepSize: this.state.vectorSettingsData.stepSize
          });
          this.setState({ questionCanvasComponentGuid: GetNewComponentGuid(), generateRandomOrigin: true,  answerCanvasComponentGuid: GetNewComponentGuid()});
          let answerArrList = [...this.state.answerArrList];
          const {widthUnit,heightUnit} = this.state.vectorSettingsData;
          const gridwidth = parseInt(widthUnit,10);
          const gridheight = parseInt(heightUnit,10);
  
          if (answerArrList && answerArrList.length > 1) {
            let newAnswerlistArr = this.onGenerateAnswerVector(answerArrList)
            //console.log("answer vectors is same so randomizing now..not!!!!!", newAnswerlistArr)
            let shouldRandomize = false;
            let firstAttempt = true;
            let i=0;
            do{
              if(firstAttempt){
                shouldRandomize = VectorParserUtil.shouldRandomize(newAnswerlistArr, gridwidth, gridheight);
              }
              if(shouldRandomize){
                  console.log("answer vectors is same so randomizing now..")
                  this.RandomizeQuestionVector();
                  newAnswerlistArr = this.onGenerateAnswerVector(answerArrList);
                  //console.log("answer vectors is same so randomizing now..after!!!!!", newAnswerlistArr)
                }
              shouldRandomize = VectorParserUtil.shouldRandomize(newAnswerlistArr, gridwidth, gridheight);
              firstAttempt=false;
              i++;
                //For Avoid Crashing
                if(i>=10){
                  console.log("answer vectors is same so randomizing now..crashing state!!")
                  break;
                }
            }while(shouldRandomize);
          }
        })
      }
    }else if(this.state.questionType === 1 || (this.state.questionType === 3 && [50, 60].includes(this.state.defaultAnswerType))){
      //RP Type Questions
      this.generateRPAnswer();
    }
  }

  answerRefreshCallback() {
    setTimeout(() => {
      this.setState({ generateRandomOrigin: true, answerCanvasComponentGuid: GetNewComponentGuid() });
    }, 100);
  }

  stringToValueRPAnswer = (tempAnswerArrayList) => {
      let RPAnswerArr = [];
      for(let x=0;x<tempAnswerArrayList.length;x++){
        if(tempAnswerArrayList[x]?.answer_text && tempAnswerArrayList[x]?.answer_display_options){
          let map = this.state.variablesMap;
          if (this.state.questionType === 3 && [50, 60, 3].includes(this.state.defaultAnswerType)) {
            map = this.state.vectorVariablesMap;
          }
          console.debug("mapmap>>>>>>", map);
          let answerText = MathParserUtil.computeFormula(
            tempAnswerArrayList[x].answer_text,
            map,
            tempAnswerArrayList[x].answer_display_options
          );
          RPAnswerArr.push(answerText?.replace(/(<([^>]+)>)/ig,"").trim())
        }
      }
      return RPAnswerArr;
  }

  onAnswerTextChange = (index, value) => {
    console.log('Changing the answer text', index, value)
    
    var tempAnswerArrayList = JSON.parse(
      JSON.stringify(this.state.answerArrList)
    );

    //let enteredString = JSON.parse(value.toString('html',null)).blocks[0].text ;
    let enteredString = TextEditor.getHTMLStringFromEditorState(value);

     //
     if (
      tempAnswerArrayList[index] !== undefined &&
      tempAnswerArrayList[index] !== null
    ) {
      tempAnswerArrayList[index].answer_text = enteredString;
      //this.setState({ answerArrList: tempAnswerArrayList });
    } else {
      tempAnswerArrayList[index] = {
        answer_type: 0,
        answer_text: "",
        alt_answer_text: "",
        question_id: 0,
        is_answer: 0,
        answer_id: 0,
        feedback_text: "",
        alt_feedback_text: "",
        enable_alt_ans_text: 0,
      };
      tempAnswerArrayList[index].key = index;
      tempAnswerArrayList[index].answer_text = enteredString;
      //this.setState({ answerArrList: tempAnswerArrayList });
    }

    if ((this.state.questionType === 1 && this.state.defaultAnswerType !== 2)
    || [50, 60].includes(this.state.defaultAnswerType)) {
      const newAnswerArr = tempAnswerArrayList.filter(data => data !== null)
      const answerTextArr = newAnswerArr.map(data => data.answer_text.trim() !== "" ? data.answer_text.replace(/(<([^>]+)>)/ig,"").trim(): undefined)
      console.debug("answerTextArr", answerTextArr)
      const filteredAnswerArr = answerTextArr.filter(data => data !== undefined);
      let isFormulaRepeated = MathParserUtil.shouldRandomize(filteredAnswerArr); 
      if(isFormulaRepeated){
        const answer_warning_text = MathParserUtil.checkAnswerFormula(answerTextArr)
        NotificationManager.error(
          answer_warning_text,
          `Error in Answer-${index+1}`,
          5000
        );
        return
      }
    }

    var tempArray = this.state.textEditorObjAns.slice();
    if (tempArray[index] === undefined || tempArray[index] == null) {
      tempArray[index] = { value: TextEditor.createEmptyValue() };
    }
    tempArray[index].value = value;
    this.setState({ textEditorObjAns: tempArray });
    //Randomized Parameters
    if (this.state.questionType === 1 || (this.state.questionType === 3 && [50, 60, 3].includes(this.state.defaultAnswerType))) {
      //this.answerListVarMap
      this.answerListVarMap[index] = MathParserUtil.getVariablesFromText(
        enteredString,
        this.answerListVarMap[index]
      );
    }

    this.setState({ answerArrList: tempAnswerArrayList }, ()=>{
      if ((this.state.questionType === 1 && this.state.defaultAnswerType !== 2)
        || (this.state.questionType === 3 && [50, 60].includes(this.state.defaultAnswerType))) {

        let RPAnswerArr = this.stringToValueRPAnswer(tempAnswerArrayList)
        console.log("RPAnswerArr", RPAnswerArr)
        let shouldRandomize = false;
        let firstAttempt = true;
        let i = 0;
        do{
          if(firstAttempt){
            shouldRandomize = MathParserUtil.shouldRandomize(RPAnswerArr);
            console.log("RPAnswerArr1", shouldRandomize)
          }
          if(shouldRandomize){
            console.log("RP Answers is same so randomizing now..")
            this.generateRandomValuesForPreview();
          }
          RPAnswerArr = this.stringToValueRPAnswer(JSON.parse(
            JSON.stringify(this.state.answerArrList)
          ));
          console.log("RPAnswerArr2", RPAnswerArr)
          shouldRandomize = MathParserUtil.shouldRandomize(RPAnswerArr);
          console.log("RPAnswerArr3", shouldRandomize)
          firstAttempt=false;
          i++;
          //For Avoid Crashing
          if(i>=10){
            console.log("Randomized Continously.. Crash State..")
            break;
          }
        }while(shouldRandomize);
      }
    });
    
    var tempAnsList = this.state.answerList.slice();
    console.log(
      "this.state.answerArrList[index] - ",
      this.state.answerArrList[index]
    );
    tempAnsList[index] = (
      <Answer
        key={index}
        index={index}
        answerText={"Answer " + (index + 1)}
        answerButton={styles.answerButton}
        correctAnswerSwitch={styles.correctAnswerSwitch}
        correctAnswer={styles.correctAnswer}
        deleteAnswerButton={styles.deleteAnswerButton}
        onAnswerTextChange={this.onAnswerTextChange.bind(this, index)}
        AnswerValue={this.state.textEditorObjAns[index]}
        size={this.state.isQuestionWithPreview ? 10 : 6}
        answerDelete={this.answerDelete.bind(this, index)}
        correctAnswerOnChange={this.correctAnswerOnChange.bind(this, index)}
        answerSwitchValue={
          this.state.answerArrList[index] !== undefined &&
          this.state.answerArrList[index] !== null
            ? this.state.answerArrList[index].is_answer
            : 0
        }
        feedbackVisible={this.state.feedbackVisibility}
        isRandomized={this.state.questionType === 1 || [50, 60].includes(this.state.defaultAnswerType)}
        feedbackText={"Feedback for Answer " + (index + 1)}
        onFeedbackTextChange={this.onFeedbackTextChange.bind(this, index)}
        FeedbackValue={this.state.textEditorObjFeed[index]}
        AltAnswerValue={this.state.textEditorObjAltAns[index]}
        onAltAnswerTextChange={this.onAltAnswerTextChange.bind(this, index)}
        AltFeedbackValue={this.state.textEditorObjAltFeedback[index]}
        onAltFeedbackTextChange={this.onAltFeedbackTextChange.bind(this, index)}
        answer_display_options={getAnswerDisplayOption(this.state.defaultAnswerType,
          this.state.questionType,
          this.state.answerArrList[index],
          index
        )}
        vectorAnswerFormula={getVectorAnswerFormula(
          this.state.questionType,
          this.state.answerArrList[index],
          index
        )}
        onAnswerDisplayOptionsChange={this.onAnswerDisplayOptionsChange}
        onVectorAnswerChange={this.onVectorAnswerChange}
        questionNonGraded={this.state.questionNonGraded}
        questionType={this.state.questionType}
        defaultAnswerType={this.state.defaultAnswerType}
        questionVectorTableMap={this.state.variablesMap}
        vectorVariablesMap={this.state.vectorVariablesMap}
        vectorAnswerVariablesMap={this.state.answerArrList[index]?.vectorAnswerVariable ? this.state.answerArrList[index]?.vectorAnswerVariable 
          : VectorParserUtil.createDefaultVectorVariableMap(this.state.vectorAnswerVariablesMap,this.state.vectorSettingsData,"")}
        onAddVectorAnswer={this.onAddVectorAnswer}
        onRemoveVectorAnswer={this.onRemoveVectorAnswer}
        vectorAnswerVariable={ this.state.answerArrList[index]?.vectorAnswerVariable ? this.state.answerArrList[index]?.vectorAnswerVariable :
           [VectorParserUtil.createDefaultVectorVariable(VectorSettingsData,"")]}
           onVectorAnswerVariableChange={this.onVectorVariableChange}
        //altAnsTextVisible={this.state.answerArrList[index].enable_alt_ans_text}
        // altAnsTextVisibleOnChange={this.altAnsTextVisibleOnChange.bind(this, index)}
      />
    );

    this.setState({ answerList: tempAnsList });
  };

  onQuestionVariableChange = (value) => {
    let updatedAnswerArrListTemp = this.state.answerArrList;
    if (updatedAnswerArrListTemp && updatedAnswerArrListTemp.length > 0) {
      updatedAnswerArrListTemp.forEach((answer, index) => {
      if (answer !== null) {
              updatedAnswerArrListTemp[index] = {
                  ...answer,
                  answer_display_options: {
                      ...answer.answer_display_options,
                      sigFig: value,
                  },
              };
          }
      });
      this.setState({ answerArrList: updatedAnswerArrListTemp });
      this.answerTextDisplay();
    }
};
  onAnswerDisplayOptionsChange = (index, value) => {
    let answerArrList = this.state.answerArrList;

    if (answerArrList && answerArrList.length > 0) {
      answerArrList[index].answer_display_options = value;
      this.setState({ answerArrList });
    }
  };

  vectorAutoPlaceOrigin = (vectorAnswerFormula) => {
    
      const vectorsMap = this.state.vectorVariablesMap;
      const {widthUnit,heightUnit} = this.state.vectorSettingsData;
      const gridwidth = parseInt(widthUnit,10);
      const gridheight = parseInt(heightUnit,10);
      if(vectorAnswerFormula){
        const maxBoundVector = VectorParserUtil.generateAnswerVector(vectorAnswerFormula,vectorsMap,"Max", this.state.vectorSettingsData);
        const xorigin = (gridwidth/2 - maxBoundVector.x/2).toFixed(0);
        const yorigin = (gridheight/2 - maxBoundVector.y/2).toFixed(0);

        return {...vectorAnswerFormula,posX:xorigin,posY:yorigin};
      }
        return vectorAnswerFormula;
   }

  RandomizeQuestionVector = () => {
    const vectorSettingsData = this.state.vectorSettingsData;
    const newVectorValues = this.state.vectorVariablesMap?this.state.vectorVariablesMap.getVectorsArray(vectorSettingsData.widthUnit, vectorSettingsData.heightUnit, vectorSettingsData.enableIdenticalVector):[];
    if(newVectorValues && newVectorValues.length > 0) {
      if(this.canvasRef.current) {
        this.canvasRef.current.drawVectors({
          vectors: newVectorValues,
          updatedGridStepSize: this.state.vectorSettingsData.stepSize
        });
      }
      //setTimeout(() => {
        this.setState({ questionCanvasComponentGuid: GetNewComponentGuid(), generateRandomOrigin: true,  answerCanvasComponentGuid: GetNewComponentGuid()})
      //}, 10);
    }
  }

  onGenerateAnswerVector = (answerArrList) => {
    let newAnswerlistArr = answerArrList.map((answerlist) => {
      if(answerlist && answerlist.vectorAnswerFormula){
        let vectorAns = VectorParserUtil.generateAnswerVector(
          answerlist.vectorAnswerFormula,
          this.state.vectorVariablesMap,
          "",
          this.state.vectorSettingsData
        );
        return vectorAns;
      }
      return null;
    })

    return newAnswerlistArr;

  }

  onVectorAnswerChange = (index, _value) => {
    let answerArrList = [...this.state.answerArrList];

    if (this.state.questionType === 3 || (this.state.questionType === 0 && [70,80,90].includes(this.state.defaultAnswerType) )) {
      for (let ansIndex = 0; ansIndex < answerArrList.length; ansIndex++) {
        const element = answerArrList[ansIndex];
        if(element === undefined || element == null) {
          answerArrList[ansIndex] = answerArrListJsonFunction(ansIndex);
        }
      };
    }
    
    let value;
    if(_value.autoOrigin == true){
      value = this.vectorAutoPlaceOrigin(_value);
    }else{
      value = {..._value,posX:_value.xOrigin,posY:_value.yOrigin};
    }

    //console.log("//Answer Values=",value)
    const answer_warning_text = VectorParserUtil.testAnswerBounds({vectorAnswerFormula:value},this.state.vectorSettingsData,this.state.vectorVariablesMap);
    if(answer_warning_text && answer_warning_text.length > 0 ){
      NotificationManager.error(
        answer_warning_text,
        `Error in ${value.name}`,
        5000
      );
    }
    const {widthUnit,heightUnit} = this.state.vectorSettingsData;
    const gridwidth = parseInt(widthUnit,10);
    const gridheight = parseInt(heightUnit,10);
      //Vector ${vector_element.name} is going outside the grid. Please change the origin or the range values.
      if(!value.autoOrigin){
        if(0<= value.xOrigin && value.xOrigin >= gridwidth){
          NotificationManager.error(
            'The vector goes outside the grid. Please change the x-origin value',
            `Error in ${value.name}`,
            5000
          );
        }
        if(0<= value.yOrigin && value.yOrigin >= gridheight){
          NotificationManager.error(
            'The vector goes outside the grid. Please change the y-origin value',
            `Error in ${value.name}`,
            5000
          );
        }
      }

      if (answerArrList && answerArrList.length > 1 && answerArrList[index]) {
        answerArrList[index].vectorAnswerFormula = value;
        let newAnswerlistArr = this.onGenerateAnswerVector(answerArrList)
        const answer_warning_text = VectorParserUtil.checkAnswerFormula(answerArrList);
        if(answer_warning_text && answer_warning_text.length > 0 ){
          NotificationManager.error(
            answer_warning_text,
            `Error in ${value.name}`,
            5000
          );
          return
        } 
        let shouldRandomize = false;
        let firstAttempt = true;
        let i = 0;
        do{
          if(firstAttempt){
            shouldRandomize = VectorParserUtil.shouldRandomize(newAnswerlistArr, gridwidth, gridheight);
          }
          if(shouldRandomize){
            console.log("Answer vectors is same so randomizing now..")
            this.RandomizeQuestionVector();
            newAnswerlistArr = this.onGenerateAnswerVector(answerArrList);
          }
          shouldRandomize = VectorParserUtil.shouldRandomize(newAnswerlistArr, gridwidth, gridheight);
          firstAttempt=false;
          i++;
          //For Avoid Crashing
          if(i>=10){
            break;
          }
        }while(shouldRandomize);
      }
      
    if (answerArrList && answerArrList.length > 0 && answerArrList[index]) {
      answerArrList[index].vectorAnswerFormula = value;

      this.setState({ answerArrList });

      var tempAnsList = this.state.answerList.slice();
      tempAnsList[index] = (
        <Answer
          key={index}
          index={index}
          answerText={"Answer " + (index + 1)}
          answerButton={styles.answerButton}
          correctAnswerSwitch={styles.correctAnswerSwitch}
          correctAnswer={styles.correctAnswer}
          deleteAnswerButton={styles.deleteAnswerButton}
          onAnswerTextChange={this.onAnswerTextChange.bind(this, index)}
          AnswerValue={this.state.textEditorObjAns[index]}
          size={this.state.isQuestionWithPreview ? 10 : 6}
          answerDelete={this.answerDelete.bind(this, index)}
          correctAnswerOnChange={this.correctAnswerOnChange.bind(this, index)}
          answerSwitchValue={
            this.state.answerArrList[index] !== undefined &&
            this.state.answerArrList[index] !== null
              ? this.state.answerArrList[index].enable_alt_ans_text
              : 0
          }
          feedbackVisible={this.state.feedbackVisibility}
          isRandomized={this.state.questionType === 1 || [50, 60].includes(this.state.defaultAnswerType)}
          feedbackText={"Feedback for Answer " + (index + 1)}
          onFeedbackTextChange={this.onFeedbackTextChange.bind(this, index)}
          FeedbackValue={this.state.textEditorObjFeed[index]}
          AltAnswerValue={this.state.textEditorObjAltAns[index]}
          onAltAnswerTextChange={this.onAltAnswerTextChange.bind(this, index)}
          AltFeedbackValue={this.state.textEditorObjAltFeedback[index]}
          onAltFeedbackTextChange={this.onAltFeedbackTextChange.bind(
            this,
            index
          )}
          answer_display_options={getAnswerDisplayOption(this.state.defaultAnswerType,
            this.state.questionType,
            this.state.answerArrList[index],
            index
          )}
          vectorAnswerFormula={value}
          onAnswerDisplayOptionsChange={this.onAnswerDisplayOptionsChange}
          onVectorAnswerChange={this.onVectorAnswerChange}
          questionNonGraded={this.state.questionNonGraded}
          questionType={this.state.questionType}
          defaultAnswerType={this.state.defaultAnswerType}
          questionVectorTableMap={this.state.variablesMap}
          vectorVariablesMap={this.state.vectorVariablesMap}
          vectorAnswerVariablesMap={this.state.answerArrList[index]?.vectorAnswerVariable ? this.state.answerArrList[index]?.vectorAnswerVariable 
            : VectorParserUtil.createDefaultVectorVariableMap(this.state.vectorAnswerVariablesMap,this.state.vectorSettingsData,"")}
          onAddVectorAnswer={this.onAddVectorAnswer}
          onRemoveVectorAnswer={this.onRemoveVectorAnswer}
          vectorAnswerVariable={ this.state.answerArrList[index]?.vectorAnswerVariable ? this.state.answerArrList[index]?.vectorAnswerVariable :
             [VectorParserUtil.createDefaultVectorVariable(VectorSettingsData,"")]}
             onVectorAnswerVariableChange={this.onVectorVariableChange}
        />
      );

      this.setState({ answerList: tempAnsList }, () => {
        
        this.answerRefreshCallback()
      });
    }
  };

  onAltAnswerTextChange = (index, value) => {
    //
    //
    //

    var tempAltAnsArray = this.state.textEditorObjAltAns.slice();
    if (
      tempAltAnsArray[index] === undefined ||
      tempAltAnsArray[index] == null
    ) {
      tempAltAnsArray[index] = { value: TextEditor.createEmptyValue() };
    }
    tempAltAnsArray[index].value = value;
    this.setState({ textEditorObjAltAns: tempAltAnsArray });

    var tempAnswerArrayList = JSON.parse(
      JSON.stringify(this.state.answerArrList)
    );

    //let enteredString = JSON.parse(value.toString('html',null)).blocks[0].text ;
    let enteredString = value;
    //
    if (
      tempAnswerArrayList[index] !== undefined &&
      tempAnswerArrayList[index] !== null
    ) {
      tempAnswerArrayList[index].alt_answer_text = enteredString;
      this.setState({ answerArrList: tempAnswerArrayList });
    } else {
      tempAnswerArrayList[index] = {
        answer_type: 0,
        answer_text: "",
        alt_answer_text: "",
        question_id: 0,
        is_answer: 0,
        answer_id: 0,
        feedback_text: "",
        alt_feedback_text: "",
        enable_alt_ans_text: 0,
      };
      tempAnswerArrayList[index].key = index;
      tempAnswerArrayList[index].alt_answer_text = enteredString;
      this.setState({ answerArrList: tempAnswerArrayList });
    }

    var tempAnsList = this.state.answerList.slice();
    tempAnsList[index] = (
      <Answer
        key={index}
        index={index}
        answerText={"Answer " + (index + 1)}
        answerButton={styles.answerButton}
        correctAnswerSwitch={styles.correctAnswerSwitch}
        correctAnswer={styles.correctAnswer}
        deleteAnswerButton={styles.deleteAnswerButton}
        onAnswerTextChange={this.onAnswerTextChange.bind(this, index)}
        AnswerValue={this.state.textEditorObjAns[index]}
        size={this.state.isQuestionWithPreview ? 10 : 6}
        answerDelete={this.answerDelete.bind(this, index)}
        correctAnswerOnChange={this.correctAnswerOnChange.bind(this, index)}
        answerSwitchValue={
          this.state.answerArrList[index] !== undefined &&
          this.state.answerArrList[index] !== null
            ? this.state.answerArrList[index].enable_alt_ans_text
            : 0
        }
        feedbackVisible={this.state.feedbackVisibility}
        isRandomized={this.state.questionType === 1 || [50, 60].includes(this.state.defaultAnswerType)}
        feedbackText={"Feedback for Answer " + (index + 1)}
        onFeedbackTextChange={this.onFeedbackTextChange.bind(this, index)}
        FeedbackValue={this.state.textEditorObjFeed[index]}
        AltAnswerValue={this.state.textEditorObjAltAns[index]}
        onAltAnswerTextChange={this.onAltAnswerTextChange.bind(this, index)}
        AltFeedbackValue={this.state.textEditorObjAltFeedback[index]}
        onAltFeedbackTextChange={this.onAltFeedbackTextChange.bind(this, index)}
        answer_display_options={getAnswerDisplayOption(this.state.defaultAnswerType,
          this.state.questionType,
          this.state.answerArrList[index],
          index
        )}
        vectorAnswerFormula={getVectorAnswerFormula(
          this.state.questionType,
          this.state.answerArrList[index],
          index
        )}
        onAnswerDisplayOptionsChange={this.onAnswerDisplayOptionsChange}
        onVectorAnswerChange={this.onVectorAnswerChange}
        questionNonGraded={this.state.questionNonGraded}
        questionType={this.state.questionType}
        defaultAnswerType={this.state.defaultAnswerType}
        questionVectorTableMap={this.state.variablesMap}
        vectorVariablesMap={this.state.vectorVariablesMap}
        vectorAnswerVariablesMap={this.state.answerArrList[index]?.vectorAnswerVariable ? this.state.answerArrList[index]?.vectorAnswerVariable 
          : VectorParserUtil.createDefaultVectorVariableMap(this.state.vectorAnswerVariablesMap,this.state.vectorSettingsData,"")}
        onAddVectorAnswer={this.onAddVectorAnswer}
        onRemoveVectorAnswer={this.onRemoveVectorAnswer}
        vectorAnswerVariable={ this.state.answerArrList[index]?.vectorAnswerVariable ? this.state.answerArrList[index]?.vectorAnswerVariable :
           [VectorParserUtil.createDefaultVectorVariable(VectorSettingsData,"")]}
           onVectorAnswerVariableChange={this.onVectorVariableChange}
        /* altAnsTextVisible={ this.state.answerArrList[index] !== undefined &&
          this.state.answerArrList[index] !== null
            ? this.state.answerArrList[index].enable_alt_ans_text
            : 0}
        altAnsTextVisibleOnChange={this.altAnsTextVisibleOnChange.bind(this, index)}*/
      />
    );

    this.setState({ answerList: tempAnsList });
  };

  onAltFeedbackTextChange = (index, value) => {
    //
    //
    //

    console.log('On feedback text change')

    var tempAltFeedbackArray = this.state.textEditorObjAltFeedback.slice();
    if (
      tempAltFeedbackArray[index] === undefined ||
      tempAltFeedbackArray[index] == null
    ) {
      tempAltFeedbackArray[index] = { value: TextEditor.createEmptyValue() };
    }
    tempAltFeedbackArray[index].value = value;
    this.setState({ textEditorObjAltFeedback: tempAltFeedbackArray });

    var tempAnswerArrayList = JSON.parse(
      JSON.stringify(this.state.answerArrList)
    );

    //let enteredString = JSON.parse(value.toString('html',null)).blocks[0].text ;
    let enteredString = value;
    //
    if (
      tempAnswerArrayList[index] !== undefined &&
      tempAnswerArrayList[index] !== null
    ) {
      tempAnswerArrayList[index].alt_feedback_text = enteredString;
      this.setState({ answerArrList: tempAnswerArrayList });
    } else {
      tempAnswerArrayList[index] = {
        answer_type: 0,
        answer_text: "",
        alt_answer_text: "",
        question_id: 0,
        is_answer: 0,
        answer_id: 0,
        feedback_text: "",
        alt_feedback_text: "",
        enable_alt_ans_text: 0,
      };
      tempAnswerArrayList[index].key = index;
      tempAnswerArrayList[index].alt_feedback_text = enteredString;
      this.setState({ answerArrList: tempAnswerArrayList });
    }

    var tempAnsList = this.state.answerList.slice();
    tempAnsList[index] = (
      <Answer
        key={index}
        index={index}
        answerText={"Answer " + (index + 1)}
        answerButton={styles.answerButton}
        correctAnswerSwitch={styles.correctAnswerSwitch}
        correctAnswer={styles.correctAnswer}
        deleteAnswerButton={styles.deleteAnswerButton}
        onAnswerTextChange={this.onAnswerTextChange.bind(this, index)}
        AnswerValue={this.state.textEditorObjAns[index]}
        size={this.state.isQuestionWithPreview ? 10 : 6}
        answerDelete={this.answerDelete.bind(this, index)}
        correctAnswerOnChange={this.correctAnswerOnChange.bind(this, index)}
        answerSwitchValue={
          this.state.answerArrList[index] !== undefined &&
          this.state.answerArrList[index] !== null
            ? this.state.answerArrList[index].enable_alt_ans_text
            : 0
        }
        feedbackVisible={this.state.feedbackVisibility}
        isRandomized={this.state.questionType === 1 || [50, 60].includes(this.state.defaultAnswerType)}
        feedbackText={"Feedback for Answer " + (index + 1)}
        onFeedbackTextChange={this.onFeedbackTextChange.bind(this, index)}
        FeedbackValue={this.state.textEditorObjFeed[index]}
        AltAnswerValue={this.state.textEditorObjAltAns[index]}
        onAltAnswerTextChange={this.onAltAnswerTextChange.bind(this, index)}
        AltFeedbackValue={this.state.textEditorObjAltFeedback[index]}
        onAltFeedbackTextChange={this.onAltFeedbackTextChange.bind(this, index)}
        answer_display_options={getAnswerDisplayOption(this.state.defaultAnswerType,
          this.state.questionType,
          this.state.answerArrList[index],
          index
        )}
        vectorAnswerFormula={getVectorAnswerFormula(
          this.state.questionType,
          this.state.answerArrList[index],
          index
        )}
        onAnswerDisplayOptionsChange={this.onAnswerDisplayOptionsChange}
        onVectorAnswerChange={this.onVectorAnswerChange}
        questionNonGraded={this.state.questionNonGraded}
        questionType={this.state.questionType}
        defaultAnswerType={this.state.defaultAnswerType}
        questionVectorTableMap={this.state.variablesMap}
        vectorVariablesMap={this.state.vectorVariablesMap}
        vectorAnswerVariablesMap={this.state.answerArrList[index]?.vectorAnswerVariable ? this.state.answerArrList[index]?.vectorAnswerVariable 
          : VectorParserUtil.createDefaultVectorVariableMap(this.state.vectorAnswerVariablesMap,this.state.vectorSettingsData,"")}
        onAddVectorAnswer={this.onAddVectorAnswer}
        onRemoveVectorAnswer={this.onRemoveVectorAnswer}
        vectorAnswerVariable={ this.state.answerArrList[index]?.vectorAnswerVariable ? this.state.answerArrList[index]?.vectorAnswerVariable :
           [VectorParserUtil.createDefaultVectorVariable(VectorSettingsData,"")]}
           onVectorAnswerVariableChange={this.onVectorVariableChange}
        /* altAnsTextVisible={ this.state.answerArrList[index] !== undefined &&
          this.state.answerArrList[index] !== null
            ? this.state.answerArrList[index].enable_alt_ans_text
            : 0}
        altAnsTextVisibleOnChange={this.altAnsTextVisibleOnChange.bind(this, index)}*/
      />
    );

    this.setState({ answerList: tempAnsList });
  };
  //OnFeedbacktextchange
  onFeedbackTextChange = (index, value) => {
    //
    //
    //
    console.log('onFeedbackTextChange');
    var tempArray = this.state.textEditorObjFeed.slice();
    if (tempArray[index] === undefined || tempArray[index] == null) {
      tempArray[index] = { value: TextEditor.createEmptyValue() };
    }
    tempArray[index].value = value;
    this.setState({ textEditorObjFeed: tempArray });

    var tempAnswerArrayList = JSON.parse(
      JSON.stringify(this.state.answerArrList)
    );

    //let enteredString = JSON.parse(value.toString('html',null)).blocks[0].text ;
    let enteredString = TextEditor.getHTMLStringFromEditorState(value);
    //
    //
    const rawDraftContentState = JSON.stringify(
      convertToRaw(value.getCurrentContent())
    );
    //
    //
    if (
      tempAnswerArrayList[index] !== undefined &&
      tempAnswerArrayList[index] !== null
    ) {
      tempAnswerArrayList[index].feedback_text = rawDraftContentState;
      //
      this.setState({ answerArrList: tempAnswerArrayList });
    } else {
      tempAnswerArrayList[index] = {
        answer_type: 0,
        answer_text: "",
        alt_answer_text: "",
        question_id: 0,
        is_answer: 0,
        answer_id: 0,
        feedback_text: "",
        alt_feedback_text: "",
        enable_alt_ans_text: 0,
      };
      tempAnswerArrayList[index].key = index;
      tempAnswerArrayList[index].feedback_text = enteredString;
      this.setState({ answerArrList: tempAnswerArrayList });
    }
    //

    var tempAnsList = this.state.answerList.slice();
    tempAnsList[index] = (
      <Answer
        key={index}
        index={index}
        answerText={"Answer " + (index + 1)}
        answerButton={styles.answerButton}
        correctAnswerSwitch={styles.correctAnswerSwitch}
        correctAnswer={styles.correctAnswer}
        deleteAnswerButton={styles.deleteAnswerButton}
        onAnswerTextChange={this.onAnswerTextChange.bind(this, index)}
        AnswerValue={this.state.textEditorObjAns[index]}
        size={this.state.isQuestionWithPreview ? 10 : 6}
        answerDelete={this.answerDelete.bind(this, index)}
        correctAnswerOnChange={this.correctAnswerOnChange.bind(this, index)}
        answerSwitchValue={
          this.state.answerArrList[index] !== undefined &&
          this.state.answerArrList[index] !== null
            ? this.state.answerArrList[index].is_answer
            : 0
        }
        feedbackVisible={this.state.feedbackVisibility}
        isRandomized={this.state.questionType === 1 || [50, 60].includes(this.state.defaultAnswerType)}
        feedbackText={"Feedback for Answer " + (index + 1)}
        onFeedbackTextChange={this.onFeedbackTextChange.bind(this, index)}
        FeedbackValue={this.state.textEditorObjFeed[index]}
        AltAnswerValue={this.state.textEditorObjAltAns[index]}
        onAltAnswerTextChange={this.onAltAnswerTextChange.bind(this, index)}
        AltFeedbackValue={this.state.textEditorObjAltFeedback[index]}
        onAltFeedbackTextChange={this.onAltFeedbackTextChange.bind(this, index)}
        answer_display_options={getAnswerDisplayOption(this.state.defaultAnswerType,
          this.state.questionType,
          this.state.answerArrList[index],
          index
        )}
        vectorAnswerFormula={getVectorAnswerFormula(
          this.state.questionType,
          this.state.answerArrList[index],
          index
        )}
        onAnswerDisplayOptionsChange={this.onAnswerDisplayOptionsChange}
        onVectorAnswerChange={this.onVectorAnswerChange}
        questionNonGraded={this.state.questionNonGraded}
        questionType={this.state.questionType}
        defaultAnswerType={this.state.defaultAnswerType}
        questionVectorTableMap={this.state.variablesMap}
        vectorVariablesMap={this.state.vectorVariablesMap}
        vectorAnswerVariablesMap={this.state.answerArrList[index]?.vectorAnswerVariable ? this.state.answerArrList[index]?.vectorAnswerVariable 
          : VectorParserUtil.createDefaultVectorVariableMap(this.state.vectorAnswerVariablesMap,this.state.vectorSettingsData,"")}
        onAddVectorAnswer={this.onAddVectorAnswer}
        onRemoveVectorAnswer={this.onRemoveVectorAnswer}
        vectorAnswerVariable={ this.state.answerArrList[index]?.vectorAnswerVariable ? this.state.answerArrList[index]?.vectorAnswerVariable :
           [VectorParserUtil.createDefaultVectorVariable(VectorSettingsData,"")]}

           onVectorAnswerVariableChange={this.onVectorVariableChange}
        /*altAnsTextVisible={ this.state.answerArrList[index] !== undefined &&
          this.state.answerArrList[index] !== null
            ? this.state.answerArrList[index].enable_alt_ans_text
            : 0}
        altAnsTextVisibleOnChange={this.altAnsTextVisibleOnChange.bind(this, index)}*/
      />
    );

    this.setState({ answerList: tempAnsList });
  };
  /** Image Drag and Drop + Upload Image from Files*
  setImage(src, editorReference) {
    let editorState = editorReference.props.value.getEditorState();
    let contentState = editorState.getCurrentContent();
    let selection = editorState.getSelection();

    let reader = new FileReader();
    reader.addEventListener(
      'load',
      function assignImageSrc(evt) {
        
        let imgSrc = evt.target.result;
        contentState = contentState.createEntity(
          ENTITY_TYPE.IMAGE,
          'IMMUTABLE',
          { src: imgSrc }
        );

        let entityKey = contentState.getLastCreatedEntityKey();
        let newContentState = Modifier.insertText(
          contentState,
          selection,
          ' ',
          null,
          entityKey
        );
        let newVal = EditorState.push(editorState, newContentState);
        editorReference._onChange(newVal);
        this.removeEventListener('load', assignImageSrc);
      },
      true
    );

    reader.readAsDataURL(src);
  }

  dropfilesHandler(referenceString, selection, files) {
    if (files[0].type.includes('image')) {
      //let urlCreator = window.URL || window.webkitURL;
      //let imageUrl = urlCreator.createObjectURL(files[0]);
      this.setImage(files[0], this.refs[referenceString]);
    }
  }

  onImageFileSelectQuestion(referenceString, event) {
    let files = event.target.files;
    if (files[0].type.includes('image')) {
      //let urlCreator = window.URL || window.webkitURL;
      //let imageUrl = urlCreator.createObjectURL(files[0]);
      //

      this.setImage(files[0], this.refs[referenceString]);
    }
  }
    
   End Drag and Drop **/
   removeElementFromArray(arr, element)  {
    var i = arr.indexOf(element);
    if (i !== -1) {
        arr.splice(i, 1);
    }
    ////console.log("questionIds Array value =",arr);
    return arr;
  }
  AddAnswerHandler() {
    var newRTEValue = TextEditor.createEmptyValue();
    var tempArray = this.state.textEditorObjAns.slice();
    var tempAltAnsArray = this.state.textEditorObjAltAns.slice();
    var tempfeedbackArray = this.state.textEditorObjFeed.slice();
    var tempAltFeedbackArray = this.state.textEditorObjAltFeedback.slice();

    tempArray.push({ value: newRTEValue });
    tempAltAnsArray.push({ value: newRTEValue });
    tempfeedbackArray.push({ value: newRTEValue });
    tempAltFeedbackArray.push({ value: newRTEValue });
    //
    //bug id #147 fixes

    var list = (
      <Answer
        index={this.state.answerIndex + 1}
        answerText={"Answer " + (this.state.answerIndex + 1)}
        key={this.state.answerList.length} //bug-tracker#161
        answerButton={styles.answerButton}
        correctAnswerSwitch={styles.correctAnswerSwitch}
        correctAnswer={styles.correctAnswer}
        deleteAnswerButton={styles.deleteAnswerButton}
        AnswerValue={tempArray[this.state.answerIndex + 1]}
        onAnswerTextChange={this.onAnswerTextChange.bind(
          this,
          this.state.answerIndex + 1
        )}
        size={this.state.isQuestionWithPreview ? 8 : 6}
        answerDelete={this.answerDelete.bind(this, this.state.answerIndex + 1)}
        correctAnswerOnChange={this.correctAnswerOnChange.bind(
          this,
          this.state.answerIndex + 1
        )}
        answerSwitchValue={0}
        feedbackVisible={this.state.feedbackVisibility}
        isRandomized={this.state.questionType === 1 || [50, 60].includes(this.state.defaultAnswerType)}
        feedbackText={"Feedback for Answer " + (this.state.answerIndex + 2)}
        FeedbackValue={tempfeedbackArray[this.state.answerIndex + 1]}
        onFeedbackTextChange={this.onFeedbackTextChange.bind(
          this,
          this.state.answerIndex + 1
        )}
        AltAnswerValue={tempAltAnsArray[this.state.answerIndex + 1]}
        onAltAnswerTextChange={this.onAltAnswerTextChange.bind(
          this,
          this.state.answerIndex + 1
        )}
        AltFeedbackValue={tempAltFeedbackArray[this.state.answerIndex + 1]}
        onAltFeedbackTextChange={this.onAltFeedbackTextChange.bind(
          this,
          this.state.answerIndex + 1
        )}
        answer_display_options={createEmptyDisplayOption()}
        vectorAnswerFormula={createEmptyVectorAnswerFormula(this.state.answerIndex+1)}
        onAnswerDisplayOptionsChange={this.onAnswerDisplayOptionsChange}
        onVectorAnswerChange={this.onVectorAnswerChange}
        questionNonGraded={this.state.questionNonGraded}
        questionType={this.state.questionType}
        defaultAnswerType={this.state.defaultAnswerType}
        questionVectorTableMap={this.state.variablesMap}
        vectorVariablesMap={this.state.vectorVariablesMap}
        vectorAnswerVariablesMap={ VectorParserUtil.createDefaultVectorVariableMap(this.state.vectorAnswerVariablesMap,this.state.vectorSettingsData,"")}
        onAddVectorAnswer={this.onAddVectorAnswer}
        onRemoveVectorAnswer={this.onRemoveVectorAnswer}
        vectorAnswerVariable={[VectorParserUtil.createDefaultVectorVariable(VectorSettingsData,"")]}
        //altAnsTextVisible={0}
        onVectorAnswerVariableChange={this.onVectorVariableChange}
      />
    );

    var tempArrayAns = this.state.answerList.slice();

    tempArrayAns.push(list);
    this.setState({
      answerList: tempArrayAns,
      answerIndex: this.state.answerIndex + 1,
      textEditorObjAns: tempArray,
      textEditorObjAltAns: tempAltAnsArray,
      textEditorObjFeed: tempfeedbackArray,
      textEditorObjAltFeedback: tempAltFeedbackArray,
    });
  }
  /*
    Function to Delete Question, this will be called when Move Question is Clicked, to Delete the Old Question

  */
  async deleteQuestion(
    subjectId,
    topicId,
    categoryId,
    subcategoryId,
    questionId
  ) {
    const payload = {
      subject_id: subjectId,
      topic_id: topicId,
      category_id: categoryId,
      subcategory_id: subcategoryId,
      question_id: questionId,
    };

    await ApiRequestService({
      method: "post",
      url: "/deleteQuestions",
      data: payload,
    });
  }
  /**
    Copy Question
  */

    vectorAnswerValidation(vectorVariable,answerIndex) {
      for (const tempVectorVariable of vectorVariable) {
        // Each vector Validation
        const inputType = tempVectorVariable?.inputType;
        const vectorName = tempVectorVariable?.name;
    
        if (inputType === "components") {
          const variableType = tempVectorVariable?.variableType;
          if (variableType ==="RANGE" ) {
              const {
                posX: variablePosX,
                posY: variablePosY,
                xMin: variableXmin,
                xMax: variableXmax,
                yMin: variableYmin,
                yMax: variableYMax
              } = tempVectorVariable;
              if (!variablePosX) {
                alert(`Please enter a valid vector X Origin for the "${vectorName}"  in Answer ${answerIndex} vector configuration.`);
                return;
              }
              if (!variablePosY) {
                alert(`Please enter a valid vector Y Origin for the "${vectorName}" in Answer ${answerIndex} vector configuration.`);
                return;
              }
              if (!variableXmin) {
                alert(`Please enter a valid minimum X value for the "${vectorName}" in Answer ${answerIndex} vector configuration.`);
                return;
              }
              if (!variableXmax) {
                alert(`Please enter a valid maximum X value for the "${vectorName}" in Answer ${answerIndex} vector configuration.`);
                return;
              }
              if (!variableYmin) {
                alert(`Please enter a valid minimum Y value for the "${vectorName}" in Answer ${answerIndex} vector configuration.`);
                return;
              }
              if (!variableYMax) {
                alert(`Please enter a valid maximum Y value for the "${vectorName}" in Answer ${answerIndex} vector configuration.`);
                return;
              }
               // Vector X Validation
              if(Number(variablePosX) < 0 || Number(tempVectorVariable.gridWidthUnit) <= Number(variablePosX)){
                alert(`Please enter a valid origin x value for the "${vectorName}" in Answer ${answerIndex} vector configuration. Vector is going outside the grid.`);
                return;
              }
              if(Number(variableXmax) < Number(variableXmin)){
                alert(`Please enter a valid x min and x max value for the "${vectorName}" in Answer ${answerIndex} vector configuration. Vector is going outside the grid and x-max cannot be less than x-min.`);
                return;
              }
              if(Number(variableXmax) > Number(tempVectorVariable.gridWidthUnit - variablePosX)){
                alert(`Please enter a valid x min and x max value for the "${vectorName}" in Answer ${answerIndex} vector configuration. Vector is going outside the grid.`);
                return;
              }

              if(Number(variableXmin) < -Number(variablePosX)){
                alert(`Please enter a valid x min and x max value for the "${vectorName}" in Answer ${answerIndex} vector configuration. Vector is going outside the grid.`);
                return;
              }

              // Vector Y Validation
              if(Number(variablePosY) < 0 || Number(tempVectorVariable.gridHeightUnit) <= Number(variablePosY)){
                alert(`Please enter a valid origin y value for the "${vectorName}" in Answer ${answerIndex} vector configuration. Vector is going outside the grid.`);
                return;
              }
              if(Number(variableYMax) < Number(variableYmin)){
                alert(`Please enter a valid y min and y max value for the "${vectorName}" in Answer ${answerIndex} vector configuration. Vector is going outside the grid and y-max cannot be less than y-min.`);
                return;
              }
              if(Number(variableYMax) > Number(tempVectorVariable.gridHeightUnit - variablePosY)){
                alert(`Please enter a valid y min and y max value for the "${vectorName}" in Answer ${answerIndex} vector configuration. Vector is going outside the grid.`);
                return;
              }

              if(Number(variableYmin) < -Number(variablePosY)){
                alert(`Please enter a valid y min and y max value for the "${vectorName}" in Answer ${answerIndex} vector configuration. Vector is going outside the grid.`);
                return;
              }
          } else if (variableType ==="LIST" ) {
            const {
              xList: variableXList,
              yList: variableYList
            } = tempVectorVariable;
            if (!variableXList) {
              alert(`Please enter a valid X list value for the "${vectorName}" in Answer ${answerIndex} vector configuration.`);
              return;
            }
            if (!variableYList) {
              alert(`Please enter a valid Y list value for the "${vectorName}" in Answer ${answerIndex} vector configuration.`);
              return;
            }

          }
        } else if (inputType === "angle-magnitude") {
          const {
            posX: variablePosX,
            posY: variablePosY,
            magMin: variableMagMin,
            magMax: variableMagMax,
            angleMin: variableAngMin,
            angleMax: variableAngMax
          } = tempVectorVariable;
          if (!variablePosX) {
            alert(`Please enter a valid vector X Origin for the "${vectorName}"  in Answer ${answerIndex} vector configuration.`);
            return;
          }
          if (!variablePosY) {
            alert(`Please enter a valid vector Y Origin for the "${vectorName}" in Answer ${answerIndex} vector configuration.`);
            return;
          }
          if (!variableMagMin) {
            alert(`Please enter a valid magitude min for the "${vectorName}" in Answer ${answerIndex} vector configuration.`);
            return;
          }
          if (!variableMagMax) {
            alert(`Please enter a valid magitude max for the "${vectorName}" in Answer ${answerIndex} vector configuration.`);
            return;
          }
          if (!variableAngMin) {
            alert(`Please enter a valid angle min for the "${vectorName}" in Answer ${answerIndex} vector configuration.`);
            return;
          }
          if (Number(variableAngMax) < Number(variableAngMin)) {
            alert(`Please enter a valid angle min and max for the "${vectorName}" in Answer ${answerIndex} vector configuration. angle-max cannot be less than angle-min`);
            return;
          }
          if (Number(variableMagMax) < Number(variableMagMin)) {
            alert(`Please enter a valid magnitude min and  max for the "${vectorName}" in Answer ${answerIndex} vector configuration. angle-max cannot be less than angle-min`);
            return;
          }
          if(Number(variablePosX) < 0 || Number(tempVectorVariable.gridWidthUnit) <= Number(variablePosX)){
            alert(`Please enter a valid origin x value for the "${vectorName}" in Answer ${answerIndex} vector configuration. Vector is going outside the grid.`);
            return;
          }
          if(Number(variablePosY) < 0 || Number(tempVectorVariable.gridHeightUnit) <= Number(variablePosY)){
            alert(`Please enter a valid origin y value for the "${vectorName}" in Answer ${answerIndex} vector configuration. Vector is going outside the grid.`);
            return;
          }


        }
      }
      return true
    }
  copyQuestion(close) {
    this.setState({
      loadingSave: true,
      saveButtonShow: false,
    });

    //
    var sub_id = parseInt(this.state.subjectId, 10);
    var top_id = parseInt(this.state.topicId, 10);
    var cat_id = parseInt(this.state.categoryId, 10);
    var subcat_id = parseInt(this.state.subcategoryId, 10);

    var questionName = this.state.questionNameDefaultVaule;
    if (!this.isValidData(sub_id, top_id, cat_id)) {
      //If the Data is not valid, return, dont save
      this.setState({
        loading: false,
        saveButtonShow: true,
        loadingSave: false,
      });
      return;
    }
    /*
     Fix for -  The “duplicate question” feature does not save the question in the correct place. It should save the question in the same category and subcategory it was created. I am not even sure where it currently saves the question, but it is ot in the subcategory were the orginal question exists. This is high priority.
    */

    if (
      this.props.selectedSubjectId === this.state.subjectId &&
      this.props.selectedTopicId === this.state.topicId &&
      this.props.selectedCategoryId === this.state.categoryId &&
      this.props.selectedSubCategoryId === this.state.subcategoryId
    ) {
      if (
        this.state.questionName === undefined ||
        this.state.questionName === null ||
        this.state.questionName === this.state.questionNameDefaultVaule ||
        this.state.questionName === ""
      ) {
        questionName = "Copy " + this.state.questionNameDefaultVaule;
        this.setState({
          questionNameDefaultVaule:
            "Copy " + this.state.questionNameDefaultVaule,
        });
      }
    }

    /* console.debug(
      'this.state.questionNameDefaultVaule',
      this.state.questionNameDefaultVaule
    ); */
    const payload = {
      subject_id: sub_id,
      topic_id: top_id,
      category_id: cat_id,
      subcategory_id: subcat_id,
      question_name: questionName,
    };
    ApiRequestService({
      method: "post",
      url: "/addQuestions",
      data: payload,
    }).then((res) => {
      if (res.data !== undefined && res.data !== null) {
        if (res.data.data !== undefined && res.data.data !== null) {
          this.setState({
            copyModeQID:res.data.data.question_id
          })
          this.addQuestion(
            res.data.data.question_id,
            this.state.subjectId,
            this.state.topicId,
            this.state.categoryId,
            this.state.subcategoryId,
            close
          );
        } else if (
          res.data.message !== undefined &&
          res.data.message !== null
        ) {
          //bug-tracker#154

          NotificationManager.error(
            "Duplicate Question",
            'Cannot create Question with Name "' +
              this.state.questionNameDefaultVaule +
              '"',
            5000
          );
          this.setState({
            loadingSave: false, //Show Savw Button again on - Duplicate Questin Error
          });
        }
      }
    });
  }

  /*
  End Copy Question
  */

  //Moving Validation to a common function so that they can be used on both copy and edit question.
  //bug-tracker#156
  //Returns true if Data is Valid
  isValidData(subjectId, topicId, categoryId) {
    if (
      isNaN(subjectId) ||
      subjectId === undefined ||
      subjectId === null ||
      subjectId === "" ||
      subjectId === 0
    ) {
      NotificationManager.error(
        "Subject cannot be Empty, please select a subject"
      );
      return false;
    }

    if (
      isNaN(topicId) ||
      topicId === undefined ||
      topicId === null ||
      topicId === "" ||
      topicId === 0
    ) {
      NotificationManager.error("Topic Cannot be Empty, please select a topic");
      return false;
    }

    if (
      isNaN(categoryId) ||
      categoryId === undefined ||
      categoryId === null ||
      categoryId === "" ||
      categoryId === 0
    ) {
      NotificationManager.error(
        "Category cannot be Empty, please select a category"
      );
      return false;
    }

    //Validate Question Name as well.
    var questionName = this.state.questionNameDefaultVaule;
    if (
      questionName === undefined ||
      questionName === null ||
      questionName === "" ||
      questionName === 0
    ) {
      NotificationManager.error(
        "Question Name cannot be Empty, please enter a valid Question Name"
      );
      return false;
    }

    if (this.state.questionType === 1 || (this.state.questionType === 3 && [50, 60, 3].includes(this.state.defaultAnswerType))) {
      return this.isValidDataRandParamters();
    }

    if (this.state.questionType === 2) {
      return this.isValidMQTData();
    }
    return true;
  }

  isValidMQTData = () => {
    const {
      mqt_questions,
      mqt_answers,
      mqt_answer_count,
      mqt_answer_header,
      questionNonGraded,
    } = this.state;
    let isValid = true;
    let firstOccurQue = true;
    Object.values(mqt_questions).forEach((question) => {
      let questionText = TextEditor.getHTMLStringFromEditorState(
        question.value
      );
      if (
        firstOccurQue &&
        (questionText === "" || questionText === "<p><br></p>")
      ) {
        alert('Please enter the vaild "Question text" for each Option');
        isValid = false;
        firstOccurQue = false;
      }
    });
    if (mqt_answer_header) {
      let firstOccurAns = true;
      Object.values(mqt_answers).forEach((answer) => {
        let answerText = TextEditor.getHTMLStringFromEditorState(answer.value);
        if (
          firstOccurAns &&
          (answerText === "" || answerText === "<p><br></p>")
        ) {
          alert('Please enter the vaild "Answer text" for each Answer Option');
          isValid = false;
          firstOccurAns = false;
        }
      });
    } else {
      if (mqt_answer_count <= 0) {
        alert('Please enter the vaild "Answer Count" from drop down');
        isValid = false;
      }
    }

    if (!questionNonGraded) {
      let firstOccur = true;
      Object.values(mqt_questions).forEach((question) => {
        //
        //if(Object.keys(mqt_question_answer_map).length !== Object.keys(mqt_questions).length){
        if (
          firstOccur &&
          (this.state.mqt_question_answer_map[question.id] === "" ||
            this.state.mqt_question_answer_map[question.id] === undefined ||
            this.state.mqt_question_answer_map[question.id] === null)
        ) {
          alert('Please choose a "Correct Answer" for each Question');
          isValid = false;
          firstOccur = false;
        }
      });

      if (this.state.mqt_mastery_condition === 0) {
        alert(
          'Please choose a "Mastery Condition" from the mastery condition drop down'
        );
        isValid = false;
      }

      if (this.state.mqt_answer_type === "") {
        alert(
          'Please choose a "MQT Answer type" from the answer type radio button'
        );
        isValid = false;
      }
    }

    return isValid;
  };

  //Check if the Radomized Parameters Question has Valid Data

  isValidDataRandParamters = () => {
    const answerArrList = this.state.answerArrList;
    const answerVariableList = this.answerListVarMap;
    const { variablesMap } = this.state;
    console.debug("answerArrList, answerVariableList, variablesMap", answerArrList, answerVariableList, variablesMap)

    //Question Validations
    if (!variablesMap) {
      NotificationManager.error(`Please add a valid formula in Question`);
      return false;
    }

    const validationErrors = variablesMap.getValidationError();
    if (validationErrors || validationErrors !== "") {
      NotificationManager.error(validationErrors);

      return false;
    }

    //Answer Validations
    for (let index = 0; index < answerVariableList.length; index++) {
      const element = answerVariableList[index];
      console.debug("elementelement", element, variablesMap)
      // TOODO: Uncomment and fix it for vector RP
      if (element) {
        if (!element.containsAll(variablesMap)) {
          NotificationManager.error(
            `One or more variables in Answer ${
              index + 1
            } is not present in the question`
          );
          return false;
        }
      }
    }

    let isValid = true;
    if (
      this.state.defaultAnswerType === 1 ||
      this.state.defaultAnswerType === 0
    ) {
      if (answerArrList) {
        answerArrList.forEach((ans, index) => {
          if (ans) {
            const { answer_display_options, answer_text } = ans;
            if (answer_text.length === 0 || answer_text.trim().length === 0) {
              NotificationManager.error(`Answer ${index + 1} is empty`);
              isValid = false;
            }
            if (answer_display_options) {
              if (
                answer_display_options.type ===
                VariableTypes.SCIENTIFIC_NOTATION
              ) {
                if (
                  MathParserUtil.isIllegalNumber(
                    answer_display_options.decimalLimit
                  )
                ) {
                  NotificationManager.error(
                    `Error in Answer ${
                      index + 1
                    } Decimal Limit should be 0 or a positive number`
                  );
                  isValid = false;
                }

                if (
                  MathParserUtil.isIllegalNumber(
                    answer_display_options.precision
                  )
                ) {
                  NotificationManager.error(
                    `Error in Answer ${
                      index + 1
                    } Precision should be 0 or a positive number`
                  );
                  isValid = false;
                }
              }

              if (answer_display_options.type === VariableTypes.FLOAT) {
                if (
                  MathParserUtil.isIllegalNumber(
                    answer_display_options.sigFig
                  ) ||
                  answer_display_options.sigFig <= 0
                ) {
                  NotificationManager.error(
                    `Error in Answer ${
                      index + 1
                    } Significant Figures should be a positive number`
                  );
                  isValid = false;
                }
              }
            }
          }
        });
      }
    } else if (this.state.defaultAnswerType === 3) {
      const { formula,formulaOneEvaluateOption,addFormulaSwitch } = this.state.answer_formula;

      if (formula === "") {
        NotificationManager.error(`Answer Formula cannot be empty`);

        return false;
      }
      //Loop Through Answer Formula Map
      const formulaArray = Array.from(
        this.state.answer_formula.formulaMap.values()
      );
      if (this.state.questionType === 1 || (this.state.questionType === 3  && (!addFormulaSwitch && formulaOneEvaluateOption ===0) )){ //Query builder for Decimal
        for (var index = 0; index < formulaArray.length; index++) {
          const formulaObj = formulaArray[index];
          if (!formulaObj.validationMode || formulaObj.validationMode === "") {
            NotificationManager.error(
              `Please select a Answer Validation mode for ${formulaObj.text}`
            );
  
            return false;
          }
  
          switch (formulaObj.validationMode) {
            case "errorPercentage": {
              if (
                formulaObj.accuracyRange === "" ||
                isNaN(formulaObj.accuracyRange)
              ) {
                NotificationManager.error(
                  `Please add an error percentage value for ${formulaObj.text}`
                );
                return false;
              }
              break;
            }
            case "valueRange": {
              if (
                formulaObj.absAccuracyValue === "" ||
                isNaN(formulaObj.absAccuracyValue)
              ) {
                NotificationManager.error(
                  `Please add an error range value for ${formulaObj.text}`
                );
                return false;
              }
              break;
            }
            case "precision": {
              if (
                formulaObj.answerPrecision === "" ||
                isNaN(formulaObj.answerPrecision)
              ) {
                NotificationManager.error(
                  `Please add an precision value  for ${formulaObj.text}`
                );
                return false;
              }
  
              if (
                parseInt(formulaObj.answerPrecision, 10) <= 0 ||
                parseInt(formulaObj.answerPrecision, 10) > 16
              ) {
                NotificationManager.error(
                  `Precision value should between 1 to 16 for ${formulaObj.text}`
                );
                return false;
              }
              break;
            }
            case "list": {
              if (formulaObj.listValues) {
                const variablesMap = this.state.variablesMap;
                const variObject = variablesMap.get(
                  MathParserUtil.removeBrackets(formulaObj.text)
                );
                const varArray = variObject.listValues.split(",");
                for (let index = 0; index < varArray.length; index++) {
                  const varName = varArray[index].trim();
                  if (!formulaObj.listValues[varName]) {
                    NotificationManager.error(
                      `Please fill correct answers for  ${varName}`
                    );
                    return false;
                  }
                }
              } else {
                NotificationManager.error(
                  `Please fill correct answers for ${formulaObj.text} values`
                );
                return false;
              }
              break;
            }
            default:
              return false;
          }
        }
      }

      const answerVars = MathParserUtil.getVariablesFromText(formula);
      if (answerVars) {
        console.debug("answerVars>>" ,answerVars, variablesMap)
        if (!answerVars.containsAll(variablesMap)) {
          NotificationManager.error(
            `One or more variables in Answer is not present in the question`
          );
          return false;
        }
      } else {
        NotificationManager.error(`Answer Formula is invalid`);

        return false;
      }
    }

    return isValid;
  };


  vectorQuestionboundcheck = () => {
    /* let questionVectorVariablesArray = null;
    let question_warning_text = "";

    //Convert Vector Question Map to Array
    if (this.state.variablesMap) {
      questionVectorVariablesArray = Array.from(this.state.vectorVariablesMap.values());
     }

    for (let index = 0; index < questionVectorVariablesArray.length; index++) {
      const vector_element = questionVectorVariablesArray[index];
      const _vector_sdata = this.state.vectorSettingsData;
      
      if(vector_element.inputType === "components" && vector_element.variableType !== 'LIST') {
        if(vector_element.xMax != "" && vector_element.xMin != "" && vector_element.yMax != "" && vector_element.yMin != "" ){
          if(Number(vector_element.xMax) < Number(vector_element.xMin)) {
            question_warning_text = `x-min cannot be greater than x-max for Vector ${vector_element.name}.`;
          } else if(Number(vector_element.yMax) < Number(vector_element.yMin)) {
            question_warning_text = `y-min cannot be greater than y-max for Vector ${vector_element.name}.`;
          }else if(-Number(_vector_sdata.widthUnit/2) > Number(vector_element.xMin) ||  Number(vector_element.xMax) > Number(_vector_sdata.widthUnit/2)){
            question_warning_text = `Vector ${vector_element.name} is going outside the grid. Please change the x range values.`;
          }else if(-Number(_vector_sdata.heightUnit/2) > Number(vector_element.yMin) || Number(vector_element.yMax) > Number(_vector_sdata.heightUnit/2)){
            question_warning_text = `Vector ${vector_element.name} is going outside the grid. Please change the y range values.`;
          }else if(0 <= Number(vector_element.posX) && Number(vector_element.posX) >= Number(_vector_sdata.widthUnit) || 0<= Number(vector_element.posY) && Number(vector_element.posY) >= Number(_vector_sdata.heightUnit)){
            question_warning_text = `Vector ${vector_element.name} is going outside the grid. Please change the origin or the range values.`;
            NotificationManager.error(question_warning_text, "Warning!", 10000);
            return; 
          } 
        }           
       } else if(vector_element.inputType === "angle-magnitude") {
        if(vector_element.angleMax != "" && vector_element.angleMin != "" && vector_element.magMax != "" && vector_element.magMin != "" ){
          if(Number(vector_element.angleMax) < Number(vector_element.angleMin)) {
            question_warning_text = `angle-min must not be greater than angle-max for Vector ${vector_element.name}`;
          } else if(Number(vector_element.magMax) < Number(vector_element.magMin)) {
            question_warning_text = `mag-min must not be greater than mag-max for Vector ${vector_element.name}`;
          } else if(0 <= Number(vector_element.posX) && Number(vector_element.posX) >= Number(_vector_sdata.widthUnit) || 0<= Number(vector_element.posY) && Number(vector_element.posY) >= Number(_vector_sdata.heightUnit)){
            question_warning_text = `Vector ${vector_element.name} is going outside the grid. Please change the origin or the range values.`;
            NotificationManager.error(question_warning_text, "Warning!", 10000);
            return; 
          }
        }
        
        } else if(vector_element.variableType === 'LIST') {
        if(0 <= Number(vector_element.posX) && Number(vector_element.posX) >= Number(_vector_sdata.widthUnit) || 0<= Number(vector_element.posY) && Number(vector_element.posY) >= Number(_vector_sdata.heightUnit)){
          NotificationManager.error(`Vector ${vector_element.name} is going outside the grid. Please change the origin or the range values.`, "Warning!", 10000);
          return; 
        }
      }

      if(question_warning_text != "") {
        NotificationManager.error(question_warning_text, "Error!", 10000);
        return;
      }
    } */
  }

  isValidParentheses(s) {
    let stack = [];

    for (let ch of s) {
        if (ch === '(' || ch === '[' || ch === '{') {
            stack.push(ch);
        } else if (ch === ')' || ch === ']' || ch === '}') {
            if (stack.length === 0) {
                return false;
            }
            let openBracket = stack.pop();
            if ((ch === ')' && openBracket !== '(') ||
                (ch === ']' && openBracket !== '[') ||
                (ch === '}' && openBracket !== '{')) {
                return false;
            }
        }
    }

    return stack.length === 0;
}

  addQuestion(
    questionID,
    subjectId,
    topicId,
    categoryId,
    subcategoryId,
    close
  ) {
    if (!this.isValidData(subjectId, topicId, categoryId)) {
      //If the Data is not valid, return, dont save
      this.setState({
        loading: false,
        saveButtonShow: true,
        loadingSave: false,
      });
      return;
    }

    let tempQuestionText = TextEditor.getHTMLStringFromEditorState(
      this.state.questionTextEditorObj
    );

    if (
      (this.state.questionText === "" && tempQuestionText === "") ||
      tempQuestionText === "<p><br></p>"
    ) {
      alert('Please enter the vaild "Question text"');
      this.setState({
        loading: false,
        saveButtonShow: true,
        loadingSave: false,
      });
      return false;
    }

    //empty answer with correct answer
    if (
      this.state.answerArrList !== undefined &&
      this.state.answerArrList !== null
    ) {
      //
      for (let i = 0; i <= this.state.answerArrList.length - 1; i++) {
        if (
          this.state.answerArrList[i] !== undefined &&
          this.state.answerArrList[i] !== null
        ) {
          //
          let tempans = this.state.answerArrList[i].answer_text;
          tempans = tempans.replace(/\n/gi, "");
          tempans = tempans.replace(/ /g, "");
          if (
            this.state.answerArrList[i].is_answer === 1 &&
            tempans === "" &&
            this.state.questionType !== 3 && !(this.state.questionType === 0 && [70,80,90].includes(this.state.defaultAnswerType))
          ) {
            //
            alert(
              'Please enter the vaild text for correct answer in "Answer ' +
                (i + 1) +
                '" text'
            );
            this.setState({
              loading: false,
              saveButtonShow: true,
              loadingSave: false,
            });
            return false;
          }
        }
      }
    }

    //Validation for multi vector
    if(this.state.questionType === 0 && [70,80].includes(this.state.defaultAnswerType)) {
      if (
        this.state.answerArrList !== undefined &&
        this.state.answerArrList !== null
      )  {
        for (let i = 0; i <= this.state.answerArrList.length - 1; i++) {
          if (
            this.state.answerArrList[i] !== undefined &&
            this.state.answerArrList[i] !== null
          ) {
             let tempVectorVariable = this.state.answerArrList[i]?.vectorAnswerVariable
             if (!tempVectorVariable || tempVectorVariable.length === 0 ) {
              alert(
                'Please enter the vaild vector for correct answer in "Answer ' +
                  (i + 1) +
                  '" configuration'
              );
              return
             }

            let isVectorValid =  this.vectorAnswerValidation(tempVectorVariable,i+1)
            if (!isVectorValid) {
              return
            }

          } else {
            alert(
              'Please enter the vaild vector configuration for correct answer in "Answer ' +
                (i + 1) +
                '" vector configuration'
            );
            return
          }
        }
      }
    }

    //checking alt question text
    //
    if (this.state.imgTagCount >= 1) {
      let tempaltQuestionTextEditorObj = this.state.altQuestionTextEditorObj;
      tempaltQuestionTextEditorObj = tempaltQuestionTextEditorObj.replace(
        /\n/gi,
        ""
      );
      tempaltQuestionTextEditorObj = tempaltQuestionTextEditorObj.replace(
        / /g,
        ""
      );
      let attrTextArr = tempaltQuestionTextEditorObj.split(";");
      attrTextArr = attrTextArr.filter(function (el) {
        return el !== "";
      });
      //
      let attrTextCount = attrTextArr.length;
      //
      if (tempaltQuestionTextEditorObj === "") {
        alert(
          '"Title and Alternative Text for all Images in Question" is Empty. Please enter a valid text.'
        );
        this.setState({
          loading: false,
          saveButtonShow: true,
          loadingSave: false,
        });
        return false;
      }
      if (attrTextCount % 2 !== 0) {
        alert(
          'Title or Alternative text is missing in "Title and Alternative Text for all Images in Question"'
        );
        this.setState({
          loading: false,
          saveButtonShow: true,
          loadingSave: false,
        });
        return false;
      }

      if (this.state.imgTagCount !== attrTextCount / 2) {
        alert(
          'Please enter a valid text for all images in "Title and Alternative Text for all Images in Question"'
        );
        this.setState({
          loading: false,
          saveButtonShow: true,
          loadingSave: false,
        });
        return false;
      }
      var lastChar =
        tempaltQuestionTextEditorObj[tempaltQuestionTextEditorObj.length - 1];
      //
      if (lastChar === ";") {
        alert(
          'Please remove semicolon at the end of the text in "Title and Alternative Text for all Images in Question"'
        );
        this.setState({
          loading: false,
          saveButtonShow: true,
          loadingSave: false,
        });
        return false;
      }
    }
    //checking alt question text
    let tempIsCorrectAnswerPresent = false;

    //checking alt answer text
    //

    if (
      this.state.answerArrList !== undefined &&
      this.state.answerArrList !== null
    ) {
      for (let i = 0; i <= this.state.answerArrList.length - 1; i++) {
        //
        if (
          this.state.answerArrList[i] !== undefined &&
          this.state.answerArrList[i] !== null
        ) {
          if (this.state.answerArrList[i].is_answer === 1) {
            tempIsCorrectAnswerPresent = true;
          }

          let tempansarr = this.state.answerArrList[i].answer_text;
          let imgTagCount = tempansarr.split("<img ").length - 1;
          //
          if (imgTagCount >= 1) {
            let tempalt_answer_text = this.state.answerArrList[i].alt_answer_text;
            tempalt_answer_text = tempalt_answer_text.replace(/\n/gi, " ");
            tempalt_answer_text = tempalt_answer_text.replace(/ /g, "");

            let attrTextArr = tempalt_answer_text.split(";");
            attrTextArr = attrTextArr.filter(function (el) {
              return el !== "";
            });
            //

            let attrTextCount = attrTextArr.length;
            if (tempalt_answer_text === "") {
              alert(
                '"Title and Alternative Text for all Images in Answer ' +
                  (i + 1) +
                  '" is Empty. Please enter a valid text.'
              );
              this.setState({
                loading: false,
                saveButtonShow: true,
                loadingSave: false,
              });
              return false;
            }
            if (attrTextCount % 2 !== 0) {
              alert(
                'Title or Alternative text is missing in "Title and Alternative Text for all Images in Answer ' +
                  (i + 1) +
                  '"'
              );
              this.setState({
                loading: false,
                saveButtonShow: true,
                loadingSave: false,
              });
              return false;
            }
            if (imgTagCount !== attrTextCount / 2) {
              alert(
                'Please enter a valid text for all images in "Title and Alternative Text for all Images in Answer ' +
                  (i + 1) +
                  '"'
              );
              this.setState({
                loading: false,
                saveButtonShow: true,
                loadingSave: false,
              });
              return false;
            }
            var ansLastChar =
              tempalt_answer_text[tempalt_answer_text.length - 1];
            //
            if (ansLastChar === ";") {
              alert(
                'Please remove semicolon at the end of the text in "Title and Alternative Text for all Images in Answer ' +
                  (i + 1) +
                  '"'
              );
              this.setState({
                loading: false,
                saveButtonShow: true,
                loadingSave: false,
              });
              return false;
            }
          } /*else if(imgTagCount === 0){
          
          this.state.answerArrList[i].alt_answer_text = ''
        }*/
        }
      }
    }
    //Check if there is a valid answer for Randomized Parameter and Answer Type is Numerical Answer(automatic grading)
    if ((this.state.questionType === 1 && this.state.defaultAnswerType === 3)

      || (this.state.questionType === 3 && [50, 60].includes(this.state.defaultAnswerType)
    || (this.state.questionType === 0 && ![70,80,90].includes(this.state.defaultAnswerType)) )
    ) {
      const { accuracyRange, formula } = this.state.answer_formula;
      //ToDo Checj if the formula is valid
      if (accuracyRange && formula) {
        tempIsCorrectAnswerPresent = true;
      }
    }
    //checking alt answer text*/

    if (
      !tempIsCorrectAnswerPresent &&
      this.state.questionNonGraded === 0 &&
      this.state.questionType !== 2 &&
      this.state.defaultAnswerType !== 3 &&
      this.state.defaultAnswerType !== 2 &&
      this.state.questionType !== 4 && // dont need correct anser for reasoning element
      !(this.state.questionType === 0 && this.state.defaultAnswerType === 90 ) 
    ) {
      alert("Please Choose a Correct answer");
      this.setState({
        loading: false,
        saveButtonShow: true,
        loadingSave: false,
      });
      return false;
    }

    this.setState({
      //loading: true,
      saveButtonShow: false,
      loadingSave: false,
    });

    //this.setState({ loading: true })

    var sub_id = subjectId;
    var top_id = topicId;
    var cat_id = categoryId;
    var subCat_id = subcategoryId;

   
    //if (this.state.subcategoryId === 0) {
    //subCat_id = parseInt(this.state.subCategoryDefaultId,10);
    // }

    var question_name = "";
    if (this.state.questionName !== "") {
      question_name = this.state.questionName;
    } else {
      question_name = this.state.questionNameDefaultVaule;
    }

    var questionTextBelowOrAbove = 0;

    var quesion_text = TextEditor.getHTMLStringFromEditorState(
      this.state.questionTextEditorObj
    );
    var alt_quesion_text = this.state.altQuestionTextEditorObj;
    var answerType = 0;
    let answerArr = [];
    var randamizeOrder = 0;
    var tempQuestionNonGraded = 0;
    let answer_warning_text = "";
    
    // console.log('this.state.questionType::', this.state.defaultAnswerType);
    
    // If Answer Type Not Free Form Vectors
    if(this.state.defaultAnswerType !== 2) {
      for (let i = 0; i <= this.state.answerArrList.length - 1; i++) {
        const _answers = this.state.answerArrList[i];
        // console.log('Check condition::', _answers)
        
        // Standard Question Check
        console.debug("_answers>>>", _answers)
        if((this.state.questionType === 0 && ![70,80,90].includes(this.state.defaultAnswerType))  || (this.state.questionType === 3 && [30, 40, 50, 60].includes(this.state.defaultAnswerType))) {
          if(_answers === null) {
            answer_warning_text = `One or more of the answers are missing the text. Please add an answer text for each of the missing answers or delete them.`;
          } else if(_answers.answer_text === "" ) {
            answer_warning_text = `One or more of the answers are missing the text. Please add an answer text for each of the missing answers or delete them.`;
          }

          // Vector Question Check 
        } else if(this.state.questionType === 3 || (this.state.questionType === 0 && ![70,80,90].includes(this.state.defaultAnswerType))) {
          if( _answers != null && _answers.hasOwnProperty('vectorAnswerFormula')) {
            answer_warning_text = VectorParserUtil.testAnswerBounds(_answers,this.state.vectorSettingsData,this.state.vectorVariablesMap);
            if(answer_warning_text != "") {
              NotificationManager.error(
                answer_warning_text,
                `Error in ${_answers.vectorAnswerFormula.name}`,
                5000
              );
              return;
            }
            const {widthUnit,heightUnit} = this.state.vectorSettingsData;
            const gridwidth = parseInt(widthUnit,10);
            const gridheight = parseInt(heightUnit,10);
            if(_answers.vectorAnswerFormula && !_answers.vectorAnswerFormula.autoOrigin){
              if(0<= _answers.vectorAnswerFormula.xOrigin && _answers.vectorAnswerFormula.xOrigin >= gridwidth){
                answer_warning_text = 'The vector goes outside the grid. Please change the x-origin value';
                NotificationManager.error(
                  answer_warning_text,
                  `Error in ${_answers.vectorAnswerFormula.name}`,
                  5000
                );
                return;
              }
              if(0<= _answers.vectorAnswerFormula.yOrigin && _answers.vectorAnswerFormula.yOrigin >= gridheight){
                answer_warning_text = 'The vector goes outside the grid. Please change the y-origin value';
                NotificationManager.error(
                  answer_warning_text,
                  `Error in ${_answers.vectorAnswerFormula.name}`,
                  5000
                );
                return;
              }
            }
            
            let answer_error_text = VectorParserUtil.validateAnswerVariables(_answers,this.state.vectorVariablesMap);
            if(answer_error_text != "") {
              NotificationManager.error(answer_error_text, "Error!", 10000);
              return;
            }
          }
          if ((this.state.questionType !== 3 && this.state.defaultAnswerType !== 3) &&
           !(this.state.questionType === 0 && [70,80,90].includes(this.state.defaultAnswerType)) ) {
            if (_answers === null) {
              answer_warning_text = `One or more of the answers are missing the text. Please add an answer text for each of the missing answers or delete them. 1`;
            } else if(_answers.vectorAnswerFormula){
              if(_answers.vectorAnswerFormula.formulaType == "angle-magnitude") {
                if(_answers.vectorAnswerFormula.name == "" || _answers.vectorAnswerFormula.formulaType == "" || (_answers.vectorAnswerFormula.angleFormula == " " || _answers.vectorAnswerFormula.magFormula == " " ||
            _answers.vectorAnswerFormula.angleFormula == "" || _answers.vectorAnswerFormula.magFormula == "")) {
              answer_warning_text = `One or more of the answers are missing the text. Please add an answer text for each of the missing answers or delete them. 2`;
              NotificationManager.error(answer_warning_text, "Error!", 10000);
              return;
            }
            } else {
                if(_answers.vectorAnswerFormula.name == "" || _answers.vectorAnswerFormula.formulaType == "" || (_answers.vectorAnswerFormula.xFormula == " " || _answers.vectorAnswerFormula.yFormula == " " ||
            _answers.vectorAnswerFormula.xFormula == "" || _answers.vectorAnswerFormula.yFormula == "")) {
              answer_warning_text = `One or more of the answers are missing the text. Please add an answer text for each of the missing answers or delete them. 3`;
              NotificationManager.error(answer_warning_text, "Error!", 10000);
              return;
            }
              }
            } else if(!_answers.vectorAnswerFormula){
              answer_warning_text = `One or more of the answers are missing the text. Please add an answer text for each of the missing answers or delete them. 4`;
              NotificationManager.error(answer_warning_text, "Error!", 10000);
              return;
            }
        }
          if(answer_warning_text.length > 0 ){
            break;
          } 
        }
      }
    } 

    const checkValidAnswerFormulaName = (text) => {
      if (text === "") return false;

      if (text.includes("\\vec") || text[0] === "\\") { // Must contain a Letter inside the curly brackets
        const vecRegex = /\\vec\{[a-zA-Z]+\}/;
        return vecRegex.test(text);
      }

      return /[a-zA-Z]/.test(text); // Must atleast contain one letter
    }

    if((this.state.defaultAnswerType === 2 && this.state.questionType === 3 
      && ![30, 40, 50, 60].includes(this.state.defaultAnswerType)) ||
      (this.state.questionType === 0 && [90].includes(this.state.defaultAnswerType))
    ) {
      // Check condition only for Answer Type is "Free Form Vectors"
      for (let i = 0; i <= this.state.vectorAnswerFormulas.length - 1; i++) {
        const _answerFormula = this.state.vectorAnswerFormulas[i];
        console.log('Check condition::', _answerFormula)

        if(_answerFormula === null) {
          answer_warning_text = `One or more of the answers are missing the text. Please add an answer text for each of the missing answers.`;
        } else if (!checkValidAnswerFormulaName(_answerFormula.name)) {  // /^[^-\s][a-zA-Z0-9_\s-]+$/ Regex - should NOT only contain white spaces at the begining + must contain a character
          answer_warning_text = `One or more of the answers are missing the name (${_answerFormula.name}). Please enter a name for each of the missing answers.`;
        }  if ((( _answerFormula.evaluate_x===0 && _answerFormula.xFormula ) === ""
        ||  (_answerFormula.evaluate_y===0 &&_answerFormula.yFormula === "" )) && (_answerFormula.formulaType === "components") && (!_answerFormula.isIncorrectAnswer)) {
          answer_warning_text = `One or more of the answers are missing the x or y Formula. Please add a formula for each of the missing answers.`;
        } if ((_answerFormula.formulaType === "components")  && ( _answerFormula.evaluate_x===1 &&_answerFormula.evaluate_y===1) ) {
          answer_warning_text = `Both of the answers are missing the x or y Formula. Please add any one formula for the missing answers.`;
        }
        
        if (( ( _answerFormula.evaluate_magnitue===0 && _answerFormula.magFormula === "")
          || ( _answerFormula.evaluate_angle===0 && _answerFormula.angleFormula === "") ) && (_answerFormula.formulaType === "angle-magnitude")) {
            answer_warning_text = `One or more of the answers are missing the magnitude or angle Formula. Please add a formula for each of the missing answers.`;
          }
          if ((_answerFormula.formulaType === "angle-magnitude")  && ( _answerFormula.evaluate_magnitue===1 &&_answerFormula.evaluate_angle===1) ) {
            answer_warning_text = `Both of the answers are missing the magnitude or angle Formula. Please add any one formula for the missing answers.`;
          }
      }
    }

    if((this.state.questionType === 3 && this.state.vectorSettingsData) || (this.state.questionType === 0 && [70,80,90].includes(this.state.defaultAnswerType))) {
      if(this.state.vectorSettingsData.height === 0 || this.state.vectorSettingsData.width == 0){
        NotificationManager.error("Grid height or width not specified", "Error!", 10000);
        return;
      }
    }

    //Image alt text check when saving  
    if(this.state.vectorSettingsData.image !== "" && this.state.vectorSettingsData.image !== undefined && this.state.questionType === 3){
      if(this.state.vectorSettingsData.altImageText == ""){
        NotificationManager.error("Image alt text is missing", "Error!", 10000);
        return;
      }
    }
    
    if(answer_warning_text != "") {
      NotificationManager.error(answer_warning_text, "Error!", 10000);
      return;
    }

    if (this.state.answerArrList !== null) {
      answerArr = JSON.parse(JSON.stringify(this.state.answerArrList));
    }

    if (this.state.defaultQuestionTextBelowOrAbove !== 0) {
      questionTextBelowOrAbove = this.state.defaultQuestionTextBelowOrAbove;
    }
    //JSON.parse(JSON.stringify(this.state.answerArrList));
    randamizeOrder = this.state.defaultRandamizeOrder;
    tempQuestionNonGraded = this.state.questionType === 0 && this.state.defaultAnswerType === 2 ? 1 : this.state.questionNonGraded;

    answerType = this.state.defaultAnswerType;
    let questionVariablesArray = null;
    if (this.state.variablesMap) {
      questionVariablesArray = Array.from(this.state.variablesMap.values());
    }

   
    //Convert Vector Question Map to Array
    let questionVectorVariablesArray = null;
    if (this.state.variablesMap) {
      questionVectorVariablesArray = Array.from(this.state.vectorVariablesMap.values());
    }
    
    // Validate question values are connect for vector questions
    if(this.state.questionType === 3) {
      let question_warning_text = "";
      console.log("questionVectorVariablesArray", questionVectorVariablesArray);
      for (let index = 0; index < questionVectorVariablesArray.length; index++) {
        const vector_element = questionVectorVariablesArray[index];
        console.debug("vector_element>>>", vector_element)
        if(vector_element.inputType === "components" && vector_element.variableType !== 'LIST') {
          if(vector_element.xMax != "" && vector_element.xMin != "" && vector_element.yMax != "" && vector_element.yMin != "" ){
            if(Number(vector_element.xMax) < Number(vector_element.xMin)) {
              question_warning_text = `x-min cannot be greater than x-max for Vector ${vector_element.name}.`;
            } else if(Number(vector_element.yMax) < Number(vector_element.yMin)) {
              question_warning_text = `y-min cannot be greater than y-max for Vector ${vector_element.name}.`;
            } else if(-Number(vector_element.gridWidthUnit)/2 > Number(vector_element.xMin) ||  Number(vector_element.xMax) > Number(vector_element.gridWidthUnit)/2){
              question_warning_text = `Vector ${vector_element.name} is going outside the grid. Please change the x range values.`;
            } else if(-Number(vector_element.gridHeightUnit)/2 > Number(vector_element.yMin) || Number(vector_element.yMax) > Number(vector_element.gridHeightUnit)/2){
              question_warning_text = `Vector ${vector_element.name} is going outside the grid. Please change the y range values.`;
            } else if (Number(vector_element.posX) + Number(vector_element.xMin) < 0) {
              question_warning_text = `Vector ${vector_element.name} is going outside the grid. Please change the x range values.`;
            } else if (Number(vector_element.posX) + Number(vector_element.xMax) > Number(vector_element.gridWidthUnit)) {
              question_warning_text = `Vector ${vector_element.name} is going outside the grid. Please change the x range values.`;
            } else if (Number(vector_element.posY) + Number(vector_element.yMin) < 0) {
              question_warning_text = `Vector ${vector_element.name} is going outside the grid. Please change the y range values.`;
            } else if (Number(vector_element.posY) + Number(vector_element.yMax) > Number(vector_element.gridHeightUnit)) {
              question_warning_text = `Vector ${vector_element.name} is going outside the grid. Please change the y range values.`;
            }
          }
        } else if(vector_element.inputType === "angle-magnitude") {
          if(vector_element.angleMax != "" && vector_element.angleMin != "" && vector_element.magMax != "" && vector_element.magMin != ""){
            if(Number(vector_element.angleMax) < Number(vector_element.angleMin)) {
              question_warning_text = `angle-min must not be greater than angle-max for Vector ${vector_element.name}`;
            } else if(Number(vector_element.magMax) < Number(vector_element.magMin)) {
              question_warning_text = `mag-min must not be greater than mag-max for Vector ${vector_element.name}`;
            }
          }
        }
      }
      
      if(question_warning_text != "") {
        NotificationManager.error(question_warning_text, "Error!", 10000);
        return;
      }
    }

    if (
      this.state.questionOwnership === 1 &&
      this.state.ownershipAttributeObj === ""
    ) {
      alert("Please fill the attribute text area for outside source ownership");
      this.setState({
        loading: false,
        saveButtonShow: true,
        loadingSave: false,
      });
      return false;
    }

    // for case sensitive and answer validation constraint
    if (this.state.caseSensitiveChange === false) {
      this.setAnswerCaseSensitiveorNot();  // default
    }
    if (this.state.shouldAnswerAllorAnyChange === false) {
      this.setShouldAnswerAllorAny("1");  // default
    }
    // for answer format
    if (this.state.answerDisplayStyle === 4) {
      this.setAnswerFormatChange(this.state.answerDisplayStyle)
    }

    for (let index = 0; index < questionVectorVariablesArray?.length; index++) {
      const vector_element = questionVectorVariablesArray[index];
      const _vector_sdata = this.state.vectorSettingsData;

      if(vector_element.inputType === "components" && vector_element.variableType !== 'LIST') {
        if((0<= Number(vector_element.posX) && Number(vector_element.posX) >= Number(_vector_sdata.widthUnit)) || (0<= Number(vector_element.posY) && Number(vector_element.posY) >= Number(_vector_sdata.heightUnit))){
          NotificationManager.error(`Vector ${vector_element.name} is going outside the grid. Please change the origin or the range values.`, "Warning!", 10000);
          return;
        }
    } else if(vector_element.inputType === "angle-magnitude") { 
      if((0<= Number(vector_element.posX) && Number(vector_element.posX) >= Number(_vector_sdata.widthUnit)) || (0<= Number(vector_element.posY) && Number(vector_element.posY) >= Number(_vector_sdata.heightUnit))){
        NotificationManager.error(`Vector ${vector_element.name} is going outside the grid. Please change the origin or the range values.`, "Warning!", 10000);
        return;
      }
    } else if(vector_element.variableType === 'LIST') {
      if((0<= Number(vector_element.posX) && Number(vector_element.posX) >= Number(_vector_sdata.widthUnit)) || (0<= Number(vector_element.posY) && Number(vector_element.posY) >= Number(_vector_sdata.heightUnit))){
        NotificationManager.error(`Vector ${vector_element.name} is going outside the grid. Please change the origin or the range values.`, "Warning!", 10000);
        return;
      }
     }
    }

    let payload = {
      question_order: this.state.questionOrder,
      question_id: questionID,
      topic_id: top_id,
      subject_id: sub_id,
      category_id: cat_id,
      subcategory_id: subCat_id,
      question_name: question_name,
      question_text: quesion_text,
      alt_question_text: alt_quesion_text,
      answer_type: answerType,
      randomize_answer: randamizeOrder,
      is_text_above_image: questionTextBelowOrAbove,
      answers: answerArr,
      answerDisplayStyle: this.state.answerDisplayStyle,
      question_nongraded: tempQuestionNonGraded,
      enable_analytics: this.state.enableAnalytics,
      enable_feedback: this.state.enableFeedback,
      //enable_alt_text:this.state.enableAltText
      question_type: this.state.questionType,
      question_variables: questionVariablesArray,
      answer_formula: this.state.answer_formula
        ? {
            ...this.state.answer_formula,
            formulaArray: this.state.answer_formula.formulaMap
              ? Array.from(this.state.answer_formula.formulaMap.values())
              : [],
          }
        : null,
      question_ownership: this.state.questionOwnership,
      question_ownership_attribute: this.state.ownershipAttributeObj,
      move_question: 0,
      rpBlackList: this.state.rpBlackList,
      vector_question_variables:questionVectorVariablesArray,
      vector_settings_data:this.state.vectorSettingsData,
      vector_answer_formulas:this.state.vectorAnswerFormulas,
      vector_below_question_text: this.state.vectorBelowQuestionText,
      freeform_vector_options: {
        show_components: this.state.showComponents,
        show_magnitude_angle:this.state.showMagnitudeAngle,
        show_vector_prompt:this.state.showVectorPrompt,
      },
    };

    // Reasoning Chain Question
    if (this.state.questionType === 4) {
      payload.reasoning_elements = this.state.reasoningElements;
      payload.connecting_words = this.state.connectingWords;
      payload.conclusion_sentences = this.state.conclusionSentences;
      payload.answer_type = 2; // answer type text box
      payload.question_nongraded = 1; // reasoning chain questions are always non-graded
      payload.is_conclusion_sentence_required = this.state.isConclusionSentenceRequired;
      payload.show_reasoning_element_category_info = this.state.showReasoningElementCategoryInfo;
    }


    if(this.state.defaultAnswerType === 1  || this.state.defaultAnswerType === 40){
      payload.for_checkbox_question = this.state.forCheckBoxQuestion;
    }

    //If MQT - Add it to Payload
    if (this.state.questionType === 2) {
      payload = this.addMQTToPayload(payload);
      if (payload === null) {
        return;
      }
    }
    if (this.state.moveMode) {
      payload.move_question = 1;
    } else {
      payload.move_question = 0;
    }
    console.debug("payload ==>", payload);

    console.debug("payload.answer_formula.formula", this.isValidParentheses(payload.answer_formula.formula))

    if (payload?.answer_formula && !this.isValidParentheses(payload.answer_formula.formula)) {
      NotificationManager.error('The answer formula has mismatched or missing parentheses.\n\nPlease ensure all parentheses are properly paired and closed.', 'ERRRO', 5000)
      return;
    }

    // Check vector_question_variables array data variableType is NOT EMPTY
    if (this.state.questionType === 3) {
      if (questionVectorVariablesArray.length) {
        for (let i = 0; i < questionVectorVariablesArray.length; i++) {
          let qv = questionVectorVariablesArray[i];
          if (qv && (qv.variableType === undefined || qv.variableType === null || qv.variableType === "")) {
            NotificationManager.error(`Please select a "Type" in vector configuration for "${qv.name}"`, 'Empty Type', 5000)
            return
          }
        }
      }
    }

    // For the below Q/A types we don't need answers list
    if (
      (payload.question_type === 3 && payload.answer_type === 2) // Vec RP - FR
      ||
      (payload.question_type === 4) // RC
      ||
      (payload.question_type === 1 && payload.answer_type === 3) // RP - FR
      ||
      (payload.question_type === 2) // Multiple question grid
      ||
      (payload.question_type === 0 && payload.answer_type === 2) // Standard - Textbox
      ||
      (payload.question_type === 0 && payload.answer_type === 90) // Standard - Draw vector
      
    ) {
      payload.answers = null;
    }
    
    this.setState({
      questionID: questionID,
      loadingSave: true,
    });

    ApiRequestService({
      method: "post",
      url: "/updateQuestions",
      data: payload,
    }).then((res) => {
      //
      this.setState({ loadingSave: false });
      // this.state.topics.push({
      //       topic_name: res.data.data.topic_name,
      //       topic_id:   res.data.data.topic_id
      // });
      // this.setState({
      //     topics: this.state.topics
      // })

     /*  if (res && res.data && res.data.data) {
        let result = res.data.data;
        this.setState({
          answerArrList: result.answers,
        })
        // this.onLoadResponse(res)
      } */

      //If the Move Option has been Selected, then Call Delete Function to Delete the Original Question
      if (this.state.moveMode === 1) {
        //subjectId,topicId,categoryId,subcategoryId,questionId
        this.deleteQuestion(
          this.props.selectedSubjectId,
          this.props.selectedTopicId,
          this.props.selectedCategoryId,
          this.props.selectedSubCategoryId,
          this.props.selectedQuestionId
        );
      }

      //bug id 150 fixes
      NotificationManager.success("Saved successfully!", "Success");
      if (this.state.copyMode === 1) {
        this.createRedirectURL(); //bug-tracker#69
        this.setState({ copyMode: 0, moveMode: 0, loading: false }, () => {
          if (close === true) {
            this.props.close();
          }
        });
      } else {
        if (close === true) {
          this.props.close();
        }
      }
      if (close !== true) {
        this.onLoadResponse(res);
        // this.onLoadQuestionByid();

        // Preventing Generate the value On Update and save - this will stop reRender 
        // if (this.state.isQuestionWithPreview) this.previewQuestion();
      }
      //this.props.hidemodule(res,this.props.selectedIndex)
    });
  }

  close = () => {
    this.props.close();
    this.setState({
      answerIndex: 0,
      answerArrList: [],
      answerList: [],
      loading: false,
    });
  }

  //GetNamesForRedirect - Get Names of Subject ,Topic , Category  and Subcategory , given their IDs
  //bug-tracker#69
  getNamesForRedirect(payload) {
    return ApiRequestService({
      method: "post",
      url: "/getNamesForRedirect",
      data: payload,
    });
  }
  //bug-tracker#69
  async createRedirectURL() {
    if (this.props.copyMode === 1) {
      this.setState({ loading: true });

      const payload = {
        questionID: this.state.questionID,
        categoryID: this.state.categoryId,
        topicID: this.state.topicId,
        subjectID: this.state.subjectId,
      };

      if (
        this.state.subcategoryId !== undefined &&
        this.state.subcategoryId !== null &&
        this.state.subcategoryId !== 0
      ) {
        payload["subCategoryID"] = this.state.subcategoryId;
      }
      let response = await this.getNamesForRedirect(payload);

      if (response.data.data !== undefined && response.data.data !== null) {
        let redirectData = response.data.data;
        // Redirect to the new category page.
        let url =
          "?subject_id=" +
          this.state.subjectId +
          "&topic_id=" +
          this.state.topicId +
          "&category_id=" +
          this.state.categoryId +
          "&subject_name=" +
          redirectData.subjectName +
          "&topic_name=" +
          redirectData.topicName +
          "&category_name=" +
          redirectData.categoryName;
        if (
          this.state.subcategoryId !== undefined &&
          this.state.subcategoryId !== null &&
          this.state.subcategoryId !== 0
        ) {
          url =
            "SubCategoryDetails" +
            url +
            "&subcategory_id=" +
            this.state.subcategoryId +
            "&subcategory_name=" +
            redirectData.subCategoryName;
        } else {
          url = "subCategory" + url;
        }

        this.props.setRedirectURL(url);
        this.setState({ loading: false });
      }
    }
  }
  changeQuestionName(e) {
    //
    var tempQuestionName = e.target.value;
    this.setState({
      questionName: tempQuestionName,
      questionNameDefaultVaule: tempQuestionName,
    });
  }
  randamizeOrderChanges(e) {
    //
    var tempRandamizedOrder = e.target.value;
    this.setState({
      randomizeOrder: tempRandamizedOrder,
    });
  }
  questionTextBelowORAboveImageOnChange(e) {
    // 0- below  1- above
    //
    var tempQuestionTextBelowOrAbove = parseInt(e.target.value, 10);
    this.setState({
      defaultQuestionTextBelowOrAbove: tempQuestionTextBelowOrAbove,
    });
  }
  AnswerTypeOnChange(e) {
    // 0- Radio  1- checkbox 2 - Text
    //
    var tempAnswerType = parseInt(e.target.value, 10);
    console.debug("tempAnswerType", tempAnswerType)
    this.setState({
      defaultAnswerType: tempAnswerType,
    }, () => {
      this.answerTextDisplay();
    });
    if (this.state.questionType === 0 && [70,80,90].includes(tempAnswerType)) {
      let enteredString = TextEditor.getHTMLStringFromEditorState(
        this.state.questionTextEditorObj
      );
      //Vector Questions - Parsing Question Text for Vector Variables
       VectorParserUtil.getVariablesFromText(
          enteredString,
          this.state.vectorVariablesMap
        ).then((vectorVariablesMap)=>{
          this.setState({
            vectorSettingsData:{...VectorSettingsData}, 
            vectorVariablesMap: vectorVariablesMap,
          },()=>{
            this.previewQuestion()
          });
        });
    }

  }

  forCheckBoxQuestionOnChange(e) {
    var tempForCheckBoxQuestion = parseInt(e.target.value, 10);
    console.log("forCheckBoxQuestionOnChange", tempForCheckBoxQuestion)
    this.setState({
      forCheckBoxQuestion: tempForCheckBoxQuestion
    });
  }

  randomizeOrderOnChange(e) {
    //
    if (e.target.checked)
      this.setState({
        defaultRandamizeOrder: 1,
      });
    else
      this.setState({
        defaultRandamizeOrder: 0,
      });
    //
  }

  correctAnswerOnChange(index, thisObj) {
    //
    //

    /*
     */

    var tempAnswerArr = this.state.answerArrList;
    /*
     */
    let toggleValue = 0;
    if (thisObj.target.checked) {
      toggleValue = 1;
    }
    //bug-tracker#161
    if (tempAnswerArr !== null && tempAnswerArr[index] !== undefined) {
      if (tempAnswerArr[index] !== undefined && tempAnswerArr[index] !== null)
        tempAnswerArr[index].is_answer = toggleValue;
    } else {
      tempAnswerArr[index] = answerArrListJsonFunction(index);
      tempAnswerArr[index].is_answer = toggleValue;
    }
    //
    // this.defaultSwitchAnswer.value = !this.defaultSwitchAnswer.value

    this.setState({
      answerArrList: tempAnswerArr,
    });
    //
  }

  /* altAnsTextVisibleOnChange( index,thisObj) {
     
     

    
    

    var tempAnswerArr = this.state.answerArrList;
    
    
    let toggleValue = 0;
    if(thisObj.target.checked)
    {
      toggleValue = 1;
    }
    //bug-tracker#161
    if (tempAnswerArr !== null && tempAnswerArr[index] !== undefined) {
      if (
        tempAnswerArr[index] !== undefined &&
        tempAnswerArr[index] !== null
      )
      tempAnswerArr[index].enable_alt_ans_text  = toggleValue;

    } else {
      tempAnswerArr[index] = answerArrListJson;
      tempAnswerArr[index].enable_alt_ans_text = toggleValue;
    }
    
    // this.defaultSwitchAnswer.value = !this.defaultSwitchAnswer.value

    this.setState({
      answerArrList: tempAnswerArr
    });
    //
  

  var answerList = [];
  var maxLength = 4;
    console.debug(
      'this.state.answerArrList.length',
      this.state.answerArrList.length
    );

    if (this.state.answerArrList.length !== 0) {
      maxLength = this.state.answerArrList.length;
    }

    for (var i = 0; i < maxLength; i++) {
      //
      //
      answerList.push(
        <Answer
          key={i}
          answerText={'Answer ' + (i + 1)}
          answerButton={styles.answerButton}
          correctAnswerSwitch={styles.correctAnswerSwitch}
          correctAnswer={styles.correctAnswer}
          deleteAnswerButton={styles.deleteAnswerButton}
          onAnswerTextChange={this.onAnswerTextChange.bind(this, i)}
          AnswerValue={this.state.textEditorObjAns[i]}
          answerSwitchValue={
            this.state.answerArrList[i] !== undefined &&
            this.state.answerArrList[i].is_answer !== undefined
              ? this.state.answerArrList[i].is_answer
              : 0
          }
          correctAnswerOnChange={this.correctAnswerOnChange.bind(this, i)}
          answerDelete={this.answerDelete.bind(this, i)}
          feedbackVisible={this.state.feedbackVisibility}
          feedbackText={'Feedback for Answer ' + (i + 1)}
          onFeedbackTextChange={this.onFeedbackTextChange.bind(this, i)}
          FeedbackValue={this.state.textEditorObjFeed[i]}
          AltAnswerValue={this.state.textEditorObjAltAns[i]}
          onAltAnswerTextChange={this.onAltAnswerTextChange.bind(this, i)}
          altAnsTextVisible={ this.state.answerArrList[i] !== undefined &&
        this.state.answerArrList[i] !== null
          ? this.state.answerArrList[i].enable_alt_ans_text
          : 0}
          altAnsTextVisibleOnChange={this.altAnsTextVisibleOnChange.bind(this, i)}
        />
      );
    }
    

    this.setState({ answerIndex: i - 1 });
    this.setState({ answerList: answerList });

  }*/

  questionNonGradeOnChange(e) {
    let tempQNG = 0;
    if (e.target.checked) {
      this.setState({
        questionNonGraded: 0,
      });
      tempQNG = 0;
    } else {
      this.setState({
        questionNonGraded: 1,
      });
      tempQNG = 1;
    }
    // this.answerTextDisplay();

    var answerList = [];
    var maxLength = 4;

    if (this.state.answerArrList.length !== 0) {
      maxLength = this.state.answerArrList.length;
    }

    for (var index = 0; index < maxLength; index++) {
      answerList.push(
        <Answer
          key={index}
          index={index}
          answerText={"Answer " + (index + 1)}
          answerButton={styles.answerButton}
          correctAnswerSwitch={styles.correctAnswerSwitch}
          correctAnswer={styles.correctAnswer}
          deleteAnswerButton={styles.deleteAnswerButton}
          onAnswerTextChange={this.onAnswerTextChange.bind(this, index)}
          AnswerValue={this.state.textEditorObjAns[index]}
          answerSwitchValue={
            this.state.answerArrList[index] !== undefined &&
            this.state.answerArrList[index] !== null &&
            this.state.answerArrList[index].is_answer !== undefined &&
            this.state.answerArrList[index].is_answer !== null
              ? this.state.answerArrList[index].is_answer
              : 0
          }
          correctAnswerOnChange={this.correctAnswerOnChange.bind(this, index)}
          answerDelete={this.answerDelete.bind(this, index)}
          feedbackVisible={this.state.feedbackVisibility}
          feedbackText={"Feedback for Answer " + (index + 1)}
          onFeedbackTextChange={this.onFeedbackTextChange.bind(this, index)}
          FeedbackValue={this.state.textEditorObjFeed[index]}
          AltAnswerValue={this.state.textEditorObjAltAns[index]}
          onAltAnswerTextChange={this.onAltAnswerTextChange.bind(this, index)}
          AltFeedbackValue={this.state.textEditorObjAltFeedback[index]}
          onAltFeedbackTextChange={this.onAltFeedbackTextChange.bind(
            this,
            index
          )}
          isRandomized={this.state.questionType === 1 || [50, 60].includes(this.state.defaultAnswerType)}
          answer_display_options={getAnswerDisplayOption(this.state.defaultAnswerType,
            this.state.questionType,
            this.state.answerArrList[index],
            index
          )}
          vectorAnswerFormula={getVectorAnswerFormula(
            this.state.questionType,
            this.state.answerArrList[index],
            index
          )}
          onAnswerDisplayOptionsChange={this.onAnswerDisplayOptionsChange}
          onVectorAnswerChange={this.onVectorAnswerChange}
          questionNonGraded={tempQNG}
          questionType={this.state.questionType}
          defaultAnswerType={this.state.defaultAnswerType}
          questionVectorTableMap={this.state.variablesMap}
          vectorVariablesMap={this.state.vectorVariablesMap}
          vectorAnswerVariablesMap={this.state.answerArrList[index]?.vectorAnswerVariable ? this.state.answerArrList[index]?.vectorAnswerVariable 
            : VectorParserUtil.createDefaultVectorVariableMap(this.state.vectorAnswerVariablesMap,this.state.vectorSettingsData,"")}
          onAddVectorAnswer={this.onAddVectorAnswer}
          onRemoveVectorAnswer={this.onRemoveVectorAnswer}
          vectorAnswerVariable={ this.state.answerArrList[index]?.vectorAnswerVariable ? this.state.answerArrList[index]?.vectorAnswerVariable :
             [VectorParserUtil.createDefaultVectorVariable(VectorSettingsData,"")]}
             onVectorAnswerVariableChange={this.onVectorVariableChange}
        />
      );
    }
    this.setState({ answerIndex: index - 1 });
    this.setState({ answerList: answerList });

    //
  }

  onQuestionTypeChange = (value) => {
    this.setState(
      {
        questionType: value,
      },
      () => {
        let enteredString = TextEditor.getHTMLStringFromEditorState(
          this.state.questionTextEditorObj
        );
        //Vector Questions - Parsing Question Text for Vector Variables
        if (this.state.questionType === 3 || (this.state.questionType === 0 && [70,80,90].includes(this.state.defaultAnswerType)) ) {
         VectorParserUtil.getVariablesFromText(
            enteredString,
            this.state.vectorVariablesMap
          ).then((vectorVariablesMap)=>{
            this.setState({
              vectorSettingsData:{...VectorSettingsData}, 
              vectorVariablesMap: vectorVariablesMap,
            },()=>{
              this.previewQuestion()
            });
          });
      
    }
        this.setState({
          // This has to be done because, the answer list stored as an UI Element Array in State instead of an Object of Properties,
          // hence the questionType Prop is not changed when the state of the parent changes
          // and the questionType has to be forcefully updated like this, not an ideal solution,
          // but the one that doesn't require the refactoring
          // of the entire code.
          answerList: this.state.answerList.map((ans) => {
            return {
              ...ans,
              props: { ...ans.props, questionType: this.state.questionType },
            };
          }),
        });
      }
    );

    if (value === 1) {
      this.initRandomizedParameters();
    }

    if (value === 2) {
      //If Question Type is MultipleQuestion Table
      this.initializeMQT();
    }

    if (value === 4) { // Reasoning elements
      this.setState({
        answerList: [],
      })

    }
    // this.answerTextDisplay();
  };

  isRCTextValid = (type, text, imgCount) => {

    // Check validation for RE has images and if no alt text is added
    let altText = text;
    altText = altText.replace(/\n/gi,"");
    altText = altText.replace(/ /g,"");

    if (altText === "") {
      alert(
        `"Title and Alternative Text for all Images in ${type}" is Empty. Please enter a valid text.`
      );
      return false;
    }

    let attrTextArr = altText.split(";");
    attrTextArr = attrTextArr.filter(function (el) {
      return el !== "";
    });

    let attrTextCount = attrTextArr.length;

    if (attrTextCount % 2 !== 0) {
      alert(
        `Title or Alternative text is missing in "Title and Alternative Text for all Images in ${type}"`
      );
      return false;
    }

    if (imgCount !== attrTextCount / 2) {
      alert(
        `Please enter a valid text for all images in "Title and Alternative Text for all Images in ${type}"`
      );
      return false;
    }
    var lastChar = altText[altText.length - 1];
    if (lastChar === ";") {
      alert(
        `Please remove semicolon at the end of the text in "Title and Alternative Text for all Images in ${type}"`
      );
      return false;
    }

    return true;

  } 

  handleAddReasoningElement = () => {

    if (this.state.altReasoningElementVisible) {
      if (!this.isRCTextValid("Reasoning Element", this.state.altReasoningElementText, this.state.altReasoningElementImgTagCount)) {
        return;
      }
    }

    console.debug("this.state.reasoningElementEditorState",this.state.reasoningElementEditorState)

    let reasoningElementText = TextEditor.getHTMLStringFromEditorState(this.state.reasoningElementEditorState);
    console.debug("reasoningElementText>>>", reasoningElementText);

    if (reasoningElementText === "" || reasoningElementText === "<p><br></p>") {
      NotificationManager.warning("Please enter your reasoning element text in the text editor", "Reasoning element", 4000)
      return;
    }
    if (this.state.reasoningElementCategoryText === "" ) {
      NotificationManager.warning("Please enter category name", "Empty Category", 4000)
      return;
    }

    if (this.state.selectedReasoningElementIndex > -1) { // Edit/Update Mode
      let updatedReasoningElements = [...this.state.reasoningElements];
      let updatedRE = {
        element: reasoningElementText,
        code: updatedReasoningElements[this.state.selectedReasoningElementIndex].code,
        altText: this.state.altReasoningElementText,
        category: this.state.reasoningElementCategoryText
      }
      
      updatedReasoningElements[this.state.selectedReasoningElementIndex] = updatedRE;
      console.debug("updatedReasoningElements>>>", updatedReasoningElements, this.state.altReasoningElementText)
      this.setState({
        reasoningElements: updatedReasoningElements,
        reasoningElementEditorState: EditorState.createWithContent(ContentState.createFromText('')),
        reasoningElementCategoryText: "",
        selectedReasoningElementIndex: -1,
      })


    } else { // Add Mode
      let codeIndex = 0;
      if (this.state.reasoningElements.length)  {
        let lastCode = this.state.reasoningElements[this.state.reasoningElements.length - 1].code;
        codeIndex = parseInt(lastCode.match(/\d+/)[0], 10) + 1;
      }
      
      let newRE = {
        element: reasoningElementText,
        code: `R${codeIndex}`,
        category: this.state.reasoningElementCategoryText,
        altText: this.state.altReasoningElementText,
      }
      let updatedReasoningElements = [...this.state.reasoningElements, newRE]

      this.setState({
        reasoningElements: updatedReasoningElements,
        reasoningElementEditorState: EditorState.createWithContent(ContentState.createFromText('')),
        reasoningElementCategoryText: "",
        selectedReasoningElementIndex: -1,
      })
    }

    this.setState({
      altReasoningElementText: ""
    })
  }

  handleRemoveReasoningElement = (index) => {

    let updatedReasoningElements = [...this.state.reasoningElements];
    updatedReasoningElements.splice(index, 1)

    this.setState({
      reasoningElements: updatedReasoningElements
    })
  }

  handleEditReasoningElement = (index) => {
    console.debug("TextEditor.createValueFromString(this.state.reasoningElements[index].element)", this.state.reasoningElements[index].element)
    this.setState({
      reasoningElementEditorState: TextEditor.createValueFromString(this.state.reasoningElements[index].element),
      reasoningElementCategoryText: this.state.reasoningElements[index].category,
      selectedReasoningElementIndex: index,
      altReasoningElementText: this.state.reasoningElements[index].altText,
    })
    if (this.reasoningElementTextEditorRef && this.reasoningElementTextEditorRef.current) {
      this.reasoningElementTextEditorRef.current.scrollIntoView({ behavior: 'smooth' });
    }
  }

  onChangeReasoningElement = (index, value, key) => {
    this.setState({
      reasoningElementCategoryText: value,
    })
    /* console.debug("index, value", index, value);
    let updatedReasoningElements = [...this.state.reasoningElements];
    updatedReasoningElements[index][key] = value;

    this.setState({
      reasoningElements: updatedReasoningElements
    }) */
  }


  handleAddConnectingWords = () => {
    if (this.state.connectingWordText === "") {
      NotificationManager.warning("Please enter a connecting word", "Empty connecting word")
      return
    }
    let codeIndex = 0;
    if (this.state.connectingWords.length) {
      let lastCode = this.state.connectingWords[this.state.connectingWords.length - 1].code;
      codeIndex = parseInt(lastCode.match(/\d+/)[0], 10) + 1;
    }
    let newConnWord = {
      code: `J${codeIndex}`,
      word: this.state.connectingWordText,
    }
    let newConnectingWords = [...this.state.connectingWords, newConnWord]
    this.setState({
      connectingWords: newConnectingWords,
      connectingWordText: "",
    })
  }

  handleRemoveConnectingWords = (index) => {
    let updatedconnectingWords = [...this.state.connectingWords];
    updatedconnectingWords.splice(index, 1)

    console.debug("updatedconnectingWords", updatedconnectingWords)

    this.setState({
      connectingWords: updatedconnectingWords
    })
  }

  onChangeConnectingWords = (index, value) => {
    console.debug("index, value", index, value);
    let updatedconnectingWords = [...this.state.connectingWords];
    updatedconnectingWords[index].word = value;

    this.setState({
      connectingWords: updatedconnectingWords
    })
  }


  handleAddconclusionSentences = () => {

    if (this.state.altConclusionSentenceVisible) {
      if (!this.isRCTextValid("Conclusion", this.state.altConclusionSentenceText, this.state.altConclusionSentenceImgTagCount)) {
        return;
      }
    }

    let conlusionSentenceText = TextEditor.getHTMLStringFromEditorState(this.state.conclusionEditorState);

    if (conlusionSentenceText === "" || conlusionSentenceText === "<p><br></p>") {
      NotificationManager.warning("Please enter your conclusion sentence in the text editor", "Conclusion Sentences", 4000)
      return;
    }

    if (this.state.selectedConclusionIndex > -1) { // Edit/Update Mode
      
      let updatedConclusionSentences = [...this.state.conclusionSentences];
      updatedConclusionSentences[this.state.selectedConclusionIndex].sentence = conlusionSentenceText;
      updatedConclusionSentences[this.state.selectedConclusionIndex].altText = this.state.altConclusionSentenceText;
      this.setState({
        conclusionSentences: updatedConclusionSentences,
        conclusionEditorState: EditorState.createWithContent(ContentState.createFromText('')),
        selectedConclusionIndex: -1,
      })

    } else { // Add Mode
      let codeIndex = 0;
      if (this.state.conclusionSentences.length) {
        let lastCode = this.state.conclusionSentences[this.state.conclusionSentences.length - 1].code;
        codeIndex = parseInt(lastCode.match(/\d+/)[0], 10) + 1;
      }
      
      let newConclSentence = {
        code: `C${codeIndex}`,
        sentence: conlusionSentenceText,
        altText: this.state.altConclusionSentenceText,
      }
      let updatedConclusionSentences = [...this.state.conclusionSentences, newConclSentence]

      this.setState({
        conclusionSentences: updatedConclusionSentences,
        conclusionEditorState: EditorState.createWithContent(ContentState.createFromText('')),
        selectedConclusionIndex: -1,
      })
    }

    this.setState({
      altConclusionSentenceText: ""
    })
  }

  handleEditConclusionSentence = (index) => {
    
    this.setState({
      conclusionEditorState: TextEditor.createValueFromString(this.state.conclusionSentences[index].sentence),
      selectedConclusionIndex: index,
      altConclusionSentenceText: this.state.conclusionSentences[index].altText,
    })
    if (this.conclusionTextEditorRef && this.conclusionTextEditorRef.current) {
      this.conclusionTextEditorRef.current.scrollIntoView({ behavior: 'smooth' });
    }
  }

  
  handleRemoveConclusionSentences = (index) => {
    let updatedConclusionSentences = [...this.state.conclusionSentences];
    updatedConclusionSentences.splice(index, 1)

    console.debug("updatedConclusionSentences", updatedConclusionSentences)

    this.setState({
      conclusionSentences: updatedConclusionSentences
    })
  }

  onQuestionOwnershipChange = (value) => {
    this.setState({
      questionOwnership: value,
    });

    if (value === 1) {
      this.setState({
        showOwnershipAttribute: true,
      });
    } else {
      this.setState({
        showOwnershipAttribute: false,
      });
    }
  };
  onOwnershipAttributeChange = (value) => {
    this.setState({
      ownershipAttributeObj: value,
    });
  };

  initRandomizedParameters = () => {
    console.log('init randomise param');
    let enteredString = TextEditor.getHTMLStringFromEditorState(
      this.state.questionTextEditorObj
    );

    console.debug("enteredString, this.state.variablesMap",  enteredString, this.state.variablesMap)

    //Randomized Questions - Parsing Question Text for Variables

    let variablesMap = MathParserUtil.getVariablesFromText(
      enteredString,
      this.state.variablesMap
    );

    this.setState({
      variablesMap: variablesMap,
    });

    let ansArrayList = this.state.answerArrList;
    ansArrayList = ansArrayList.map((value) => {
      if (
        value &&
        (value.answer_display_options === undefined ||
          value.answer_display_options === null)
      ) {
        value.answer_display_options = createEmptyDisplayOption();
      }
      return value;
    });

    this.setState({
      answerArrList: ansArrayList,
    });
  };

  enableAnalyticsOnChange = (e) => {
    this.setState({ enableAnalytics: e.target.checked });
  };

  enableFeedbackOnChange = (e) => {
    this.setState({ enableFeedback: e.target.checked });
    this.setState({ feedbackVisibility: e.target.checked });
    var answerList = [];
    var maxLength = 4;
    /* console.debug(
        'this.state.answerArrList.length',
        this.state.answerArrList.length
      ); */

    if (this.state.answerArrList.length !== 0) {
      maxLength = this.state.answerArrList.length;
    }

    for (var index = 0; index < maxLength; index++) {
      //
      //
      answerList.push(
        <Answer
          key={index}
          index={index}
          answerText={"Answer " + (index + 1)}
          answerButton={styles.answerButton}
          correctAnswerSwitch={styles.correctAnswerSwitch}
          correctAnswer={styles.correctAnswer}
          deleteAnswerButton={styles.deleteAnswerButton}
          onAnswerTextChange={this.onAnswerTextChange.bind(this, index)}
          AnswerValue={this.state.textEditorObjAns[index]}
          answerSwitchValue={
            this.state.answerArrList[index] !== undefined &&
            this.state.answerArrList[index].is_answer !== undefined
              ? this.state.answerArrList[index].is_answer
              : 0
          }
          correctAnswerOnChange={this.correctAnswerOnChange.bind(this, index)}
          answerDelete={this.answerDelete.bind(this, index)}
          feedbackVisible={e.target.checked}
          feedbackText={"Feedback for Answer " + (index + 1)}
          onFeedbackTextChange={this.onFeedbackTextChange.bind(this, index)}
          FeedbackValue={this.state.textEditorObjFeed[index]}
          AltAnswerValue={this.state.textEditorObjAltAns[index]}
          onAltAnswerTextChange={this.onAltAnswerTextChange.bind(this, index)}
          AltFeedbackValue={this.state.textEditorObjAltFeedback[index]}
          onAltFeedbackTextChange={this.onAltFeedbackTextChange.bind(
            this,
            index
          )}
          questionNonGraded={this.state.questionNonGraded}
          questionType={this.state.questionType}
          defaultAnswerType={this.state.defaultAnswerType}
          questionVectorTableMap={this.state.variablesMap}
          vectorVariablesMap={this.state.vectorVariablesMap}
          vectorAnswerVariablesMap={this.state.answerArrList[index]?.vectorAnswerVariable ? this.state.answerArrList[index]?.vectorAnswerVariable 
            : VectorParserUtil.createDefaultVectorVariableMap(this.state.vectorAnswerVariablesMap,this.state.vectorSettingsData,"")}
          onAddVectorAnswer={this.onAddVectorAnswer}
          onRemoveVectorAnswer={this.onRemoveVectorAnswer}
          vectorAnswerVariable={ this.state.answerArrList[index]?.vectorAnswerVariable ? this.state.answerArrList[index]?.vectorAnswerVariable :
             [VectorParserUtil.createDefaultVectorVariable(VectorSettingsData,"")]}
             onVectorAnswerVariableChange={this.onVectorVariableChange}
          /*altAnsTextVisible={ this.state.answerArrList[index] !== undefined &&
          this.state.answerArrList[index] !== null
            ? this.state.answerArrList[index].enable_alt_ans_text
            : 0}
            altAnsTextVisibleOnChange={this.altAnsTextVisibleOnChange.bind(this, index)}*/
        />
      );
    }
    //

    this.setState({ answerIndex: index - 1 });
    this.setState({ answerList: answerList });
  };
  onVariableTableRowChange = (variableObj) => {
    console.log('onVariableTableRowChange', variableObj )
    //On vector Question Variable Change
    if(variableObj?.type ===   "FLOAT") {
      this.onQuestionVariableChange(variableObj?.sigFig)
    }
    const formatValue = (value) => value.toString();
      if(variableObj.autoOrigin){
        variableObj.posX = formatValue(Math.trunc((variableObj.gridWidthUnit / 2) - (variableObj.x/2)));
        variableObj.posY = formatValue(Math.trunc((variableObj.gridHeightUnit / 2) - (variableObj.y/2)));
        console.log(variableObj.name," = ","Auto X-Orgin", variableObj.posX, "Auto Y-Orgin", variableObj.posY) 
      } 
    let varMap = this.state.variablesMap;
    if(varMap !== undefined && varMap !== null){
      varMap.set(variableObj.name, variableObj);
      //console.log('onVariableTableRowChange', varMap)
      this.setState({
        variablesMap: varMap,
      }, () => {
        const vectorSettingsData = this.state.vectorSettingsData;
        const newVectorValues = this.state.vectorVariablesMap?this.state.vectorVariablesMap.getVectorsArray(vectorSettingsData.widthUnit, vectorSettingsData.heightUnit, vectorSettingsData.enableIdenticalVector):[];
        if(newVectorValues && newVectorValues.length > 0) {
          if(this.state.vectorState.length > 0 && newVectorValues.length > 0) {
            for (let _index = 0; _index < this.state.vectorState.length; _index++) {
              const _vectorElement = this.state.vectorState[_index];
              newVectorValues[_index].x = _vectorElement.x;
              newVectorValues[_index].y = _vectorElement.y; 
            }
          }
          
          if(this.canvasRef.current) {
            this.canvasRef.current.drawVectors({
              vectors: newVectorValues,
              updatedGridStepSize: this.state.vectorSettingsData.stepSize
            });
          }

          setTimeout(() => {
            this.setState({ questionCanvasComponentGuid: GetNewComponentGuid() })
          }, 100);
        }
      });
      /* Check the vector question bounds and min & max */
      this.vectorQuestionboundcheck();
      
      // if (this.state.isQuestionWithPreview) {
      //   this.previewQuestion();
      // }
    }
  };


  onAddVectorAnswer = (index) => {
    let tempanswerArrList = [...this.state.answerArrList];
  
    if ((this.state.questionType === 0 && [70,80].includes(this.state.defaultAnswerType) )) {
      for (let ansIndex = 0; ansIndex < tempanswerArrList.length; ansIndex++) {
        const element = tempanswerArrList[ansIndex];
        if(element === undefined || element == null) {
          tempanswerArrList[ansIndex] = answerArrListJsonFunction(ansIndex);
          tempanswerArrList[ansIndex].vectorAnswerVariable = [VectorParserUtil.createDefaultVectorVariable(this.state.vectorSettingsData,"")]
        }
        if(element.vectorAnswerVariable === undefined || element.vectorAnswerVariable == null  || element.vectorAnswerVariable.length == 0 ) {
          tempanswerArrList[ansIndex].vectorAnswerVariable = [VectorParserUtil.createDefaultVectorVariable(this.state.vectorSettingsData,"")]
        }
      };
    }
    if (tempanswerArrList && tempanswerArrList.length > 0 && tempanswerArrList[index]) {
      // Get the last variable name in vectorAnswerVariablesMap
      const vectorAnswerVariable = tempanswerArrList[index]?.vectorAnswerVariable;
      if (!vectorAnswerVariable || vectorAnswerVariable.length === 0 ) {
        alert(
          'Please enter the vaild vector for correct answer in "Answer ' +
            (index + 1) +
            '" configuration'
        );
        return
       }
      let lastVariable = "";
      if (vectorAnswerVariable && vectorAnswerVariable.length > 0) {
        // Get the last variable's name from the last entry
        lastVariable = vectorAnswerVariable[vectorAnswerVariable.length - 1].name || "";
        lastVariable = lastVariable.replace(/\\vec{|}/g, "").toUpperCase();; // Extract the variable (e.g., 'A', 'B', etc.)
        // Call createDefaultVectorVariableMap with the last variable
        tempanswerArrList[index].vectorAnswerVariable.push(VectorParserUtil.createDefaultVectorVariable(
          this.state.vectorSettingsData, 
          lastVariable
        ))
      }
    }

    this.setState({
      answerArrList: tempanswerArrList
    }, () => {
      this.answerTextDisplay()
    });
  };

  onRemoveVectorAnswer = (answerIndex,variableIndex) => {
    let tempanswerArrList = [...this.state.answerArrList];
  
    if ((this.state.questionType === 0 && [70,80,90].includes(this.state.defaultAnswerType) )) {
      for (let ansIndex = 0; ansIndex < tempanswerArrList.length; ansIndex++) {
        const element = tempanswerArrList[ansIndex];
        if(element === undefined || element == null) {
          tempanswerArrList[ansIndex] = answerArrListJsonFunction(ansIndex);
        }
      };
    }
    if (tempanswerArrList && tempanswerArrList.length > 0 && tempanswerArrList[answerIndex]) {
      // Get the last variable name in vectorAnswerVariablesMap
      const vectorAnswerVariable = tempanswerArrList[answerIndex].vectorAnswerVariable;
      let lastVariable = "";
  
      if (vectorAnswerVariable && vectorAnswerVariable.length > 1) {

        tempanswerArrList[answerIndex].vectorAnswerVariable.splice(variableIndex,1)
      }
    }

    this.setState({
      answerArrList: tempanswerArrList
    }, () => {
      this.answerTextDisplay()
    });
  };
  onVectorVariableChange = (index,variableObj) => {
  
    let answerArrList = [...this.state.answerArrList];
      if ((this.state.questionType === 0 && [70,80,90].includes(this.state.defaultAnswerType) )) {
        for (let ansIndex = 0; ansIndex < answerArrList.length; ansIndex++) {
          const element = answerArrList[ansIndex];
          if(element === undefined || element == null) {
            answerArrList[ansIndex] = answerArrListJsonFunction(ansIndex);
          }
        };
      }
      
      if (answerArrList && answerArrList.length > 0 && answerArrList[index]) {
        let tempAnswerVariable = answerArrList[index]?.vectorAnswerVariable

        if (tempAnswerVariable !== null && tempAnswerVariable !== undefined && tempAnswerVariable.length > 0  ){
          let variableIndex = tempAnswerVariable?.findIndex((variable) => variable.name === variableObj.name);
          if (variableIndex !== -1) {   
            tempAnswerVariable[variableIndex] = variableObj
            answerArrList[index].vectorAnswerVariable = tempAnswerVariable;
            this.setState({ answerArrList });
          }
        } else {
          tempAnswerVariable = [variableObj]
          answerArrList[index].vectorAnswerVariable = tempAnswerVariable;
          this.setState({ answerArrList });
        }

        var tempAnsList = this.state.answerList.slice();
        tempAnsList[index] = (
          <Answer
            key={index}
            index={index}
            answerText={"Answer " + (index + 1)}
            answerButton={styles.answerButton}
            correctAnswerSwitch={styles.correctAnswerSwitch}
            correctAnswer={styles.correctAnswer}
            deleteAnswerButton={styles.deleteAnswerButton}
            onAnswerTextChange={this.onAnswerTextChange.bind(this, index)}
            AnswerValue={this.state.textEditorObjAns[index]}
            size={this.state.isQuestionWithPreview ? 10 : 6}
            answerDelete={this.answerDelete.bind(this, index)}
            correctAnswerOnChange={this.correctAnswerOnChange.bind(this, index)}
            answerSwitchValue={
              this.state.answerArrList[index] !== undefined &&
              this.state.answerArrList[index] !== null
                ? this.state.answerArrList[index].enable_alt_ans_text
                : 0
            }
            feedbackVisible={this.state.feedbackVisibility}
            isRandomized={this.state.questionType === 1 || [50, 60].includes(this.state.defaultAnswerType)}
            feedbackText={"Feedback for Answer " + (index + 1)}
            onFeedbackTextChange={this.onFeedbackTextChange.bind(this, index)}
            FeedbackValue={this.state.textEditorObjFeed[index]}
            AltAnswerValue={this.state.textEditorObjAltAns[index]}
            onAltAnswerTextChange={this.onAltAnswerTextChange.bind(this, index)}
            AltFeedbackValue={this.state.textEditorObjAltFeedback[index]}
            onAltFeedbackTextChange={this.onAltFeedbackTextChange.bind(
              this,
              index
            )}
            answer_display_options={getAnswerDisplayOption(this.state.defaultAnswerType,
              this.state.questionType,
              this.state.answerArrList[index],
              index
            )}
            vectorAnswerFormula={this.state.vectorAnswerFormula}
            onAnswerDisplayOptionsChange={this.onAnswerDisplayOptionsChange}
            onVectorAnswerChange={this.onVectorAnswerChange}
            questionNonGraded={this.state.questionNonGraded}
            questionType={this.state.questionType}
            defaultAnswerType={this.state.defaultAnswerType}
            vectorVariablesMap={this.state.vectorVariablesMap}
            vectorAnswerVariablesMap={this.state.answerArrList[index]?.vectorAnswerVariable ? this.state.answerArrList[index]?.vectorAnswerVariable 
              : VectorParserUtil.createDefaultVectorVariableMap(this.state.vectorAnswerVariablesMap,this.state.vectorSettingsData,"")}
            onAddVectorAnswer={this.onAddVectorAnswer}
            onRemoveVectorAnswer={this.onRemoveVectorAnswer}
            vectorAnswerVariable={tempAnswerVariable}
            onVectorAnswerVariableChange={this.onVectorVariableChange}
          />
        );
  
        this.setState({ answerList: tempAnsList }, () => {
          
          this.answerRefreshCallback()
        });
      }
  };
  getFileContents = (text) => {
    let obj = {};
    for (let [key, value] of text) {
      obj[key] = value;
    }
    // set formula text
    let answerFormulaValueChange = this.state.answer_formula
    if (this.state.variablesMap.size === 0) {
      answerFormulaValueChange.formula = ''
    }
    else {
      answerFormulaValueChange.formula = '{{' + this.state.variablesMap.entries().next().value[0] + '}}'
    }
    var formulaMap; 
    formulaMap = MathParserUtil.getAnswerFormulasFromText(answerFormulaValueChange.formula,answerFormulaValueChange.formulaMap);
    answerFormulaValueChange.formulaMap = formulaMap;
    // set validation mode to LIST
    let tempValidationObject = {
      text: answerFormulaValueChange.formula
    };
    let formulaMapTemp = answerFormulaValueChange.formulaMap;
    formulaMapTemp.set(tempValidationObject.text,{...tempValidationObject,validationMode: "list"});
    answerFormulaValueChange.formulaMap = formulaMapTemp;
    this.setState({
      answer_formula: answerFormulaValueChange,
      defaultAnswerType: 3,
    });
    this.onDisplayStyleChange("4")
    for (const formulaItem of Array.from(this.state.answer_formula.formulaMap.values())){
      formulaItem.listValues = obj;
    }
    this.setState({
      answer_formula: this.state.answer_formula,
    });
  };

  onAnswerFormulaChange = (value) => {
    this.setState({ answer_formula: { ...value } });
  };

  /**
   * MQT Functions
   **/
  //Initialize MQT Options
  initializeMQT = (mqt_options) => {
    this.initializeMQTQuestions(mqt_options);
    this.initializeMQTAnswers(mqt_options);
  };

  initializeMQTQuestions = (mqt_options) => {
    if(mqt_options){
      const mqt_questions ={};
      if(mqt_options.mqt_questions) {
        var id = "";
        
        for (let i = 0; i < Object.keys(mqt_options.mqt_questions).length; i++) {
          id = Object.keys(mqt_options.mqt_questions)[i];
          mqt_questions[id] = createMQTObjectFromString(mqt_options.mqt_questions[id], i+1);
        };
        this.setState({
          mqt_questions,
          mqt_hide_question:mqt_options.mqt_hide_question,
          mqt_question_answer_map:mqt_options.mqt_question_answer_map?mqt_options.mqt_question_answer_map:null,
          mqt_question_random_order:mqt_options.mqt_question_random_order,
          mqt_answers_random_order : mqt_options.mqt_answers_random_order,
          mqt_mastery_condition:mqt_options.mqt_mastery_condition,
          mqt_answer_type:mqt_options.mqt_answer_type
        });
      }
    }

    if (
      !this.state.mqt_questions ||
      Object.keys(this.state.mqt_questions).length <= 0
    ) {
      //Create 2 Empty Question Rows
      let mqt_questions = {};
      for (let index = 0; index < 1; index++) {
        const mqt_question = {
          id:index + 1+'_'+shortid.generate(),
          displayOrder: index + 1,
          value:TextEditor.createEmptyValue()
        }; 

        mqt_questions[mqt_question.id] = mqt_question;
      }

      this.setState({
        mqt_questions,
      });
    }
  };

  initializeMQTAnswers = (mqt_options) => {
    if(mqt_options){
      let mqt_answers = {};
      const mqt_answer_header = mqt_options.mqt_answer_header;
      const mqt_answer_count = mqt_options.mqt_answer_count;
      var id = "";
      if(mqt_options.mqt_answers){
        for (let i = 0; i < Object.keys(mqt_options.mqt_answers).length; i++) {
          id = Object.keys(mqt_options.mqt_answers)[i];
          mqt_answers[id] = createMQTObjectFromString(mqt_options.mqt_answers[id], i+1);
        }
        this.setState({
          mqt_answers: mqt_answers
        });
      }

      this.setState({
        mqt_answer_count,
        mqt_answer_header,
      });
    }
    if (
      !this.state.mqt_answers ||
      Object.keys(this.state.mqt_answers).length <= 0
    ) {
      let mqt_answers = {};
      for (let index = 1; index <= 5; index++) {
        let mqt_answer ={
          id:index+'_'+shortid.generate(),
          displayOrder: index,
          value:TextEditor.createEmptyValue()
        }; 
        
        mqt_answers[mqt_answer.id] = mqt_answer;
      }

      this.setState({
        mqt_answers,
      });
    }
  };

  
  addMQTQuestion = async () => {
    let mqt_questions = this.state.mqt_questions;

    let mqt_questions_array = objectsToArray(Object.values(mqt_questions));
    let displayOrder = (Object.keys(mqt_questions)).length;
    if(mqt_questions_array && mqt_questions_array.length > 0) {
      // When we remove the questions from array, the index got changed so getting index from previos one
      displayOrder = mqt_questions_array[mqt_questions_array.length - 1].displayOrder;
    }

    const mqt_question = await new Promise((resolve, reject) => {
          resolve({id:generateNewKeyIndex(displayOrder)+'_'+shortid.generate(),
          displayOrder: displayOrder + 1,
          value:TextEditor.createEmptyValue()})
    });
    mqt_questions[mqt_question.id] = mqt_question;

    
    this.setState({
      mqt_questions
    }, this.resetOnQuestionCountChange());
  }

  addMQTAnswer = () => {
    let mqt_answers = this.state.mqt_answers;

    let mqt_answers_array = objectsToArray(Object.values(mqt_answers));
    let displayOrder = (Object.keys(mqt_answers)).length;
    if(mqt_answers_array && mqt_answers_array.length > 0) {
      // When we remove the questions from array, the index got changed so getting index from previos one
      displayOrder = mqt_answers_array[mqt_answers_array.length - 1].displayOrder;
    }

    const mqt_answer = {id:generateNewKeyIndex(displayOrder)+'_'+shortid.generate(),
      displayOrder: displayOrder + 1,
      value:TextEditor.createEmptyValue()};
      mqt_answers[mqt_answer.id]=mqt_answer;

    this.setState(
      {
        mqt_answers,
      },
      this.resetOnMQTAnswerCountChange()
    );
  };

  onMQTQuestionDelete = (key) => {
    let mqt_questions = this.state.mqt_questions;
    let mqt_questions_array = objectsToArray(Object.values(mqt_questions));
    if(mqt_questions_array && mqt_questions_array.length > 1) {
      delete mqt_questions[key];
      this.setState({
        mqt_questions
      },this.resetOnQuestionCountChange());
    } else {
      NotificationManager.error(
        'There should be a minimum of 1 questions',
        "Error",
        5000
      );
    }
  }

  onMQTAnswerDelete = (key) => {
    let mqt_answers = this.state.mqt_answers;
    let mqt_answers_array = objectsToArray(Object.values(mqt_answers));
    if(mqt_answers_array && mqt_answers_array.length > 2) {
      delete mqt_answers[key];
      let new_mqt_answers = {};
      Object.keys(mqt_answers).forEach((mqt_answer_key, index) => {
        let displayOrder = index+1
        mqt_answers[mqt_answer_key].displayOrder = displayOrder
        let char = mqt_answers[mqt_answer_key].id[0]
        let replacedID = mqt_answers[mqt_answer_key].id.replace(char, String(displayOrder))
        mqt_answers[mqt_answer_key].id = replacedID
        new_mqt_answers[replacedID] = mqt_answers[mqt_answer_key]
      })
      this.setState({
        mqt_answers: new_mqt_answers
      },this.resetOnMQTAnswerCountChange());
    } else {
      NotificationManager.error(
        'There should be a minimum of 2 answers',
        "Error",
        5000
      );
    }
   
  }

  onMQRQuestionChange = (key, editorState) => {
    let mqt_questions = {...this.state.mqt_questions};
    //let question = mqt_questions.get(key);
    // console.log('onMQRQuestionChange', editorState)
    mqt_questions[key.id] =  {value:editorState, displayOrder:key.displayOrder, id:key.id}
    this.setState({
      mqt_questions: mqt_questions
    });
  };

  onMQRAnswerChange = (key, editorState) => {
    let mqt_answers = {...this.state.mqt_answers};
    mqt_answers[key.id] = {value:editorState,displayOrder:key.displayOrder,id:key.id};
    this.setState({
      mqt_answers: mqt_answers
    });
  };

  onmqt_answer_headerChange = (event) => {
    this.setState(
      { mqt_answer_header: event.target.checked },
      this.resetOnMQTAnswerCountChange()
    );
  };

  onmqt_hide_questionChange = (e) => {
    this.setState(
      { mqt_hide_question: e.target.checked }
    );
  }

  onmmqt_answer_countChange = (value) => {
    this.setState(
      { mqt_answer_count: parseInt(value, 10) },
      this.resetOnMQTAnswerCountChange()
    );
  };

  onmqt_answer_typeChange = (e) => {
    //
    this.setState({ mqt_answer_type: e.target.value });
  };

  

  resetOnMQTAnswerCountChange = () => {
    this.setState({ mqt_question_answer_map: {} });
  };

  resetOnQuestionCountChange = () => {
    this.setState({ mqt_mastery_condition: 0 });
  };

  addMQTToPayload = (payload) => {
    if(payload){
      const mqt_questions = {}; 

      Object.keys(this.state.mqt_questions).forEach(async(key) => {
        const question = this.state.mqt_questions[key];
        mqt_questions[question.id] = await cloneMQTQuestionObject(question,true);
      });

      if (Object.keys(this.state.mqt_answers).length < 2) {
        NotificationManager.error(
          'There should be a minimum of 2 answers',
          "Error",
          5000
        );
        return null
      }
      
      const mqt_answers = {};
      Object.keys(this.state.mqt_answers).forEach(async(key) => {
        const answer = this.state.mqt_answers[key];
        mqt_answers[answer.id] = await cloneMQTQuestionObject(answer,true);
      });

      const mqt_options = {
        mqt_questions,
        mqt_answers,
        mqt_answer_count:this.state.mqt_answer_count,
        mqt_hide_question:this.state.mqt_hide_question,
        mqt_answer_header:this.state.mqt_answer_header,
        mqt_question_answer_map:this.state.mqt_question_answer_map,
        mqt_question_random_order:this.state.mqt_question_random_order,
        mqt_answers_random_order: this.state.mqt_answers_random_order,
        mqt_mastery_condition:this.state.mqt_mastery_condition,
        mqt_answer_type:this.state.mqt_answer_type
      }

      payload['mqt_options'] = mqt_options;
    }

    return payload;
  };

  onmMQTCorrectAnswerChange = (question, value) => {
    const mqt_question_answer_map = this.state.mqt_question_answer_map;

    mqt_question_answer_map[question.id] = value.toString();
    //
    this.setState({
      mqt_question_answer_map,
    });
  };

  onMQTQuestionRandomOrder = (event) =>{
    this.setState({mqt_question_random_order:event.target.checked});
  }

  onMQTAnswersRandomOrder = (event) =>{
    this.setState({mqt_answers_random_order:event.target.checked});
  }
  /** 
   * MQT Functions End
   **/

  OnComponentShowChange =(event , type) => {
    if(type === 'showComponents'){
      this.setState({showComponents: event.target.checked})
    }else if (type === 'showVectorPrompt') {
      this.setState({showVectorPrompt: event.target.checked})
    } else {
      this.setState({showMagnitudeAngle: event.target.checked})
    }
  }

  hidePreviewQuestion = () => {
    this.props.hidePreviewQuestion()
  }

  render() {

    const { questionCanvasComponentGuid, pageLoading } = this.state;
    
    if (pageLoading) {
      return <LoadingSpinner />;
    }

    let questionWithOutPreviewStyle = {
      float: "left",
      width: "100%",
      marginLeft: "17",
    };
    let floatFooter = {
      position: "fixed",
      bottom: "0px",
      width: "100%",
      backgroundColor: "white",
      float: "left",
      zIndex: 9,
    };
    let questionWithPreviewStyle = {
      //width: "60%",
      //overflow: "scroll",
      maxHeight: "90vh",
      marginLeft: "17px",
    };
    let questionWithPreviewWidthStyle = { padding: "0px", marginTop: "35px" };
    let questionWithPreviewSaveBtn = { width: "50%" };
    let showPreviewStyle = {
      float: "right",
      marginTop: "0px",
      //marginLeft: '623px',
      display: "block",
      //position: 'absolute',
      //backgroundColor: 'rgb(242, 243, 244)',
      height: "100vh",
      //width: "35%",
      overflow: "scroll",
    };
    let hidePreviewStyle = {
      float: "left",
      marginTop: "-0px",
      marginLeft: "750px",
      display: "none",
    };
    let padding = { paddingLeft: "97px" };
    let paddingZero = { paddingLeft: "0px" };

    let hideDiv = { display: "none" };

    let questionTextWidth = {};

    var controlEnable = "disabled";
    //
    if (this.state.copyMode === 1) {
      controlEnable = "";
    }

    /*
     */
    /*let saveButtonStyle = {
      display: 'block',
      backgroundColor: '#960000',
      color: 'white',
      width: '200px',
      paddingTop: '5px',
      paddingBottom: '5px',
      textAlign: 'center',
      border: 'none'
    };*/
    //var saveButtonStyleHide = {}
    
    const loadingSave = this.state.loadingSave;

    const baseControlsForVectorRP = [
      { label: "Decimal or E notation", value: "1" },
      { label: "Decimal", value: "5" },
      { label: "E notation", value: "6" },
      { label: "Explicit scientific notation", value: "2" },
    ];

    const baseControls = [...baseControlsForVectorRP, { label: "Fraction", value: "3" },{ label: "Text", value: "4" }];
    const checkIfTextContainsAnImage = (text) => {
      if (text === undefined || text === null || text === "") return false;
      return text.includes("<img") && text.includes("</img>")
    }
    const handleQuestionResize = (type) => {
      console.debug("this.questionCardRef", this.questionCardRef);
      if (this.questionCardRef && this.questionCardRef.current) {
          let images = this.questionCardRef.current.querySelectorAll('img');

          if (images && images.length) {
              let newWidth = type === "plus" ? this.state.questionImageWidth + 100 : this.state.questionImageWidth - 100;
              images.forEach(img => {
                  img.style.setProperty('width', `${newWidth}px`, 'important');
                  if (img.classList.contains("custom-image-align-right")) {
                        if (newWidth >= 700) {
                            img.style.setProperty('float', "none", "important")
                        } else {
                            img.style.setProperty('float', "right", "important")
                        }
                    }
                    if (img.classList.contains("custom-image-align-left")) {
                        if (newWidth >= 700) {
                            img.style.setProperty('float', "none", "important")
                        } else {
                            img.style.setProperty('float', "left", "important")
                        }
                    }
              });
              this.setState({ questionImageWidth: newWidth })
          }
      }
    }
    const handleQuestionPreview = () =>{
      console.log("AppURL=")
      let strToRemove = 'cpanel/'
      console.log("AppURL=", this?.appProperties)
      let url = (this.appProperties.appURL)   
      // let url = "http://localhost:3001/"   
      url = url.replace(strToRemove, "");
      if (process.env.hasOwnProperty("REACT_APP_APPSETTING_REQUIRED")) {
        let hostArray = window.location.hostname.split(".");
        if (hostArray.length > 4) {
          url = `${window.location.protocol}//${hostArray[hostArray.length - 5]}.student.${hostArray[hostArray.length - 3]}.${hostArray[hostArray.length - 2]}.${hostArray[hostArray.length - 1]}/`
        }else if(hostArray.length == 4){
          url = `${window.location.protocol}//${hostArray[hostArray.length - 4]}.student.${hostArray[hostArray.length - 2]}.${hostArray[hostArray.length - 1]}/`
        }
      }
      if(this.appProperties.loginType === "shiboleth"){
        url = url+"student/";
      }
      
      url = url + `previewquestion?topic_id=${this.state.topicId}&subject_id=${this.state.subjectId}&category_id=${this.state.categoryId}&subcategory_id=${this.state.subcategoryId}&question_id=${this.state.selectedQuestionId}`
        
      console.log("AppURL=", url)
      window.open(url)
      this.setState({isQuizAttendedByUser:true})
    }
    return (
      this.props.IsQuestionList ? 
      this.state.loading ?
      <LoadingSpinner loading={this.state.loading} /> :
     
      <div className ={this.props.IsQuestionList && 'livePreviewClass'} style={this.props.IsQuestionList && {width:'95%',marginTop:"30px"}} >
        { this.props.IsQuestionList &&  <div style={styles.livePreviewTitleDiv} >
            <p style={styles.previewTitleBlock}>Live Preview</p>
            <p style={{ float: "right" }}>
            <Button  
              style={{float:"right", paddingTop: '0px'}}
              onClick={() => {
                console.log("Button Clicked!"); 
                this.hidePreviewQuestion();
              }}>
              <img
                className="livePreviewCloseIcon"
                src={crossIcon}
                style={{padding:"0px"}}
                alt="Delete"
              />
            </Button>
            </p>
          </div>}
          <br />
      <div>
        <br />
        <br />
        <div style={styles.previewText}>
         
            <div className='position-relative '
                id={`question-no-${this.props.uniqueID}`}
                style={{
                    backgroundColor: "#EFF1F2",
                    border: "1px solid #A7B1B7",
                    boxShadow: "4px 4px 15px 0px rgba(0, 0, 0, 0.25)",
                    borderRadius: "8px",
                    overflow: 'hidden',
                    width: '100%',
                    height: '100%',
                    padding:  '1rem',
                    transform:  "scale(1)",
                    transition: 'height 0s ease, transform 0.6s ease , width 0.6s ease',
                    borderWidth:  1,
                    transformOrigin: 'bottom left',
                }}>
                <div className='sf-question-card w-100 position-relative' style={{
                    overflowY: 'auto',
                    overflowX:'hidden',
                    opacity:  100,
                    height: '100%',
                }} 
                ref={this.questionCardRef}
                >
                    <div className='d-flex justify-content-between align-items-center sf-question-header-position' style={{ backgroundColor: "#EFF1F2", zIndex:"1" }}>
                        <div className='d-flex justify-content-start' style={{display:"flex"}}>
                            <Typography variant='h6' fontWeight={'500'} className='mb-1'>
                                Question
                            </Typography>
                            <div className='sf-image-resize-btn-container' style={{
                                display: checkIfTextContainsAnImage(MathParserUtil.setVariablesToText(
                                  TextEditor.getHTMLStringFromEditorState(
                                    this.state.questionTextEditorObj
                                  ),
                                  this.state.variablesMap,
                                  { formatValues: true }
                                )) ? 'flex' : 'none'
                            }}>
                                 <button 
                                    className="sf-image-resize-btn" 
                                    icon data-tip data-for='zoomIn-info'
                                    onClick={() => handleQuestionResize("plus")}
                                  >
                                    <HiOutlineZoomIn fontSize={25} />
                                  </button>
                                  <ReactTooltip id='zoomIn-info' type='light' className='tool-tip tooltip-width studenttooltip' place='bottom' >
                                    <span className='studenttooltipClass'>{"Magnify all images within the question"}</span>
                                  </ReactTooltip>
                              

                                  <button
                                        disabled={this.state.questionImageWidth === 200}
                                        style={{
                                            color: this.state.questionImageWidth === 200 ? 'gray' : '#BA0C2F'
                                        }}
                                        icon data-tip data-for='zoomOut-info'
                                        className="sf-image-resize-btn" onClick={() => {
                                            handleQuestionResize("minus")
                                        }}>
                                        <HiOutlineZoomOut fontSize={25} />
                                    </button>
                                  <ReactTooltip id='zoomOut-info' type='light' className='tool-tip tooltip-width studenttooltip' place='bottom' >
                                    <span className='studenttooltipClass'>{"Shrink all images within the question"}</span>
                                  </ReactTooltip>
                              
                            </div>
                        </div>
                    </div>
                  <div className='text-align-left pl-2 px-2'>
                  <MathJax
                              math={this.state.questionType === 3 ?TextEditor.getHTMLStringFromEditorStateWithoutFigure(
                                  this.state.questionTextEditorObj,
                                this.state.variablesMap,
                                { formatValues: true }
                              ):MathParserUtil.setVariablesToText(
                                TextEditor.getHTMLStringFromEditorStateWithoutFigure(
                                  this.state.questionTextEditorObj
                                ),
                                this.state.variablesMap,
                                { formatValues: true }
                              )}
                            />

                          {/* {this.props.questionText !== null ? createVideoLinkIframe(this.props.questionText) : ''} */}
                          {this.state.questionText !== null  ?  TextEditor.createVideoLinkIframe(this.state.questionText):''}
                          {/* {TextEditor.createVideoLinkIframe(this.state.questionTextEditorObj)} */}
                          {/* vectors={vectors} onVectorMoved={onVectorMoved} */}
                          {this.state.questionType === 3 && this.state.vectorSettingsData? (
                            <Canvas
                              ref={this.canvasRef}
                              readOnly={true}
                              degStepSize={5}
                              magStepSize={1}
                              rulerXPoint={this.state.vectorSettingsData.rulerXPoint}
                              rulerYPoint={this.state.vectorSettingsData.rulerYPoint}
                              ComponentGuid={questionCanvasComponentGuid}
                              height={this.state.vectorSettingsData.height}
                              width={this.state.vectorSettingsData.width}
                              stepSize={this.state.vectorSettingsData.stepSize}
                              enableGrid={this.state.vectorSettingsData.enableGrid}
                              enableBorder={this.state.vectorSettingsData.enableBorder}
                              enableDarkGridLine={this.state.vectorSettingsData.enableDarkGridLine}
                              enableRuler={this.state.vectorSettingsData.enableRuler}
                              freeBodyDiagram={this.state.vectorSettingsData.image}
                              fbdWidth={this.state.vectorSettingsData.imageWidth}
                              fbdHeight={this.state.vectorSettingsData.imageHeight}
                              fbdX={this.state.vectorSettingsData.imageX}
                              fbdY={this.state.vectorSettingsData.imageY}
                              stepDeg={true}
                              gridColor={this.state.vectorSettingsData.gridColor}
                              rulerXLabel={this.state.vectorSettingsData.rulerXLabel}
                              rulerYLabel={this.state.vectorSettingsData.rulerYLabel}
                              rulerNXLabel={this.state.vectorSettingsData.rulerNXLabel}
                              rulerNYLabel={this.state.vectorSettingsData.rulerNYLabel}
                              commonVectorSettings={this.state.vectorSettingsData}
                            ></Canvas>
                          ) : null}
                      </div>
                </div>
            </div>


          {this.state.questionType === 3 && this.state.vectorBelowQuestionText !== '' && 
          <div style={{marginTop: '25px'}}>
          <MathJax
            math={this.state.vectorBelowQuestionText}/>
            </div>
          }
        </div>
      </div>
      <div>
        <br />
        {
          this.state.questionType === 2 ?
          this.state.mqt_answer_header ?
          <MQTDisplayOption2 mqt_answer_type={this.state.mqt_answer_type} random_order={this.state.mqt_question_random_order} random_answer_order={this.state.mqt_answers_random_order} mqt_questions={this.state.mqt_questions} mqt_answers={this.state.mqt_answers} mqt_hide_question={this.state.mqt_hide_question}></MQTDisplayOption2>
          :
          <MQTDisplayOption1 mqt_answer_type={this.state.mqt_answer_type}  mqt_questions={this.state.mqt_questions} mqt_answer_count={this.state.mqt_answer_count}></MQTDisplayOption1>
          :
          <this.LivePreviewAnswerUI/>
        }
        
      </div>
      </div>
      : 
      <form className="formClass" onSubmit={e => { e.preventDefault(); }}>
        <fieldset disabled={this.props.readOnly}>
          <div style={{ width: "100%", overflowX: "scroll" }}>
            <Loader loading={this.state.loading} />
            <div style={styles.createQuesPage}>
              {/*Live Preview Div start*/}
              <div
                className="livePreviewClass"
                style={
                  this.state.isQuestionWithPreview && this.state.questionType !== 4
                    ? showPreviewStyle
                    : hidePreviewStyle
                }
              >
                <div style={styles.livePreviewTitleDiv}>
                  <p style={styles.previewTitle}>Live Preview</p>
                  <p style={{ float: "right" }}>
                  {
                    (this.state.questionType === 3 || this.state.questionType === 1) && (
                    
                    <Button
                      className="randomizeButton"
                      flat
                      primary
                      swapTheming
                      style={styles.buttomClass}
                      onClick={this.generateRandomisedAnswer}
                    >
                      Randomize
                    </Button>
                    )}
                     <Button
                        className="exitButton"
                        flat
                        primary
                        swapTheming
                        style={{marginRight:"15px"}}
                        onClick={handleQuestionPreview}
                      >
                      Student Preview
                    </Button>
                      <Button
                        className="exitButton"
                        flat
                        primary
                        swapTheming
                        style={styles.buttomClass}
                        onClick={this.previewExit}
                      >
                      Exit
                    </Button>
                  </p>
                </div>
                <div style={styles.livePreviewQuestionDiv}>
                  {/* <p style={styles.previewTitle}>Question</p> */}
                  <br />
                  <br />
                  <div style={styles.previewText}>
                   
                      <div className='position-relative '
                          id={`question-no-${this.props.uniqueID}`}
                          style={{
                              backgroundColor: "#EFF1F2",
                              border: "1px solid #A7B1B7",
                              boxShadow: "4px 4px 15px 0px rgba(0, 0, 0, 0.25)",
                              borderRadius: "8px",
                              overflow: 'hidden',
                              width: '100%',
                              height: '100%',
                              padding:  '1rem',
                              transform:  "scale(1)",
                              transition: 'height 0s ease, transform 0.6s ease , width 0.6s ease',
                              borderWidth:  1,
                              transformOrigin: 'bottom left',
                          }}>
                          <div className='sf-question-card w-100 position-relative' style={{
                              overflowY: 'auto',
                              overflowX:'hidden',
                              opacity:  100,
                              height: '100%',
                          }} 
                          ref={this.questionCardRef}
                          >
                              <div className='d-flex justify-content-between align-items-center sf-question-header-position' style={{ backgroundColor: "#EFF1F2", zIndex:"1" }}>
                                  <div className='d-flex justify-content-start' style={{display:"flex"}}>
                                      <Typography variant='h6' fontWeight={'500'} className='mb-1'>
                                          Question
                                      </Typography>
                                      <div className='sf-image-resize-btn-container' style={{
                                          display: checkIfTextContainsAnImage(MathParserUtil.setVariablesToText(
                                            TextEditor.getHTMLStringFromEditorState(
                                              this.state.questionTextEditorObj
                                            ),
                                            this.state.variablesMap,
                                            { formatValues: true }
                                          )) ? 'flex' : 'none'
                                      }}>
                                           <button 
                                              className="sf-image-resize-btn" 
                                              icon data-tip data-for='zoomIn-info'
                                              onClick={() => handleQuestionResize("plus")}
                                            >
                                              <HiOutlineZoomIn fontSize={25} />
                                            </button>
                                            <ReactTooltip id='zoomIn-info' type='light' className='tool-tip tooltip-width studenttooltip' place='bottom' >
                                              <span className='studenttooltipClass'>{"Magnify all images within the question"}</span>
                                            </ReactTooltip>
                                        

                                            <button
                                                  disabled={this.state.questionImageWidth === 200}
                                                  style={{
                                                      color: this.state.questionImageWidth === 200 ? 'gray' : '#BA0C2F'
                                                  }}
                                                  icon data-tip data-for='zoomOut-info'
                                                  className="sf-image-resize-btn" onClick={() => {
                                                      handleQuestionResize("minus")
                                                  }}>
                                                  <HiOutlineZoomOut fontSize={25} />
                                              </button>
                                            <ReactTooltip id='zoomOut-info' type='light' className='tool-tip tooltip-width studenttooltip' place='bottom' >
                                              <span className='studenttooltipClass'>{"Shrink all images within the question"}</span>
                                            </ReactTooltip>
                                        
                                      </div>
                                  </div>
                              </div>
                            <div className='text-align-left pl-2 px-2'>
                            <MathJax
                                        math={this.state.questionType === 3 ?TextEditor.getHTMLStringFromEditorStateWithoutFigure(
                                            this.state.questionTextEditorObj,
                                          this.state.variablesMap,
                                          { formatValues: true }
                                        ):MathParserUtil.setVariablesToText(
                                          TextEditor.getHTMLStringFromEditorStateWithoutFigure(
                                            this.state.questionTextEditorObj
                                          ),
                                          this.state.variablesMap,
                                          { formatValues: true }
                                        )}
                                      />
    
                                    {/* {this.props.questionText !== null ? createVideoLinkIframe(this.props.questionText) : ''} */}
                                    {this.state.questionText !== null  ?  TextEditor.createVideoLinkIframe(this.state.questionText):''}
                                    {/* {TextEditor.createVideoLinkIframe(this.state.questionTextEditorObj)} */}
                                    {/* vectors={vectors} onVectorMoved={onVectorMoved} */}
                                    {this.state.questionType === 3 && this.state.vectorSettingsData? (
                                      <Canvas
                                        ref={this.canvasRef}
                                        readOnly={true}
                                        degStepSize={5}
                                        magStepSize={1}
                                        rulerXPoint={this.state.vectorSettingsData.rulerXPoint}
                                        rulerYPoint={this.state.vectorSettingsData.rulerYPoint}
                                        ComponentGuid={questionCanvasComponentGuid}
                                        height={this.state.vectorSettingsData.height}
                                        width={this.state.vectorSettingsData.width}
                                        stepSize={this.state.vectorSettingsData.stepSize}
                                        enableGrid={this.state.vectorSettingsData.enableGrid}
                                        enableBorder={this.state.vectorSettingsData.enableBorder}
                                        enableDarkGridLine={this.state.vectorSettingsData.enableDarkGridLine}
                                        enableRuler={this.state.vectorSettingsData.enableRuler}
                                        freeBodyDiagram={this.state.vectorSettingsData.image}
                                        fbdWidth={this.state.vectorSettingsData.imageWidth}
                                        fbdHeight={this.state.vectorSettingsData.imageHeight}
                                        fbdX={this.state.vectorSettingsData.imageX}
                                        fbdY={this.state.vectorSettingsData.imageY}
                                        stepDeg={true}
                                        gridColor={this.state.vectorSettingsData.gridColor}
                                        rulerXLabel={this.state.vectorSettingsData.rulerXLabel}
                                        rulerYLabel={this.state.vectorSettingsData.rulerYLabel}
                                        rulerNXLabel={this.state.vectorSettingsData.rulerNXLabel}
                                        rulerNYLabel={this.state.vectorSettingsData.rulerNYLabel}
                                        commonVectorSettings={this.state.vectorSettingsData}
                                      ></Canvas>
                                    ) : null}
                                </div>
                          </div>
                      </div>


                    {this.state.questionType === 3 && this.state.vectorBelowQuestionText !== '' && 
                    <div style={{marginTop: '25px'}}>
                    <MathJax
                      math={this.state.vectorBelowQuestionText}/>
                      </div>
                    }
                  </div>
                </div>
                <div>
                  <br />
                  {
                    this.state.questionType === 2 ?
                    this.state.mqt_answer_header ?
                    <MQTDisplayOption2 mqt_answer_type={this.state.mqt_answer_type} random_order={this.state.mqt_question_random_order} random_answer_order={this.state.mqt_answers_random_order} mqt_questions={this.state.mqt_questions} mqt_answers={this.state.mqt_answers} mqt_hide_question={this.state.mqt_hide_question}></MQTDisplayOption2>
                    :
                    <MQTDisplayOption1 mqt_answer_type={this.state.mqt_answer_type}  mqt_questions={this.state.mqt_questions} mqt_answer_count={this.state.mqt_answer_count}></MQTDisplayOption1>
                    :
                    <this.LivePreviewAnswerUI/>
                  }
                  
                </div>
              </div>
              {/*Live Preview Div end */}
              <div
                className="livePreviewWithQuestion"
                style={
                  this.state.isQuestionWithPreview && this.state.questionType !== 4
                    ? questionWithPreviewStyle
                    : questionWithOutPreviewStyle
                }
              >
                <h1>Question Details Page</h1>

                <div style={{ marginLeft: "17px" }}>
                  <label htmlFor="queNameId">
                    <b>Question Name</b>
                  </label>
                </div>
                <br />
                <input
                  id="queNameId"
                  style={styles.questionNameText}
                  type="text"
                  value={this.state.questionNameDefaultVaule}
                  onChange={this.changeQuestionName}
                  placeholder="Add New  Question"
                />
                {this.state.questionType !== 4 ? 
                <Button
                  flat
                  primary
                  swapTheming
                  className="buttonStyle"
                  style={
                    this.state.isQuestionWithPreview
                      ? hideDiv
                      : styles.livePreview
                  }
                  onClick={this.previewQuestion}
                >
                  Live Preview
                </Button> : null}

                {this.props.copyMode ? (
                  <div style={{ padding: "0px", marginLeft: "0px" }}>
                    <br />
                    <p style={{ fontSize: "medium" }}>
                      Please choose a new destination(category or subcategory)
                    </p>
                    <Grid>
                      <Cell size={this.state.isQuestionWithPreview ? 4 : 3}>
                        <br />
                        <SelectBox
                          labeltxt="Subjects"
                          columns={
                            this.state.userprofilerole === 2
                              ? this.state.subjects
                              : this.state.instAllSubjects
                          }
                          keys={["subject_id", "subject_name"]}
                          className="create-question-select-box"
                          selectBoxcallBack={this.selectBoxSubjectHandleChange}
                          defaultId={this.state.subjectDefaultId}
                          selectBoxDisabled={controlEnable}
                        />
                      </Cell>
                      <Cell
                        style={
                          this.state.isQuestionWithPreview
                            ? padding
                            : paddingZero
                        }
                        size={this.state.isQuestionWithPreview ? 4 : 3}
                      >
                        <br />
                        <SelectBox
                          labeltxt="Topics"
                          columns={this.state.topics}
                          keys={["topic_id", "topic_name"]}
                          className="create-question-select-box"
                          selectBoxcallBack={this.selectBoxTopicHandleChange}
                          defaultId={this.state.topicDefaultId}
                          selectBoxDisabled={controlEnable}
                          ///bug-tracker#156
                          style={{
                            visibility: this.state.showTopicsSelectBox
                              ? "visible"
                              : "hidden",
                          }}
                        />
                      </Cell>
                      <Cell size={this.state.isQuestionWithPreview ? 6 : 3}>
                        <br />
                        <SelectBox
                          labeltxt="Category"
                          columns={this.state.categories}
                          keys={["category_id", "category_name"]}
                          className="create-question-select-box"
                          selectBoxcallBack={this.selectBoxCategoryHandleChange}
                          defaultId={this.state.categoryDefaultId}
                          ///bug-tracker#156
                          style={{
                            visibility: this.state.showCategorySelectBox
                              ? "visible"
                              : "hidden",
                          }}
                          selectBoxDisabled={controlEnable}
                        />
                      </Cell>
                      <Cell size={this.state.isQuestionWithPreview ? 4 : 3}>
                        <br />
                        <SelectBox
                          labeltxt="SubCategory"
                          columns={this.state.subCategories}
                          keys={["subcategory_id", "subcategory_name"]}
                          className="create-question-select-box"
                          selectBoxcallBack={
                            this.selectBoxSubcategoryHandleChange
                          }
                          defaultId={this.state.subCategoryDefaultId}
                          ///bug-tracker#156
                          style={{
                            visibility: this.state.showSubCategorySelectBox
                              ? "visible"
                              : "hidden",
                          }}
                          selectBoxDisabled={controlEnable}
                        />
                      </Cell>
                    </Grid>
                  </div>
                ) : (
                  ""
                )}
                <div>
                  <Grid>
                    <Cell size={3}>
                      <label style={styles.questionTextLabel}>
                        <b>Question Text</b>
                      </label>
                      <label style={styles.questionBelowAboveDiv}>
                        <div style={{ display: "none" }}>
                          <input
                            type="radio"
                            name="quesBelow"
                            value="0"
                            checked={
                              this.state.defaultQuestionTextBelowOrAbove === 0
                                ? "checked"
                                : ""
                            }
                            onChange={
                              this.questionTextBelowORAboveImageOnChange
                            }
                          />
                          Below image
                          <input
                            type="radio"
                            name="quesBelow"
                            value="1"
                            checked={
                              this.state.defaultQuestionTextBelowOrAbove === 1
                                ? "checked"
                                : ""
                            }
                            onChange={
                              this.questionTextBelowORAboveImageOnChange
                            }
                          />
                          Above image
                        </div>
                      </label>
                    </Cell>
                    {/*} <Cell size={3}>
                  <input
                    accept="image/*"
                    name="Add Image"
                    className="addImageStyle"
                    type="file"
                    onChange={this.onImageFileSelectQuestion.bind(
                      this,
                      'showDetails'
                    )}
                  />
                </Cell>
                */}
                  </Grid>
                </div>
                <div style={{ width: "100%" }}>
                  <Grid>
                    <Cell size={this.state.isQuestionWithPreview ? 12 : 12}>
                      <div
                        style={
                          this.state.isQuestionWithPreview
                            ? questionTextWidth
                            : paddingZero
                        }
                      >
                        <div>
                          <TextEditor
                            preview={this.state.isQuestionWithPreview}
                            value={this.state.questionTextEditorObj}
                            onChange={this.onQuestionTextChange}
                            name="questionEditor"
                          />
                          <br />
                          {this.state.questionType === 0 ?(
                            <StandardQuestionHelp />
                          ): undefined}
                          {this.state.questionType === 1 ? (
                            <QuestionHelp />
                          ):this.state.questionType === 3 ? (
                            <VectorQuestionHelp />
                          ) : undefined}
                        </div>
                        <div
                          style={
                            this.state.altQueTextVisible
                              ? this.state.isQuestionWithPreview
                                ? { marginLeft: "5%", width: "90%" }
                                : { width: "63%", marginLeft: "5%" }
                              : { display: "none" }
                          }
                        >
                          <table>
                            <tbody>
                              <tr>
                                <td>
                                  <p
                                    style={{
                                      fontSize: "medium",
                                      color: "#960000",
                                    }}
                                  >
                                    <label htmlFor="altQueId">
                                      Title Text and Alternative for all Images
                                      in Question
                                    </label>
                                  </p>
                                </td>
                                <td>
                                  <Button
                                    className="nocqcStyle"
                                    icon
                                    tooltipLabel="Format : Title Text for 1st Image ; Alt text 1st Image ; Title Text for 2nd Image ; Alt text for 2nd Image and so on. Don't use semicolon at the end of the text. Use it only to separate Title Text and Alt."
                                  >
                                    help
                                  </Button>
                                </td>
                              </tr>
                            </tbody>
                          </table>
                          <TextField
                            id="altQueId"
                            style={{ borderStyle: "ridge" }}
                            rows={2}
                            value={this.state.altQuestionTextEditorObj}
                            onChange={this.onAltQuestionTextChange}
                            name="altQuestionEditor"
                          />
                          <br />
                        </div>
                       
                      </div>
                    </Cell>
                  </Grid>
                  <Grid>
                    {/* Main Grid Container for all Settings */}
                    <Cell
                      tabletSize={12}
                      desktopSize={this.state.isQuestionWithPreview ? 3 : 3}
                      phoneSize={12}
                      id="main-control-top-left"
                    >
                      <Grid >
                        <Cell size={6}>
                          <label
                            ref={this.reasoningElementTextEditorRef} // Added this ref here because we need auto scroll when editing RE
                            htmlFor="question-type-dropdown"
                            style={styles.randamizeOrderLable}
                          >
                            <b>Question Type</b>
                            {/* {this.state.questionType} */}
                          </label>
                          <SelectField
                            id="question-type-dropdown"
                            ref="question-type-dropdown"
                            placeholder="Select a Question Type"
                            menuItems={questionTypes}
                            style={styles.selectFields}
                            value={this.state.questionType}
                            onChange={this.onQuestionTypeChange}
                            itemLabel="label"
                          />
                        </Cell>
                        <Cell size={12} style={{ display: "none" }}>
                          <label
                            htmlFor="question-ownership"
                            style={styles.randamizeOrderLable}
                          >
                            <b>Question content owned by</b>
                          </label>
                          <SelectField
                            id="question-ownership"
                            ref="question-ownership"
                            placeholder="Select a Question Ownership"
                            menuItems={questionOwnership}
                            value={this.state.questionOwnership}
                            onChange={this.onQuestionOwnershipChange}
                            itemLabel="label"
                          />
                          {this.state.showOwnershipAttribute ? (
                            <TextField
                              id="ownership-outside-source-attribute"
                              style={{ borderStyle: "ridge" }}
                              rows={4}
                              value={this.state.ownershipAttributeObj}
                              onChange={this.onOwnershipAttributeChange}
                              name="ownership-outside-source-attribute"
                            />
                          ) : (
                            ""
                          )}
                        </Cell>
                      </Grid>
                    </Cell>
                    <Cell
                      tabletSize={12}
                      desktopSize={this.state.isQuestionWithPreview ? 12 : 9}
                      phoneSize={12}
                      id="main-control-top-right"
                    >
                      <Grid>
                        {this.state.questionType === 2 ? (
                          <this.MQTControlButtons />
                        ) : null}
                      </Grid>
                    </Cell>
                    <Cell
                      tabletSize={12}
                      desktopSize={this.state.isQuestionWithPreview ? 12 : 6}
                      phoneSize={12}
                      id="main-control-bottom-left"
                      style={{
                        display: this.state.questionType === 4 ? 'none' : 'block' // hide for reasoning elements
                      }}
                    >
                      <Grid >
                        <Cell size={2}>
                          <label
                            htmlFor="quegradedId"
                            style={styles.randamizeOrderLable}
                          >
                            <b>Question Graded </b>
                          </label>

                          <div style={{ paddingTop: "10px" }}>
                            <Toggle
                              id="quegradedId"
                              ref="QuestionNongraded"
                              disabled={this.state.questionType === 0 && this.state.defaultAnswerType===2 ? true : false}
                              checked={
                                 (this.state.questionType === 0 && this.state.defaultAnswerType===2 ? false :(this.state.questionNonGraded === 1
                                  ? false
                                  : true))
                              }
                              icons={false}
                              width={230}
                              onChange={this.questionNonGradeOnChange}
                            />
                          </div>
                        </Cell>
                        {this.state.questionType === 2 &&
                        !this.state.questionNonGraded ? (
                          <Cell size={2}>
                            <label
                              htmlFor="mqt-mastery-condition"
                              style={styles.randamizeOrderLable}
                            >
                              <b>Mastery Condition</b>
                            </label>

                            <SelectField
                              id="mqt-mastery-conditionn"
                              menuItems={
                                this.state.mqt_questions
                                  ? getMQTMasteryConditionCount({
                                      mqt_questions: this.state.mqt_questions,
                                    })
                                  : []
                              }
                              value={this.state.mqt_mastery_condition}
                              itemLabel="label"
                              itemValue="value"
                              onChange={(value) => {
                                this.setState({ mqt_mastery_condition: value });
                              }}
                            />
                          </Cell>
                        ) : null}
                        {this.state.questionType === 0 ? (
                          <Cell size={2}>
                            <label
                              htmlFor="enableanalyticsId"
                              style={styles.randamizeOrderLable}
                            >
                              <b>Enable Analytics </b>
                            </label>

                            <div style={{ paddingTop: "10px" }}>
                              <Toggle
                                id="enableanalyticsId"
                                ref="QuestionEnableAnalytics"
                                icons={false}
                                width={230}
                                onChange={this.enableAnalyticsOnChange}
                                checked={this.state.enableAnalytics}
                              />
                            </div>
                          </Cell>
                        ) : null}

                        {this.state.questionType === 0 ? (
                          <Cell size={3}>
                            <Tooltipped
                              label={this.helpTextModel.getHelpTextForKey(
                                "Enable Answer Feedback"
                              )}
                              position="top"
                              delay={500}
                            >
                              <label
                                htmlFor="enaclefeedbackId"
                                style={styles.randamizeOrderLable}
                              >
                                <b>Enable Answer Feedback </b>
                              </label>
                            </Tooltipped>

                            <div style={{ paddingTop: "10px" }}>
                              <Toggle
                                id="enaclefeedbackId"
                                ref="QuestionEnableFeedback"
                                icons={false}
                                width={230}
                                onChange={this.enableFeedbackOnChange}
                                checked={this.state.enableFeedback}
                              />
                            </div>
                          </Cell>
                        ) : null}
                        <Cell size={5}>
                          <div
                            style={{
                              fontSize: "14px",
                              color: "rgb(87, 98, 113)",
                              display: this.state.questionType === 2 ? 'none' : 'block'
                            }}
                          >
                            <label>
                              {" "}
                              <b>Answer Type</b>{" "}
                              {/* {this.state.defaultAnswerType} */}
                            </label>
                            <br />
                            <input
                              type="radio"
                              name="answerType"
                              value="0"
                              checked={
                                this.state.defaultAnswerType === 0
                                  ? "checked"
                                  : ""
                              }
                              onChange={this.AnswerTypeOnChange}
                            />
                            {this.state.questionType === 3 ? "Vector Arrow Multiple Choice" : "Multiple choice(Radio)"}
                            <Button
                              className="nocqcStyle"
                              icon
                              tooltipLabel="Only one answer choice allowed. More than one answer may be designated as correct. Any correct answer selected will be scored as correct."
                            >
                              help
                            </Button>
                            <br />
                            <input
                              type="radio"
                              name="answerType"
                              value="1"
                              checked={
                                this.state.defaultAnswerType === 1
                                  ? "checked"
                                  : ""
                              }
                              onChange={this.AnswerTypeOnChange}
                            />
                            
                            {this.state.questionType === 3 ? "Vector Arrow Multiple Select" : "Multiple select(Checkbox)"}
                            <Button
                              className="nocqcStyle"
                              icon
                              tooltipLabel="Multiple answer choices allowed. All correct answers (and only correct answers) must be selected by student for answer to be scored as correct."
                            >
                              help
                            </Button>
                            <br />
                            {this.state.questionType === 1 ? (
                              <React.Fragment>
                                <input
                                  type="radio"
                                  name="answerType"
                                  value="3"
                                  checked={
                                    this.state.defaultAnswerType === 3
                                      ? "checked"
                                      : ""
                                  }
                                  onChange={this.AnswerTypeOnChange}
                                />
                                Free Response(automatic grading)
                                <br />
                              </React.Fragment>
                            ) : null}
                            {this.state.questionType !== 1 ? (
                              <React.Fragment>
                                <input
                                  type="radio"
                                  name="answerType"
                                  value="2"
                                  checked={
                                    this.state.defaultAnswerType === 2
                                      ? "checked"
                                      : ""
                                  }
                                  onChange={this.AnswerTypeOnChange}
                                />
                                {this.state.questionType === 3 ? "Vector Arrow Draw (automatic grading)":"Text Box"}
                                <br />
                                </React.Fragment>):
                                null
                            }
                             {this.state.questionType === 0 ? (
                              <>
                                <React.Fragment>
                                  <input
                                    type="radio"
                                    name="answerType"
                                    value="70"
                                    checked={
                                      this.state.defaultAnswerType === 70
                                        ? "checked"
                                        : ""
                                    }
                                    onChange={this.AnswerTypeOnChange}
                                  />
                                  Vector Arrow Multiple Choice
                                  <Button
                                    className="nocqcStyle"
                                    icon
                                    tooltipLabel="Only one answer choice allowed. More than one answer may be designated as correct. Any correct answer selected will be scored as correct."
                                  >
                                    help
                                  </Button>
                                  <br />
                                </React.Fragment>
                                <React.Fragment>
                                <input
                                  type="radio"
                                  name="answerType"
                                  value="80"
                                  checked={
                                    this.state.defaultAnswerType === 80
                                      ? "checked"
                                      : ""
                                  }
                                  onChange={this.AnswerTypeOnChange}
                                />
                                Vector Arrow Multiple Select
                                <Button
                                  className="nocqcStyle"
                                  icon
                                  tooltipLabel="Multiple answer choices allowed. All correct answers (and only correct answers) must be selected by student for answer to be scored as correct."
                                >
                                  help
                               </Button>
                                <br />
                              </React.Fragment>
                                <React.Fragment>
                                <input
                                  type="radio"
                                  name="answerType"
                                  value="90"
                                  checked={
                                    this.state.defaultAnswerType === 90
                                      ? "checked"
                                      : ""
                                  }
                                  onChange={this.AnswerTypeOnChange}
                                />
                                Vector Arrow Draw (automatic grading)
                                <br />
                              </React.Fragment>
                              </>
                            ) : null}
                                   {/* Vector Arrow Random Param  */}
                                   {this.state.questionType === 3 ? (
                              <React.Fragment>
                              <input
                                type="radio"
                                name="answerType"
                                value="30"
                                checked={
                                  this.state.defaultAnswerType === 30
                                    ? "checked"
                                    : ""
                                }
                                onChange={this.AnswerTypeOnChange}
                              />
                              Standard Multiple Choice
                              <Button
                                className="nocqcStyle"
                                icon
                                tooltipLabel="Only one answer choice allowed. More than one answer may be designated as correct. Any correct answer selected will be scored as correct."
                              >
                              help
                            </Button>
                              <br />
                              <div>
                                <input
                                  type="radio"
                                  name="answerType"
                                  value="40"
                                  checked={
                                    this.state.defaultAnswerType === 40
                                      ? "checked"
                                      : ""
                                  }
                                  onChange={this.AnswerTypeOnChange}
                                />
                                 Standard Multiple Select
                                <Button
                                  className="nocqcStyle"
                                  icon
                                  tooltipLabel="Multiple answer choices allowed. All correct answers (and only correct answers) must be selected by student for answer to be scored as correct."
                                >
                                  help
                                </Button>
                              </div>
                              <div>
                                <input
                                  type="radio"
                                  name="answerType"
                                  value="50"
                                  checked={
                                    this.state.defaultAnswerType === 50
                                      ? "checked"
                                      : ""
                                  }
                                  onChange={this.AnswerTypeOnChange}
                                />
                                Random Parameter Multiple Choice
                                <Button
                                  className="nocqcStyle"
                                  icon
                                  tooltipLabel="Only one answer choice allowed. More than one answer may be designated as correct. Any correct answer selected will be scored as correct."
                                >
                                  help
                                </Button>
                              </div>
                              <div>
                                <input
                                  type="radio"
                                  name="answerType"
                                  value="60"
                                  checked={
                                    this.state.defaultAnswerType === 60
                                      ? "checked"
                                      : ""
                                  }
                                  onChange={this.AnswerTypeOnChange}
                                />
                                Random Parameter Multiple Select
                                <Button
                                  className="nocqcStyle"
                                  icon
                                  tooltipLabel="Multiple answer choices allowed. All correct answers (and only correct answers) must be selected by student for answer to be scored as correct."
                                >
                                  help
                                </Button>
                              </div>
                              <div>
                                  <input
                                  type="radio"
                                  name="answerType"
                                  value="3"
                                  checked={
                                    this.state.defaultAnswerType === 3
                                      ? "checked"
                                      : ""
                                  }
                                  onChange={this.AnswerTypeOnChange}
                                />
                                Ran. Param. Free Response (auto grading)
                                <br />
                              </div>
                              </React.Fragment>
                            ) : null}

                            {
                              this.state.questionType !== 1 && this.state.questionType !== 3 && this.state.questionType !== 0 ?
                                <React.Fragment>
                                  <input
                                  type="radio"
                                  name="answerType"
                                  value="3"
                                  checked={
                                    this.state.defaultAnswerType === 3
                                      ? "checked"
                                      : ""
                                  }
                                  onChange={this.AnswerTypeOnChange}
                                />
                                Free Response(automatic grading)
                                <br />
                              </React.Fragment>:
                              null
                            }
                            
                          </div>
                        </Cell>
                      </Grid>
                    </Cell>
                    <Cell
                      tabletSize={12}
                      desktopSize={this.state.isQuestionWithPreview ? 12 : 6}
                      phoneSize={12}
                      id="main-control-bottom-right"
                    >
                      <Grid
                        style={{
                          display: (this.state.questionType === 2 || this.state.questionType === 4) ? "none" : "",
                          width: "91%"
                        }}
                      >
                        {this.state.defaultAnswerType === 1 || this.state.defaultAnswerType === 40 || this.state.defaultAnswerType === 60 ?
                        <Cell size={5}>
                          <div
                            style={{
                              fontSize: "14px",
                              color: "rgb(87, 98, 113)",
                            }}
                          >
                            <label>
                              {" "}
                              <b>Multiple Select Grading Rule</b>{" "}
                            </label>
                            <br />
                            <input
                              type="radio"
                              name="forCheckBoxQuestion"
                              value="1"
                              checked={
                                this.state.forCheckBoxQuestion === 1
                                  ? "checked"
                                  : ""
                              }
                              onChange={this.forCheckBoxQuestionOnChange}
                            />
                            All
                            <Button
                              className="nocqcStyle"
                              icon
                              tooltipLabel="All correct answers and no incorrect answers must be chosen"
                            >
                              help
                            </Button>
                            <br />
                            <input
                              type="radio"
                              name="forCheckBoxQuestion"
                              value="0"
                              checked={
                                this.state.forCheckBoxQuestion === 0
                                  ? "checked"
                                  : ""
                              }
                              onChange={this.forCheckBoxQuestionOnChange}
                            />
                            Any
                            <Button
                              className="nocqcStyle"
                              icon
                              tooltipLabel="At least one correct answer and no incorrect answers must be chosen"
                            >
                              help
                            </Button>
                            <br />

                          </div>
                          
                        </Cell> 
                        
                        : null}
                        {( this.state.questionType !== 3  && this.state.defaultAnswerType !== 3 )|| (this.state.questionType === 3 && this.state.defaultAnswerType !== 2 && this.state.defaultAnswerType !== 3)? (
                          //Do not show Randomized Order Button and Answer Display Style Options for Randomized Paramaters Question Option with Numerical Option
                          <React.Fragment>
                            <Cell size={2}>
                              <label
                                htmlFor="randomizeansorderId"
                                style={styles.randamizeOrderLable}
                              >
                                <b>Randomize Answer Order</b>
                              </label>

                              <div style={{ paddingTop: "10px" }}>
                                <Toggle
                                  id="randomizeansorderId"
                                  ref="randomizeOrderToggle"
                                  checked={
                                    this.state.defaultRandamizeOrder === 0
                                      ? false
                                      : true
                                  }
                                  icons={false}
                                  width={230}
                                  onChange={this.randomizeOrderOnChange}
                                />
                              </div>
                            </Cell>
                            <Cell size={2}>
                              <Button
                                flat
                                primary
                                swapTheming
                                onClick={this.AddAnswerHandler}
                                style={{ height: "auto" }}
                              >
                                Add Answer
                              </Button>
                            </Cell>
                            <Cell size={3}>
                              <SelectionControlGroup
                                id="selection-control-group-radios"
                                name="answer-display-style"
                                type="radio"
                                className="answer-display-style-radio"
                                label="Answer Display style"
                                value={this.state.answerDisplayStyle.toString()}
                                controls={[
                                  {
                                    label: "One Column",
                                    value: "1",
                                  },
                                  {
                                    label: "Two Column",
                                    value: "2",
                                  },
                                ]}
                                onChange={this.onDisplayStyleChange}
                              />
                            </Cell>
                          </React.Fragment>
                          ) :  ((this.state.questionType !== 3 && this.state.defaultAnswerType !== 2) ||
                        (this.state.questionType === 3 && this.state.defaultAnswerType === 3)) ?(
                          <Cell size={4}>
                            {
                              
                            //Note: Reused the Answer Display Style Option state,to avoid creating a new sql column,
                            // this won't have any issue,since Answer Display style is not used in Text Type answer anyway.
                           }
                          <SelectionControlGroup
                            id="selection-control-group-radios"
                            name="answer-display-style"
                            type="radio"
                            className="answer-display-style-radio"
                            label="Answer Format"
                            value={this.state.answerDisplayStyle.toString()}
                            controls={this.state.questionType === 3 && this.state.defaultAnswerType === 3 ? baseControlsForVectorRP :baseControls}
                            onChange={this.onDisplayStyleChange}
                          />
                          {/* {this.state.answerDisplayStyle} */}
                        </Cell>
                          ): (this.state.questionType === 3 && this.state.defaultAnswerType === 2) ?
                          <Cell size={4}>
                            <label
                            style={styles.randamizeOrderLable} >
                              <b>Choose Components </b>
                            </label>
                            <div style={{fontSize: '14px', color: "rgb(87, 98, 113)"}}>
                            <input 
                              type="checkbox"
                              name="Show Components"
                              style={{marginRight: '5px'}}
                              checked={this.state.showComponents}
                              onChange={(event) => this.OnComponentShowChange(event, 'showComponents') }
                              /> 
                             Show Components
                            </div>
                           
                            <div style={{fontSize: '14px', color: "rgb(87, 98, 113)"}}>
                             <input 
                               type="checkbox"
                               name="Show Magnitude-Angle"
                               style={{marginRight: '5px'}}
                               checked={this.state.showMagnitudeAngle}
                               onChange={(event) => this.OnComponentShowChange(event, 'showMagnitudeAngle') }
                               />
                               Show Magnitude-Angle
                            </div>
                            <div style={{fontSize: '14px', color: "rgb(87, 98, 113)"}}>
                             <input 
                               type="checkbox"
                               name="Show Magnitude-Angle"
                               style={{marginRight: '5px'}}
                               checked={this.state.showVectorPrompt}
                               onChange={(event) => this.OnComponentShowChange(event, 'showVectorPrompt') }
                               />
                               Enable Question Vectors Prompt
                               <Button
                                className="nocqcStyle"
                                icon
                                  tooltipLabel="Allow student to show/hide the question vector in their answer canvas."
                                >
                                help
                              </Button>
                            </div>
                          </Cell>

                          :null
                        }
                        {
                          (this.state.questionType === 0 && [70,80,90].includes(this.state.defaultAnswerType)) ?
                          
                            <React.Fragment>
                              <VectorCanvasSettings
                                settings={this.state.vectorSettingsData}
                                onChange={this.onVectorGridSettingsChanged}
                              />
                          
                            </React.Fragment> :""
                        }
                      </Grid>
                    </Cell>
                  </Grid>
                </div>
                <Grid>
                  <Cell size={this.state.isQuestionWithPreview ? 12 : 12}>
                  {/* Randomized Parameters Variable Table */}
                  {this.state.questionType === 1 ? (
                            <VariablesTable
                              style={{ width: "120%", overflowX: "scroll" }}
                              preview={this.state.isQuestionWithPreview}
                              data={this.state.variablesMap}
                              onUploadFile={this.getFileContents}
                              onTableRowChange={this.onVariableTableRowChange}
                              answerDisplayOptions={
                                this.state.answerDisplayOptions
                              }
                              showDecimalOption={this.state.showDecimalOption}
                              className="variable-table"
                            />
                          ) : this.state.questionType === 3 ? (
                            <React.Fragment>
                              <VectorCanvasSettings
                                settings={this.state.vectorSettingsData}
                                onChange={this.onVectorGridSettingsChanged}
                              />
                              <VectorVariablesTable
                                style={{ width: "120%", overflowX: "scroll" }}
                                preview={this.state.isQuestionWithPreview}
                                data={this.state.vectorVariablesMap}
                                onUploadFile={this.getFileContents}
                                onTableRowChange={this.onVariableTableRowChange}
                                answerDisplayOptions={
                                  this.state.answerDisplayOptions
                                }
                                showDecimalOption={this.state.showDecimalOption}
                              />
                              <div style={
                                this.state.isQuestionWithPreview
                                ? questionTextWidth
                                  : paddingZero,{marginTop: '20px'}
                                }>
                            <label style={styles.questionTextLabel}>
                                <b>Vector Below Question Text</b>
                              </label>
                                <div  style={{marginTop:'25px'}}>
                                <TextEditor
                                preview={this.state.isQuestionWithPreview}
                                value={this.state.vectorBelowGridTextEditorObj}
                                onChange={this.onBelowVectorQuestion}
                                name="questionEditor"
                                />
                                </div>
                              <br />
                            </div>
                            </React.Fragment>
                          ) : undefined}
                  </Cell>
                </Grid>
                {/* Reasoning Chain Question UI */}
                <div style={{
                  display: this.state.questionType === 4 ? 'flex' : 'none',
                  justifyContent:'center',
                  flexDirection:'column'
                }}>

                <div style={{display:"flex", justifyContent:'flex-start'}}>
                    {/* <Checkbox
                        id="radomized-order-of-elements"
                        name="simple-checkboxes[]"
                        label="Randomized order of elements"
                      />
                    <Checkbox
                        id="stack-by-category"
                        name="simple-checkboxes[]"
                        label="Stack by Category"
                      /> */}
                  </div>

                    <div className="reasoning-chain">
                      
                        <div style={{display:'flex', justifyContent:'flex-start', marginTop:'12px'}}>
                          <div style={{display:'flex', justifyContent:'center'}}>
                            <div>
                              <Toggle
                                id="hide-cat-info"
                                checked={this.state.showReasoningElementCategoryInfo}
                                icons={false}
                                width={230}
                                onChange={() => this.setState({showReasoningElementCategoryInfo : !this.state.showReasoningElementCategoryInfo})}
                                className="nongradedClass"
                                name="hide-cat-info"
                              />
                            </div>

                          <p className="testTimePara">
                            <label for="hide-cat-info">
                              Show Category Info
                            </label>
                            <Button className='nocqcStyle' icon data-tip data-for='hide-cat-info'>help</Button>
                            <ReactTooltip id='hide-cat-info' type='light' className='tool-tip tooltip-width' place='right' >
                              <span>{"If enabled, students can view the category name"}</span>
                            </ReactTooltip>
                          </p>
                        </div>
                        </div>
                      <ExpansionList className="md-cell md-cell--12">

                        {/* Reasoning Elements */}
                        <ExpansionPanel defaultExpanded label={
                          <div className="expansion-heading">Reasoning Elements</div>
                        } footer={null}>
                          {/* <Button primary raised>Upload</Button> */}
                          <div>

                            <div>
                              <TextEditor 
                                className="RTWrapper element-text-editor"
                                key={"reasoning-elements"}
                                placeholder="Enter your reasoning element..." 
                                value={this.state.reasoningElementEditorState} 
                                onChange={(editorState) => {

                                  let enteredString = TextEditor.getHTMLStringFromEditorState(
                                    editorState
                                  );

                                  var imgTagCount = enteredString.split("<img ").length - 1;
                                  console.debug("imgTagCount", imgTagCount)
                                  if (imgTagCount > 0) {
                                    this.setState({
                                      altReasoningElementVisible: true,
                                      altReasoningElementImgTagCount: imgTagCount,
                                    });
                                  } else {
                                    this.setState({
                                      altReasoningElementVisible: false,
                                    });
                                  }

                                  this.setState({
                                    reasoningElementEditorState: editorState,
                                  })
                                }}
                              />
                            </div>
                            
                            {/* RE - alt text field */}
                            <div
                              style={{
                                display: this.state.altReasoningElementVisible === true ? "block" : "none"
                              }}
                            >
                              <table>
                                <tbody>
                                  <tr>
                                    <td>
                                      <p
                                        style={{
                                          fontSize: "medium",
                                          color: "#960000",
                                        }}
                                      >
                                        <label htmlFor="altQueId">
                                          Title Text and Alternative for all Images
                                          in Reasoning Element
                                        </label>
                                      </p>
                                    </td>
                                    <td>
                                      <Button
                                        className="nocqcStyle"
                                        icon
                                        tooltipLabel="Format : Title Text for 1st Image ; Alt text 1st Image ; Title Text for 2nd Image ; Alt text for 2nd Image and so on. Don't use semicolon at the end of the text. Use it only to separate Title Text and Alt."
                                      >
                                        help
                                      </Button>
                                    </td>
                                  </tr>
                                </tbody>
                              </table>
                              <TextField
                                id="altREId"
                                style={{ borderStyle: "ridge" }}
                                rows={2}
                                value={this.state.altReasoningElementText}
                                onChange={(val) => {
                                  this.setState({
                                    altReasoningElementText: val,
                                  })
                                }}
                                name="altQuestionEditor"
                              />
                              <br />
                            </div>
                            
                          
                            <TextField
                                id={`reasoning-elements-category`}
                                label="Category"
                                lineDirection="center"
                                value={this.state.reasoningElementCategoryText}
                                placeholder="Enter category name"
                                onChange={(value) => {
                                  this.onChangeReasoningElement(this.state.selectedReasoningElementIndex, value, "category");
                                }}
                              />
                          <Button primary raised style={{ marginTop: '12px' }} onClick={this.handleAddReasoningElement}>
                            {this.state.selectedReasoningElementIndex > -1 ? "Update this Reasoning Element to the Question" : "Add this Reasoning Element to the Question"}
                            </Button>
                            {this.state.selectedReasoningElementIndex > -1 ? 
                              <Button style={{marginLeft:'4px'}} flat primary onClick={() => {
                                this.setState({
                                  reasoningElementEditorState: EditorState.createWithContent(ContentState.createFromText('')),
                                  reasoningElementCategoryText: "",
                                  selectedReasoningElementIndex: -1,
                                  altReasoningElementText: "",
                                })
                              }}>
                                Cancel
                              </Button> 
                            : null}
                          </div>
                          <div className="reasoning-elements">
                            <DataTable 
                              noDataComponent="No Reasoning Elements have been added to the question"
                              columns={[
                                {
                                  name: 'Code',
                                  selector: 'code',
                                  sortable: true,
                                  width: "100px",
                                  /* cell: (_, rowIndex) => {
                                    return <div style={{width:"fit-content"}}>
                                      R{rowIndex}
                                    </div>
                                  } */
                                },
                                {
                                  name: 'Reasoning Element',
                                  selector: 'element',
                                  sortable: true,
                                  // width: "90%",
                                  cell: (row) => {
                                    return <MathJax
                                        className="re-mathjax-text"
                                        math={row.element}
                                      />
                                  }
                                },
                                {
                                  name: 'Category',
                                  selector: 'category',
                                  width: "200px",
                                  sortable: true,
                                },
                                {
                                  name: 'Actions',
                                  selector: '',
                                  width: "140px",
                                  cell: (row, rowIndex) => {
                                    return <div>
                                      <Button icon tooltipLabel="Edit" tooltipPosition="top" onClick={() => {
                                        this.handleEditReasoningElement(rowIndex)
                                      }}>
                                        <img src={editIcon} alt="Edit"  />
                                      </Button>

                                      <Button icon tooltipLabel="Remove" tooltipPosition="top" onClick={() => {
                                        this.handleRemoveReasoningElement(rowIndex)
                                      }}>
                                        <img src={crossIcon} alt="Remove"  />
                                      </Button>
                                    </div>
                                  }
                                },
                              ]}
                              data={this.state.reasoningElements ? this.state.reasoningElements: []}
                              selectableRows={false}
                              onSelectedRowsChange={() => {}}
                              customStyles={customStyles}
                              />
                            {/* {this.state.reasoningElements?.map((ele, i) => {
                              // let map =  MathParserUtil.getVariablesFromText(ele.element);
                              return <div className="reasoning-element" key={i}>
                                <div className="reasoning-element-val" onClick={() => {
                                  this.handleEditReasoningElement(i)
                                }}>
                                    <MathJax
                                      math={ele.element}
                                    />
                                  <Chip label={ele.category} style={{background:'#007AFF', fontSize:'12px'}} labelStyle={{color:'#fff'}} />
                                  
                                </div>

                                <div className="reasoning-element-actions">
                                  <Button icon tooltipLabel="Edit" onClick={() => {
                                    this.handleEditReasoningElement(i)
                                  }}>
                                    <img src={editIcon} alt="Edit"  />
                                  </Button>

                                  <Button icon tooltipLabel="Remove" onClick={() => {
                                    this.handleRemoveReasoningElement(i)
                                  }}>
                                    <img src={crossIcon} alt="Remove"  />
                                  </Button>
                                </div>
                              </div>
                            })} */}

                          </div>
                        </ExpansionPanel>

                        {/* Connecting Words */}
                        <ExpansionPanel defaultExpanded label={
                            <div className="expansion-heading"
                            ref={this.conclusionTextEditorRef} // Added this ref here because we need auto scroll when editing CS
                            >Connecting Words</div>
                          } footer={null}>
                            {/* <Button primary raised>Upload</Button> */}
                            <div>
                              <TextField 
                                id="connectingwords"
                                label="Connecting Words"
                                placeholder="Enter some connecting words..."
                                value={this.state.connectingWordText}
                                onChange={(value) => {
                                  this.setState({
                                    connectingWordText: value,
                                  })
                                }}
                              />
                              <Button primary raised style={{ marginTop: '12px' }} onClick={this.handleAddConnectingWords}>
                                Add this Connecting word to the question
                              </Button>
                            </div>
                            {this.state.connectingWords && this.state.connectingWords.length === 0 ? 
                                <div className="w-100 mt-2">
                                  <center>No Connecting words have been added to the question</center>
                                </div>
                            : 
                            <div style={{
                              display: 'flex',
                              justifyContent: 'flex-start',
                              flexWrap: "wrap",
                              width: "100%",
                              paddingBottom: "1rem",
                              marginTop: '1rem',
                              gap: '12px'
                            }}>
                              {this.state.connectingWords?.map((ele, index) => {
                                return <Chip label={ele.word} removable onClick={() => {
                                  this.handleRemoveConnectingWords(index)
                                }} />
                              })}
                            </div>
                            }
                        </ExpansionPanel>

                        <div style={{display:'flex', justifyContent:'flex-start', marginTop:'12px'}}>
                          <div style={{display:'flex', justifyContent:'center'}}>
                            <div>
                              <Toggle
                                id="conclusion-required"
                                checked={this.state.isConclusionSentenceRequired}
                                icons={false}
                                width={230}
                                onChange={() => this.setState({isConclusionSentenceRequired : !this.state.isConclusionSentenceRequired})}
                                className="nongradedClass"
                                name="conclusion-required"
                              />
                            </div>

                            <p className="testTimePara">
                              <label for="conclusion-required">
                                Conclusion Required
                              </label>
                              <Button className='nocqcStyle' icon data-tip data-for='allow_practice'>help</Button>
                              <ReactTooltip id='allow_practice' type='light' className='tool-tip tooltip-width' place='right' >
                                <span>{"If enabled, students are forced to pick atleast one conlusion sentence"}</span>
                              </ReactTooltip>
                            </p>
                        </div>
                        </div>
                        {/* Conclusions Words */}
                        <ExpansionPanel defaultExpanded label={
                          <div className="expansion-heading">Conclusions</div>
                        } footer={null}>
                            <div>
                              <TextEditor 
                                className="RTWrapper element-text-editor"
                                key={"conclusion-sentences"}
                                placeholder="Enter your conclusion sentence..." 
                                value={this.state.conclusionEditorState} 
                                onChange={(editorState) => {

                                  let enteredString = TextEditor.getHTMLStringFromEditorState(
                                    editorState
                                  );

                                  var imgTagCount = enteredString.split("<img ").length - 1;
                                  console.debug("imgTagCount", imgTagCount)
                                  if (imgTagCount > 0) {
                                    this.setState({
                                      altConclusionSentenceVisible: true,
                                      altConclusionSentenceImgTagCount: imgTagCount,
                                    });
                                  } else {
                                    this.setState({
                                      altConclusionSentenceVisible: false,
                                    });
                                  }

                                  this.setState({
                                    conclusionEditorState: editorState,
                                  })
                                }}
                              />
                            </div>
                            {/* Conclusion alt text */}
                            <div
                              style={{
                                display: this.state.altConclusionSentenceVisible === true ? "block" : "none"
                              }}
                            >
                              <table>
                                <tbody>
                                  <tr>
                                    <td>
                                      <p
                                        style={{
                                          fontSize: "medium",
                                          color: "#960000",
                                        }}
                                      >
                                        <label htmlFor="altQueId">
                                          Title Text and Alternative for all Images
                                          in Conclusion
                                        </label>
                                      </p>
                                    </td>
                                    <td>
                                      <Button
                                        className="nocqcStyle"
                                        icon
                                        tooltipLabel="Format : Title Text for 1st Image ; Alt text 1st Image ; Title Text for 2nd Image ; Alt text for 2nd Image and so on. Don't use semicolon at the end of the text. Use it only to separate Title Text and Alt."
                                      >
                                        help
                                      </Button>
                                    </td>
                                  </tr>
                                </tbody>
                              </table>
                              <TextField
                                id="altCId"
                                style={{ borderStyle: "ridge" }}
                                rows={2}
                                value={this.state.altConclusionSentenceText}
                                onChange={(val) => {
                                  console.debug("val", val)
                                  this.setState({
                                    altConclusionSentenceText: val,
                                  })
                                }}
                                name="altCEditor"
                              />
                              <br />
                            </div>
                          
                          <div>
                            <Button primary raised style={{ marginTop: '12px' }} onClick={this.handleAddconclusionSentences}>
                              {this.state.selectedConclusionIndex > -1 ? "Update this Conclusion to the question" : "Add this Conclusion to the question"}
                            </Button>
                              {this.state.selectedConclusionIndex > -1 ? 
                                <Button style={{marginLeft:'4px'}} flat primary onClick={() => {
                                  this.setState({
                                    conclusionEditorState: EditorState.createWithContent(ContentState.createFromText('')),
                                    conclusionWordText: "",
                                    selectedConclusionIndex: -1,
                                    altConclusionSentenceText: "",
                                  })
                                }}>
                                  Cancel
                                </Button> 
                              : null}
                          </div>
                          <div style={{marginTop:"10px"}}>
                            <DataTable 
                              noDataComponent="No Conclusions have been added to the question"
                                columns={[
                                  {
                                    name: 'Code',
                                    selector: 'code',
                                    sortable: true,
                                    width: "100px",
                                   /*  cell: (_, rowIndex) => {
                                      return <div style={{width:"fit-content"}}>
                                        C{rowIndex}
                                      </div>
                                    } */
                                  },
                                  {
                                    name: 'Conclusion Sentence',
                                    selector: 'sentence',
                                    sortable: true,
                                    // width: "90%",
                                    cell: (row) => {
                                      return <MathJax
                                          className="re-mathjax-text"
                                          math={row.sentence}
                                        />
                                    }
                                  },
                                  {
                                    name: 'Actions',
                                    selector: '',
                                    width: "140px",
                                    cell: (row, rowIndex) => {
                                      return <div>
                                        <Button icon tooltipLabel="Edit" tooltipPosition="top" onClick={() => {
                                          this.handleEditConclusionSentence(rowIndex)
                                        }}>
                                          <img src={editIcon} alt="Edit"  />
                                        </Button>

                                        <Button icon tooltipLabel="Remove" tooltipPosition="top" onClick={() => {
                                          // this.handleRemoveReasoningElement(rowIndex)
                                          this.handleRemoveConclusionSentences(rowIndex)
                                        }}>
                                          <img src={crossIcon} alt="Remove"  />
                                        </Button>
                                      </div>
                                    }
                                  },
                                ]}
                                data={this.state.conclusionSentences ? this.state.conclusionSentences: []}
                                selectableRows={false}
                                onSelectedRowsChange={() => {}}
                                customStyles={customStyles}
                                />
                          </div>

                        </ExpansionPanel>
                      </ExpansionList>
                    </div>

                </div>
                
                <div
                  style={
                    this.state.isQuestionWithPreview
                      ? questionWithPreviewWidthStyle
                      : questionWithOutPreviewStyle
                  }
                >
                  {/*Answers list div*/}
                  <br />
                  {/* In the create question window, move the red box “delete answer” button to the left so that it does not overlap into the live preview window and stays in the “Answer” portion of the page.*/}
                  {this.state.questionType === 2 ? (
                    <this.MQTQuestionContainer />
                  ) : (
                      // <this.AnswerListUI />
                      this.AnswerListUI()

                  )}
                </div>
              </div>

              <div
                style={
                  this.state.isQuestionWithPreview
                    ? questionWithPreviewSaveBtn
                    : questionWithOutPreviewStyle
                }
              >
                <div style={floatFooter}>
                  <center>
                    {/* bug id 145  fixes*/}
                    {loadingSave ? (
                      <LoadingSpinner cls="" />
                    ) : this.props.readOnly ? null : (
                      <this.FooterUI />
                    )}
                  </center>
                </div>
              </div>
            </div>
          </div>
        </fieldset>
      </form>
    );
  }

  //UI Elements are Defined Here to Reduce Clutter in Render Function

  //Answer List Element
  AnswerListUI = () => {
    if (this.state.questionType === 3) {
      let defaultAnswerType = this.state.defaultAnswerType;
      let questionType = this.state.questionType;
      if ([30, 40].includes(defaultAnswerType) ) {
          return this.state.answerList.map(function(answerlist, index) {
              return {
                ...answerlist,
                props: {
                  ...answerlist.props,
                  defaultAnswerType: defaultAnswerType,
                }
              };
            })
      }
/*       if (defaultAnswerType === 3) {
        return <TextAnswerFormula
        className="answer-formula-box"
        answer_formula={this.state.answer_formula}
        onChange={this.onAnswerFormulaChange}
        variablesMap={this.state.variablesMap}
        caseSensitive={this.state.isCaseSensitive}
        changeCaseSensitive={this.changeCaseSensitive}
        selected={this.state.shouldAnswerAllorAny}
        answerFormat={this.state.answerDisplayStyle}
        answerType={this.state.defaultAnswerType}
        changeShouldAnswerAllorAny={this.onChangeAnswerAllorAny}
        questionType={questionType}
      />
      } */
    }

    console.debug("AnswerListUI called", this.state.questionType, this.state.defaultAnswerType, this.state.vectorAnswerFormulas)

    return (
      <Grid style={{ float: "left", width: "97%" }}>
        {/* {this.state.answerList} */}

      {this.state.questionType !== 4 && this.state.defaultAnswerType !== 3 && this.state.defaultAnswerType !== 2 
      && !(this.state.questionType === 0 && [90].includes(this.state.defaultAnswerType)  )
      ? (
        this.state.answerList.map(function(answerlist, index) {
          return answerlist;
        })
      ) : (this.state.questionType === 1 || (this.state.questionType === 3 && this.state.defaultAnswerType === 3))  ? (
        <TextAnswerFormula
          className="answer-formula-box"
          answer_formula={this.state.answer_formula}
          onChange={this.onAnswerFormulaChange}
          variablesMap={this.state.variablesMap}
          caseSensitive={this.state.isCaseSensitive}
          changeCaseSensitive={this.changeCaseSensitive}
          selected={this.state.shouldAnswerAllorAny}
          answerFormat={this.state.answerDisplayStyle}
          answerType={this.state.defaultAnswerType}
          questionType={this.state.questionType}
          defaultAnswerType={this.state.defaultAnswerType}
          changeShouldAnswerAllorAny={this.onChangeAnswerAllorAny}
        />
      ) :this.state.questionType === 3 && this.state.defaultAnswerType === 2 ? (
        <VectorAnswers _vectorAnswers={
          this.state.vectorAnswerFormulas
        }
        onValueChange = {
          (value) => {
           this.setState({vectorAnswerFormulas:value})
          }
        }
        />
        // <VectorAnswerFormula
        //       data={{
        //         ...this.state.vectorAnswerFormula,
        //         name:'answer',
        //       }}
        //       onValueChange={(value) =>{
        //         this.setState({
        //           vectorAnswerFormula:{...value},
        //         })
        //       }
        //       }
        //     />
      ): (this.state.questionType === 0 && [90].includes(this.state.defaultAnswerType)) ? (
        
        <DrawVectorAnswers _vectorAnswers={
          this.state.vectorAnswerFormulas
        }
        onValueChange = {
          (value) => {
           this.setState({vectorAnswerFormulas:value})
          }
        }
        />
      ) : (
        ""
      )}

        <ImageResizeWarning />
        <br />
        <center>
          {
            !this.appProperties.enableLTI ?
              <div
                style={this.props.currSubject ? { display: "none" } : {}}
                className="image-resize-warning"
              >
                <p>
                  <b>Note :</b> Contact Administrator to gain access to edit this
                  page.
                </p>
              </div> : " "
          }
          
        </center>
      </Grid>
    );
  };
  //Footer UI
  FooterUI = () => (
    <div>
{(!this.appProperties.enableLTI) ? 
      <div>
      <Button
        style={this.props.currSubject ? {} : { display: "none" }}
        flat
        primary
        swapTheming
        onClick={
          this.state.copyMode
            ? () => this.copyQuestion(false)
            : () =>
                this.addQuestion(
                  this.props.copyMode == 1 ? this.state.copyModeQID: this.props.selectedQuestionId,
                  this.state.subjectId,
                  this.state.topicId,
                  this.state.categoryId,
                  this.state.subcategoryId,
                  false
                )
        }
      >
        Save
      </Button>
      &nbsp;&nbsp;&nbsp;
      <Button
        style={
          this.props.currSubject
            ? { backgroundColor: "green", color: "white" }
            : { display: "none" }
        }
        flat
        swapTheming
        onClick={
          this.state.copyMode
            ? () => this.copyQuestion(true)
            : () =>
                this.addQuestion(
                  this.props.copyMode == 1 ? this.state.copyModeQID : this.props.selectedQuestionId,
                  this.state.subjectId,
                  this.state.topicId,
                  this.state.categoryId,
                  this.state.subcategoryId,
                  true
                )
        }
      >
        Save & Close
      </Button>
      &nbsp;&nbsp;&nbsp;
      <Button flat secondary swapTheming onClick={this.close}>
        Close
      </Button>
    </div>
  :  
     <Button flat secondary swapTheming onClick={this.close}>
     Close
    </Button>
  }
    </div>
    
   
  );

  //Multiple Question Table Format UI
  //MQT - Multiple Question Table
  MQTQuestionContainer = () => (
    <Grid style={{ float: "left", width: "97%" }}>
      <Cell id="mqt-questions-cell" size={this.state.isQuestionWithPreview || !this.state.mqt_answer_header ? 12 : 12}>
      <div style={{  fontSize:'.8em', backgroundColor: 'rgb(150, 0, 0)', width: '100%', textAlign: 'center', color: 'white', paddingBottom: '10px',marginBottom:'50px' }} className='md-btn--text'>Questions</div>
        {
          objectsToArray(Object.values(this.state.mqt_questions)).map((question, i) => {
            return [<div key='mqt-question-container'>
              <label
                            style={styles.randamizeOrderLable}
                          >
                           <b>Question {i + 1} </b>
                </label>
              <Button
                flat
                secondary
                swapTheming
                className="mqt-delete-button"
                onClick={() => this.onMQTQuestionDelete(question.id)}
              >
                Delete Choice
              </Button>

              {this.state.questionNonGraded ? null : (
                <div className="mqt-correct-answer">
                  <label //htmlFor="mqt-answer-header"
                    style={styles.questionTextLabel}
                  >
                    <b>Correct Answer</b>
                  </label>
                  <SelectionControlGroup
                    type={this.state.mqt_answer_type}
                    id={"mqt-correct-answer-checkbox" + question.id}
                    name={"mqt-correct-answer-checkbox" + question.id}
                    controls={
                      this.state.mqt_answers
                        ? getMQTCorrectAnswerArray({
                            mqt_answers: this.state.mqt_answers,
                            mqt_answer_count: this.state.mqt_answer_count,
                            mqt_answer_header: this.state.mqt_answer_header,
                          })
                        : []
                    }
                    value={
                      this.state.mqt_question_answer_map[question.id]
                        ? this.state.mqt_question_answer_map[question.id]
                        : ""
                    }
                    onChange={(value) => {
                      this.onmMQTCorrectAnswerChange(question, value);
                    }}
                  />
                </div>
              )}
              
              <TextEditor className='question-wrapper' style={{ margin: 'auto' }} key={"mqt-question-" + i} value={question.value} onChange={(editorState) => this.onMQRQuestionChange(question, editorState)} />
            </div>,
            <br key="qBR"></br>,
          ];
        })}
      </Cell>
      {
        this.state.mqt_answer_header? (
        <Cell id="mqt-answers-cell" size={this.state.isQuestionWithPreview ? 12 : 12} >
          <div style={{  fontSize:'.8em', backgroundColor: 'rgb(150, 0, 0)', width: '100%', textAlign: 'center', color: 'white', paddingBottom: '10px',marginBottom:'50px' }} className='md-btn--text'>Answers</div>
          {
            objectsToArray(Object.values(this.state.mqt_answers)).map((answer, i) => {
              return [<div>
                
                <label
                            style={styles.randamizeOrderLable}
                          >
                           <b>Answer {i + 1} </b>
                </label>
                <Button
                  flat
                  secondary
                  swapTheming
                  className="mqt-delete-button"
                  onClick={() => this.onMQTAnswerDelete(answer.id)}
                >
                  Delete Choice
                        </Button>
                <TextEditor className='question-wrapper' style={{ margin: 'auto' }} key={"mqt-answer-" + i} value={answer.value} onChange={(editorState) => this.onMQRAnswerChange(answer, editorState)} />
              </div>,
              <br></br>,
            ];
          })}
        </Cell>
      ) : null}
    </Grid>
  );

  MQTControlButtons = () => [
    <Cell key='answer-type' size={4}>
      <label htmlFor="mqt-answer-type" style={styles.questionTextLabel}>
        <b>Answer Type</b>
      </label>
      <div>
        {/*<SelectionControlGroup
          id="mqt-answer-type"
          value={this.state.mqt_answer_type}
          icons='false'
          onChange={this.onmqt_answer_typeChange}
          name="mqt-answer-type"
          type="radio"
          controls={[{
            label: 'Multiple select(Checkbox)',
            value: 'checkbox',
          }, {
            label: 'Multiple choice(Radio)',
            value: 'radio',
          }]}
        />*/}
        <input
          type="radio"
          name="mqt-answer-type"
          value="radio"
          checked={this.state.mqt_answer_type === "radio" ? "checked" : ""}
          onChange={this.onmqt_answer_typeChange}
        />
        Multiple choice(Radio)
        <Button
          className="nocqcStyle"
          icon
          tooltipLabel="Only one answer choice allowed. More than one answer may be designated as correct. Any correct answer selected will be scored as correct."
        >
          help
        </Button>
        <br />
        <input
          type="radio"
          name="mqt-answer-type"
          value="checkbox"
          checked={this.state.mqt_answer_type === "checkbox" ? "checked" : ""}
          onChange={this.onmqt_answer_typeChange}
        />
        Multiple select(Checkbox)
        <Button
          className="nocqcStyle"
          icon
          tooltipLabel="Multiple answer choices allowed. All correct answers (and only correct answers) must be selected by student for answer to be scored as correct."
        >
          help
        </Button>
      </div>
    </Cell>,
    this.state.mqt_answer_header ?
    <Cell key="mqt-hide-question" size={3}>
    <label htmlFor="mqt-hide-question" style={styles.questionTextLabel}>
      <b>Hide Questions Column</b>
    </label>
    <div>
      <Toggle
        id="mqt-answer-header"
        checked={this.state.mqt_hide_question}
        icons={false}
        onChange={this.onmqt_hide_questionChange}
      />
    </div>
  </Cell> : "",
    <Cell key="mqt-answer-header" size={3}>
      <label htmlFor="mqt-answer-header" style={styles.questionTextLabel}>
        <b>Answer Choice Header</b>
      </label>
      <div>
        <Toggle
          id="mqt-answer-header"
          checked={this.state.mqt_answer_header}
          icons={false}
          onChange={this.onmqt_answer_headerChange}
        />
      </div>
    </Cell>,
    <Cell key="mqt-question-order-1" size={3}>
      <label htmlFor="mqt-question-order" style={styles.questionTextLabel}>
        <b>Randomize Question Order</b>
      </label>
      <div>
        <Toggle
          id="mqt-question-orderr"
          checked={this.state.mqt_question_random_order}
          icons={false}
          onChange={this.onMQTQuestionRandomOrder}
        />
      </div>
    </Cell>,
    <Cell key='mqt-question-order-2' size={3}>
      <label htmlFor="mqt-question-order" style={styles.questionTextLabel}>
        <b>Randomize Answer Order</b>
      </label>
      <div>
        <Toggle
          id="mqt-question-orderr"
          checked={this.state.mqt_answers_random_order}
          icons={false}
          onChange={this.onMQTAnswersRandomOrder}
        />
      </div>
    </Cell>,
    <Cell key='mqt-control-button' size={3}>
    {
      this.state.mqt_answer_header? (
        <Button className='mqt-control-button' flat primary swapTheming onClick={this.addMQTAnswer}>
          Add Answer
        </Button>
      ) : (
        <div>
          <label htmlFor="mqt-answer-count" style={styles.questionTextLabel}>
            <b>Answer Choice Count</b>
          </label>
          <div>
            <SelectField
              id="mqt-answer-choice-dropdown"
              placeholder="Select Number of Choices"
              menuItems={[1, 2, 3, 4, 5, 6, 7]}
              value={this.state.mqt_answer_count}
              onChange={this.onmmqt_answer_countChange}
            />
          </div>
        </div>
      )}
    </Cell>,
    <Cell key="mqt-control-button-1" size={3}>
      <Button
        className="mqt-control-button"
        flat
        primary
        swapTheming
        onClick={this.addMQTQuestion}
      >
        Add Question
      </Button>
    </Cell>,
  ];

  //Live Preview Answer UI
  LivePreviewAnswerUI = () => (
    <div style={styles.previewText}>
      <div style={{ width: "100%" }}>
        <div>
        <Typography variant='h6' fontWeight={'500'} className='d-flex align-items-center mb-1'>
            Answer:
            <div className='sf-image-resize-btn-container'
                style={{
                    display: this.answerContainsAnImage ? 'flex' : 'none'
                }}
            >
                <Tooltip placement="top" arrow title="Magnify all images in all answers">
                    <button className="sf-image-resize-btn" onClick={() => {
                        this.handleAnswerResize("plus")
                    }}>
                        <HiOutlineZoomIn fontSize={25} />
                    </button>
                </Tooltip>
                <Tooltip placement="top" arrow title="Shrink all images within all answers">
                    <button
                        disabled={this.state.answerImageWidth === 200}
                        style={{
                            color: this.state.answerImageWidth === 200 ? 'gray' : '#BA0C2F'
                        }}
                        className="sf-image-resize-btn" onClick={() => {
                            this.handleAnswerResize("minus")
                        }}>
                        <HiOutlineZoomOut fontSize={25} />
                    </button>
                </Tooltip>
            </div>
                                                     
        </Typography>
        { this.state.questionType === 0 && [0,1,30,40,50,60].includes(this.state.defaultAnswerType) ?
        <div className='mb-2'>Select one from the below options:
        </div>  :" "
        }
        <Grid>
        {this.state.questionType === 3 && this.state.defaultAnswerType ===2 || (this.state.questionType === 0 && this.state.defaultAnswerType ===90) ? 
        <VectorFreeFormAnswerLivePreview
              vectorSettings={this.state.vectorSettingsData}
              
              vectorAnswerFormulas={this.state.vectorAnswerFormulas}
              showComponents ={this.state.showComponents}
              showMagnitudeAngle = {this.state.showMagnitudeAngle}
            />
          :
          ""
        } 
          {(this.state.questionType === 0 && [70,80].includes(this.state.defaultAnswerType) ) ? // standard Question with vector question refactor

            this.state.answerArrList.map((answerlist, index) => {
              if (!answerlist) {
                return <tr></tr>;
              }
              let inputType = "radio";
              if (this.state.defaultAnswerType === 0 ||(this.state.questionType === 0 && [70].includes(this.state.defaultAnswerType) ) ) {
                inputType = "radio";
              } else if (this.state.defaultAnswerType === 1 ||(this.state.questionType === 0 && [80].includes(this.state.defaultAnswerType) )) {
                inputType = "Checkbox";
              }
              const vectorVariableMap = VectorParserUtil.buildQuestionVariablesMap(answerlist?.vectorAnswerVariable)
              let vectors
              const vectorSettingsData = this.state.vectorSettingsData;
              const newVectorValues = vectorVariableMap?
              vectorVariableMap?.getVectorsArray(vectorSettingsData.widthUnit, vectorSettingsData.heightUnit, vectorSettingsData.enableIdenticalVector):[];
              return (
                <>

                  {inputType === "radio" ?
                  <Cell key={index + 'Checkbox'}
                    // onClick={() => handleClickContent(cIndex)}
                    className={`w-full h-full`}
                    size={11}
                    onClick={(e) => {
                      if (e.target.closest(".view-vectors-container")) {
                        return; // return if clicked within the '.view-vectors-container' 
                    }
                      e.preventDefault();
                      this.setState({localValue:answerlist.answer_id.toString()})
                      // handleClickContent(cIndex)
                      
                  }}>
                          <div className={`
                                    sf-ans-btn cursor-pointer justify-center
                                        ${(this.state.localValue === answerlist.answer_id.toString()) ? "sf-ans-btn-selected " : " "}
                                `}
                                style={{justifyContent:"center"}}
                                >
                                 <label className='cursor-pointer p-0 m-0 w-100' htmlFor={'radio' + index}>
                                 <div style={{
                                        padding:"15px 0px 0px 15px",
                                        borderRadius:"10px",
                                        backgroundColor:"white",
                                      }}>


                                 <AnswerVector
                                      // vector={[newVector,newVector]}
                                        vector={[...newVectorValues]}
                                        generateRandomOrigin={this.state.generateRandomOrigin}
                                        answerCanvasComponentGuid={GetNewComponentGuid()}
                                        refreshAnswer={this.answerRefreshCallback}
                                        vectorSettingsData={this.state.vectorSettingsData}
                                      />
                                      </div>
                                  </label>
                            </div>
                     
                  </Cell> : inputType === "Checkbox"  ?
                       <Cell key={index + 'Checkbox'}
                       // onClick={() => handleClickContent(cIndex)}
                       className={`w-full h-full`}
                       size={11}
                       onClick={(e) => {
                        if (e.target.closest(".view-vectors-container")) {
                            return; // return if clicked within the '.view-vectors-container' 
                        }
                        e.preventDefault();
                        let newLocalValueArr = [...this.state.localValueArr];
                        if (newLocalValueArr.includes(answerlist.answer_id.toString())) {
                            newLocalValueArr = this.removeElementFromArray(newLocalValueArr, answerlist.answer_id.toString());
                        } else {
                            newLocalValueArr.push(answerlist.answer_id.toString());
                        }
                        this.setState({localValueArr:newLocalValueArr})
                     }}>
                             <div className={`
                                       sf-ans-btn cursor-pointer justify-center
                                       ${this.state.localValueArr.includes(answerlist.answer_id.toString()) ? "sf-ans-btn-selected " : " "}
                                   `}
                                   style={{justifyContent:"center"
                                   }}
                                   >
                                    <label className='cursor-pointer p-0 m-0 w-100' htmlFor={'radio' + index}>
                                      <div style={{
                                        padding:"15px 0px 0px 15px",
                                        borderRadius:"10px",
                                        backgroundColor:"white",
                                      }}>

                                      <AnswerVector
                                          // vector={[newVector,newVector]}
                                            vector={[...newVectorValues]}
                                            generateRandomOrigin={this.state.generateRandomOrigin}
                                            answerCanvasComponentGuid={GetNewComponentGuid()}
                                            refreshAnswer={this.answerRefreshCallback}
                                            vectorSettingsData={this.state.vectorSettingsData}
                                          />
                                      </div>
                                     </label>
                               </div>
                        
                     </Cell>
                     : ""}
                </>
              );
            })

          : this.state.defaultAnswerType !== 2 &&
          this.state.defaultAnswerType !== 3 ? (
            this.state.questionType === 3 && ![30, 40, 50, 60].includes(this.state.defaultAnswerType) ? (
              //Vectors

              this.state.answerArrList.map((answerlist, index) => {
                if (!answerlist) {
                  return <tr></tr>;
                }
                let inputType = "radio";
                if (this.state.defaultAnswerType === 0 ||(this.state.questionType === 0 && [70].includes(this.state.defaultAnswerType) ) ) {
                  inputType = "radio";
                } else if (this.state.defaultAnswerType === 1 ||(this.state.questionType === 0 && [80].includes(this.state.defaultAnswerType) )) {
                  inputType = "Checkbox";
                }
                const vectorAns = VectorParserUtil.generateAnswerVector(
                  answerlist.vectorAnswerFormula,
                  this.state.vectorVariablesMap,
                  "",
                  this.state.vectorSettingsData
                );
                return (
                  <>
                    {inputType === "radio" ?
                      <Cell key={index + 'radio'}
                      // onClick={() => handleClickContent(cIndex)}
                      className={`w-full h-full`}
                      size={this.state.answerDisplayStyle === 2 ? 6 :11}
                      onClick={(e) => {
                        if (e.target.closest(".view-vectors-container")) {
                          return; // return if clicked within the '.view-vectors-container' 
                      }
                        e.preventDefault();
                        if(answerlist.answer_id){
                          this.setState({localValue:answerlist.answer_id?.toString()})
                        }
                        // handleClickContent(cIndex)
                      
                    }}
                      >
                      <div className={`
                              sf-ans-btn cursor-pointer 
                                  ${(this.state.localValue === answerlist.answer_id?.toString()) ? "sf-ans-btn-selected " : " "}
                          `}>
                         <div style={{
                              borderRadius:"10px",
                              backgroundColor:"white",
                            }}>
                              <AnswerVector
                                  vector={vectorAns ? [vectorAns] : []}
                                  generateRandomOrigin={this.state.generateRandomOrigin}
                                  answerCanvasComponentGuid={this.state.answerCanvasComponentGuid}
                                  refreshAnswer={this.answerRefreshCallback}
                                  vectorSettingsData={this.state.vectorSettingsData}
                              />
                            </div>
                      </div>

                  </Cell> : inputType === "Checkbox"  ?
                      <Cell key={index + 'Checkbox'}
                      className={`w-full h-full`}
                      size={this.state.answerDisplayStyle === 2 ? 6 :11}
                      onClick={(e) => {
                        if (e.target.closest(".view-vectors-container")) {
                          return; // return if clicked within the '.view-vectors-container' 
                      }
                        e.preventDefault();
                        if(answerlist.answer_id){
                          let newLocalValueArr = [...this.state.localValueArr];
                          if (newLocalValueArr.includes(answerlist.answer_id?.toString())) {
                              newLocalValueArr = this.removeElementFromArray(newLocalValueArr, answerlist.answer_id?.toString());
                          } else {
                              newLocalValueArr.push(answerlist.answer_id?.toString());
                          }
                          this.setState({localValueArr:newLocalValueArr})
                        }
                    }}
                      >
                      <div className={`
                              sf-ans-btn cursor-pointer 
                            ${this.state.localValueArr.includes(answerlist.answer_id?.toString()) ? "sf-ans-btn-selected " : " "}
                          `}>
                            <div style={{
                              borderRadius:"10px",
                              backgroundColor:"white",
                            }}>
                              <AnswerVector
                                  vector={vectorAns ? [vectorAns] : []}
                                  generateRandomOrigin={this.state.generateRandomOrigin}
                                  answerCanvasComponentGuid={this.state.answerCanvasComponentGuid}
                                  refreshAnswer={this.answerRefreshCallback}
                                  vectorSettingsData={this.state.vectorSettingsData}
                              />
                            </div>
                      </div>

                  </Cell> : ""
                   }
                  </>

                );
              })
            ) : (
              this.state.answerArrList.map((answerlist, index) => {
                //bug-tracker#161
                if (answerlist !== null) {
                  var inputType = "radio";
                  var answerType = "";
                  if (this.state.defaultAnswerType === 0  || this.state.defaultAnswerType === 30 || this.state.defaultAnswerType === 50) {
                    inputType = "radio";
                  } else if (this.state.defaultAnswerType === 1  || this.state.defaultAnswerType === 40 || this.state.defaultAnswerType === 60) {
                    inputType = "Checkbox";
                  }

                  if (this.state.defaultAnswerType === 2 && index === 0) {
                    inputType = "";
                    answerType = (
                      <textarea style={{ width: "490px", height: "100px" }}
                      
                      className='w-100 px-2 py-2'
                      style={{
                          border: "2px solid #A7B1B7",
                          borderRadius: '4px'
                      }}
                      rows={5}
                      type="text"
                      placeholder='Type your answer here'
                      name="selectedAnswer"
                      />
                    );
                    return (
                      <tr>
                         <div className='mb-2'>Fill in the input box:</div>
                        <td>{answerType} </td>
                      </tr>
                    );
                  } else if (this.state.defaultAnswerType !== 2) {
                    answerType = <input type={inputType} name="radio-group"/>;
                    /* console.debug(
                                          'answerlist.answer_text = ',
                                          answerlist.answer_text
                                        ); */
                    let ansText = answerlist.answer_text;
                    if (
                      this.state.questionType === 1 &&
                      this.state.isQuestionWithPreview
                    ) {
                      ansText = MathParserUtil.computeFormula(
                        answerlist.answer_text,
                        this.state.variablesMap,
                        answerlist.answer_display_options
                      );
                    }

                    if (this.state.questionType === 3 && [50, 60].includes(this.state.defaultAnswerType)) {
                      ansText  = MathParserUtil.computeFormula(
                        answerlist.answer_text,
                        this.state.vectorVariablesMap,
                        answerlist.answer_display_options
                      );
                    }

                    var mathJaxValue = (
                      <MathJax
                        math={answerlist.answer_text !== null ? ansText : ""}
                      />
                    );

                    /*bug id 146 Live Preview - Checkbox Text not is straight line*/

                    return answerlist.answer_text !== "" ? (
                      <>
                        {/* <td>{answerType}</td> */}
                           {inputType === "radio" ?
                          <Cell key={index + 'radio'}
                            // onClick={() => handleClickContent(cIndex)}
                            className={`w-full h-full`}
                            size={this.state.answerDisplayStyle === 2 ? 6 :11}
                            onClick={(e) => {
                              e.preventDefault();
                              if(answerlist.answer_id){
                                this.setState({localValue:answerlist.answer_id?.toString()})
                              }
                              // handleClickContent(cIndex)
                             
                          }}
                            >
                            <div className={`
                                    sf-ans-btn cursor-pointer 
                                        ${(this.state.localValue === answerlist.answer_id?.toString()) ? "sf-ans-btn-selected " : " "}
                                `}>
                                 <label className='cursor-pointer p-0 m-0 w-100' htmlFor={'radio' + index}>
                                   {mathJaxValue}
                                   {ansText !== null ? TextEditor.createVideoLinkIframe(ansText):''}
                                  </label>
                            </div>
    
                         </Cell> : inputType === "Checkbox"  ?
                          <Cell key={index + 'Checkbox'}
                          className={`w-full h-full`}
                          size={this.state.answerDisplayStyle === 2 ? 6 :11}
                          onClick={(e) => {
                            e.preventDefault();
                            if(answerlist.answer_id){
                              let newLocalValueArr = [...this.state.localValueArr];
                              if (newLocalValueArr.includes(answerlist.answer_id?.toString())) {
                                  newLocalValueArr = this.removeElementFromArray(newLocalValueArr, answerlist.answer_id?.toString());
                              } else {
                                  newLocalValueArr.push(answerlist.answer_id?.toString());
                              }
                              this.setState({localValueArr:newLocalValueArr})
                            }
                        }}
                          >
                          <div className={`
                                  sf-ans-btn cursor-pointer 
                                 ${this.state.localValueArr.includes(answerlist.answer_id?.toString()) ? "sf-ans-btn-selected " : " "}
                              `}>
                              <label className='cursor-pointer p-0 m-0 w-100' htmlFor={'radio' + index}>
                                {mathJaxValue}
                                {ansText !== null ? TextEditor.createVideoLinkIframe(ansText):''}
                                </label>
                          </div>
  
                      </Cell> : ""
                           }
                         
                      </>
                    ) : null;
                  } else {
                    return null;
                  }
                } else {
                  return null;
                }
              })
            )
          ) : this.state.defaultAnswerType === 3 &&
            this.state.answer_formula &&
            this.state.answer_formula.formula ? (
            <tr>
              <td></td>
              <td>
                <RPPreview
                  answer_formula={this.state.answer_formula}
                  answerFormat={this.state.answerDisplayStyle}
                ></RPPreview>
              </td>
            </tr>
          ) : this.state.questionType !== 3 ? (
            <tr>
              <td></td>
              <div>
                <div className='mb-2'>Fill in the input box:</div>
                <textarea
                  className='w-100 px-2 py-2'
                  style={{
                      border: "2px solid #A7B1B7",
                      borderRadius: '4px',
                      width: "390px", height: "100px",
                      marginTop:"10px"
                  }}
                  rows={5}
                  type="text"
                  placeholder='Type your answer here'
                  name="selectedAnswer"
                />
              </div>
            </tr>
          ):<tr>
          <td></td></tr>}
        </Grid>
        </div>
      </div>
    </div>
  );
  //MQT Live Preview
  MQTLivePreviewUI = () => {};
}

const AnswerVector = ({ vector, vectorSettingsData,refreshAnswer, answerCanvasComponentGuid, generateRandomOrigin }) => {
  const canvasRef = useRef(null);

  useEffect(() => {
    if (canvasRef && canvasRef.current && vector && generateRandomOrigin)
    {
      canvasRef.current.drawVectors({ vectors: [...vector] });
    }
  }, [canvasRef, vector]);

  useEffect(() => {
    setTimeout(() => {
      refreshAnswer();
    }, 500);
  }, []);

  // console.log(`Point 0 ::: Before Rendering Grid Settings Data => `, vectorSettingsData);

  if(vectorSettingsData){
    return (
      <Canvas
        ref={canvasRef}
        readOnly={true}
        degStepSize={5}
        magStepSize={1}
        ComponentGuid={answerCanvasComponentGuid}
        magStepSize={1}
        rulerXPoint={vectorSettingsData.rulerXPoint}
        rulerYPoint={vectorSettingsData.rulerYPoint}
        rulerXLabel={vectorSettingsData.rulerXLabel}
        rulerYLabel={vectorSettingsData.rulerYLabel}
        rulerNXLabel={vectorSettingsData.rulerNXLabel}
        rulerNYLabel={vectorSettingsData.rulerNYLabel}
        height={vectorSettingsData.height}
        width={vectorSettingsData.width}
        stepSize={vectorSettingsData.stepSize}
        enableGrid={vectorSettingsData.enableGrid}
        enableBorder={vectorSettingsData.enableBorder}
        enableDarkGridLine={vectorSettingsData.enableDarkGridLine}
        enableRuler={vectorSettingsData.enableRuler}
        gridColor={vectorSettingsData.gridColor}
        stepDeg={true}
        freeBodyDiagram={vector && vector.showImage?vectorSettingsData.image:null}
        fbdWidth={vectorSettingsData.imageWidth}
        fbdHeight={vectorSettingsData.imageHeight}
        fbdX={vectorSettingsData.imageX}
        fbdY={vectorSettingsData.imageY}
        commonVectorSettings={vectorSettingsData}
      ></Canvas>
    );
  }
  else
    return null;
};
